import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/tech-academy-apac/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const FeatureCard = makeShortcode("FeatureCard");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <FeatureCard title="Agile Integration Best Practices Using an IBM GitOps Automation Framework" color="dark" mdxType="FeatureCard">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "42.01388888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARASEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAIABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAEF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAwAC/9oADAMBAAIQAxAAAAHPgoUWv//EABcQAQEBAQAAAAAAAAAAAAAAAAIBABH/2gAIAQEAAQUCtqyJm6Dv/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAESQf/aAAgBAwEBPwFPCD//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwFX/8QAGRAAAgMBAAAAAAAAAAAAAAAAABEBEjFh/9oACAEBAAY/ArSuGCP/xAAbEAEAAgIDAAAAAAAAAAAAAAABEQAhMUFxof/aAAgBAQABPyEolSbZvGgferCFsM4m/wD/2gAMAwEAAgADAAAAEIgP/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARYf/aAAgBAwEBPxBBB2Am63//xAAWEQEBAQAAAAAAAAAAAAAAAAAAASH/2gAIAQIBAT8Quqf/xAAcEAEBAAEFAQAAAAAAAAAAAAABEQAhMUFRcZH/2gAIAQEAAT8QgpSQBXezzABBjaKrh6Zdwgo1n7n/2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "banner",
          "title": "banner",
          "src": "/tech-academy-apac/static/6e9fd17bde28c9bae770d99192d70890/2e753/gitops-banner.jpg",
          "srcSet": ["/tech-academy-apac/static/6e9fd17bde28c9bae770d99192d70890/69549/gitops-banner.jpg 288w", "/tech-academy-apac/static/6e9fd17bde28c9bae770d99192d70890/473e3/gitops-banner.jpg 576w", "/tech-academy-apac/static/6e9fd17bde28c9bae770d99192d70890/2e753/gitops-banner.jpg 1152w", "/tech-academy-apac/static/6e9fd17bde28c9bae770d99192d70890/6c77f/gitops-banner.jpg 1195w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </FeatureCard>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Lab Overview</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Prerequisites</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Business Context</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Automation Framework Introduction</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Lab Environment</AnchorLink>
  <AnchorLink mdxType="AnchorLink">0 - Preparation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1 - Clone Repositories</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2 - Explore the Environment</AnchorLink>
  <AnchorLink mdxType="AnchorLink">3 - Prepare the Subscription</AnchorLink>
  <AnchorLink mdxType="AnchorLink">4 - Deploy ACE and ES instances</AnchorLink>
  <AnchorLink mdxType="AnchorLink">5 - Activate MQ Queue Manager</AnchorLink>
  <AnchorLink mdxType="AnchorLink">6 - Customize Event Streams</AnchorLink>
  <AnchorLink mdxType="AnchorLink">7 - Configure ACE</AnchorLink>
  <AnchorLink mdxType="AnchorLink">8 - Customize APIC</AnchorLink>
  <AnchorLink mdxType="AnchorLink">9 - Check the Demo Assets</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Summary</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Lab Overview`}</h2>
    <p>{`Have you received requests to deliver a Multi-style Integration demo or PoC, and you don’t know how to quickly prepare this environment? You are on the right place. In this session,  you will learn how to prepare a demo/PoC environment using GitOps automation framework. This environment will include different assets, capabilities, services and applications of IBM Cloud Pak for Integration.`}</p>
    <p>{`The first main goal of this session is to provide you a complete CP4I environment with multiple demo assets to be ready to progress your sales opportunity. This first goal is achieved by reusing a `}<a href="https://github.ibm.com/joel-gomez/cp4i-demo" target="_blank">{`multi-style integration demo assets`}</a>{`.`}</p>
    <p>{`The second goal is to provide this environment quickly and easily, by using the GitOps automation framework, more details `}<a href="https://production-gitops.dev/" target="_blank">{`here`}</a>{` about Cloud Pak Production Deployment Guides.`}</p>
    <p>{`This document was created for Senior Technical Specialists, and we know you are one of them. Because of that, instead to have very detailled steps, we have high level directions about what you need to do. There are some challenges that we don’t explain how to do them, but we are pretty sure that you can do it! But let the proctors know if you have any issue to complete the challenges.`}</p>
    <p>{`In this session you will learn:`}</p>
    <ul>
      <li parentName="ul">{`the IBM opinionated point of view regarding a GitOps centric method to manage RHOCP infrastructure, IBM integration software and application workload code (three tier GitOps architecture).`}</li>
      <li parentName="ul">{`how to develop, review, and extend an IBM GitOps automation repository that incapsulate key software components within the IBM Integration portfolio.`}</li>
      <li parentName="ul">{`how to position a GitOps automation framework as a key boot-strapping and operational mechanism supporting a Client PoC activity and Client adoption.`}</li>
    </ul>
    <hr></hr>
    <h2>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`You need to have an OpenShift environment with GitOps operators. For this session, your proctor will provide you a pre-installed environment, with admin access (more details below). If you want to create your personal environment, check this `}<a href="https://www.youtube.com/watch?v=SmDE80vuP3w" target="_blank">{`video`}</a>{` or follow the preparation section from this `}<a href="https://github.com/sko-master/multi-tenancy-gitops/blob/master/doc/sko-scenario.md" target="_blank">{`documentation`}</a>{`.`}</li>
      <li parentName="ul">{`You need to have installed in your machine:`}
        <ul parentName="li">
          <li parentName="ul">
            <a href="https://docs.openshift.com/container-platform/4.8/cli_reference/openshift_cli/getting-started-cli.html" target="_blank">oc CLI</a> v4.6+.
          </li>
          <li parentName="ul">{`github CLI`}</li>
          <li parentName="ul">{`Bash Shell`}</li>
          <li parentName="ul">{`JAVA v8+`}</li>
          <li parentName="ul">
            <a href="https://stedolan.github.io/jq/" target="_blank">jq CLI</a>
          </li>
        </ul>
      </li>
      <li parentName="ul">{`You need to have a SalesForce account. This should have been completed as part of the `}<a href="https://ibm-garage-tsa.github.io/cp4i-demohub/salesdemos/carrepair-new/prepare/#setting-up-salesforce" target="_blank">{`Tech Academy pre-requisite work`}</a>{`.`}</li>
      <li parentName="ul">{`You need to have a mailtrap account. This too should have been completed as part of the `}<a href="https://mailtrap.io/" target="_blank">{`Tech Academy pre-requisite work`}</a>{`.`}</li>
      <li parentName="ul">{`You have access to GitHub Organization with all repositories. Your proctor will provide that for you.`}</li>
      <li parentName="ul">{`You need to have your GitHub Personal Access Token. Check `}<a href="https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/creating-a-personal-access-token" target="_blank">{`here`}</a>{` how to create it.`}</li>
    </ul>
    <hr></hr>
    <h2>{`Business Context`}</h2>
    <p>{`This document describes multiple use cases that highlight the multi-style integration patterns needed by an Integration Specialist to implement a digital transformation initiative that showcase the value Cloud Pak for Integration can provide.`}</p>
    <p>{`In this case a customer has a system of record that has used for many years which ws designed to work with MQ to process requirements, and now they want to extend the application to expose an API in a asecure way as part of their mobile app.`}</p>
    <p>{`But the requirement doesn’t end there, they are also implementing a new CRM system as a Service and they want to keep both systems in sync without having to modify the original system of record.`}</p>
    <p>{`Additionally as part of their digital transformation initiative they want to stay closer to their clients and they want to send email notifications when the client is taking certain actions in their mobile app. To support this strategy, the enterprise architecture team wants to implement an event backbone, as part of their event driven architecture.`}</p>
    <p>{`The following diagram provides a high level view of the scenario:
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACkElEQVQoz22S3UtTcRjHz17Unb2cvbhNUzfn5oZCubmpLQXtxsBZUsmGWeBFZGUFXgTe9BdEZF1kN90IUVh0EQSRiWgimRciSXmRRCoKFVnpMtDs0znHfAm6+PJ7fr/f8zzf7/MiuN1uvF4vBQUFeDwe9Ho9giCg0+nUU4FGo1HvoijSdPoCNke2+lZeXo7JZNr2U+Hz+aipqSEej1NWVkYoFNr+dLlceGQyvV6nElktFuINxzBaJGxWK21tbWqcVqslLy9vS8ROduVDEDRYrDZu9/TQPzDA8NAgz/oHqK2tRTCYt31NJiNKdYpCh8NBXV3dplqbzaaWa5UZVedMM05fKXOzH1hchemFdd7OQ+uJFgTRjNdfTEaGgUgkTjKVorDQJ6vLx+XOwWiSCQOBANFoVGUxGAwo98rKSiYmZ/gNzH1aY102WlJHESx2OTAbySQn3Bem63InpSE/es2uHpaUlKi9M5vNGOWmi2Yb9vwgDYkEqWQzqZOnOHOxk3D1YaSiKmIHj1NaUY8ltxR7QZhsbwSXL6rCHdi/2UO/rEqSNkvWZxllZ//OhEWrnCiGP9GLs6qH8ub7Mvo40PqIWPKBaseSD3HEblLd8RLBbrcTkccfDAbR6nTqREVDFk6nk+JgiLxcF8G9VXjOzuLp+E5O+xKBS0vktm8i1rWE5/xXfOc+UnHlG4KyT7v3bctW+lpff0i1M+1F9A4vMbUAozMbPJ9a4+7wKvdGVhmaXmf03Qbj739xZ2T937XZDWUtpL+TVxI+HvvMi9erjL75wdyXDQYn0zwdX2Fetp+MLTM4sUzfqzUESZL4H5SdMsowiZnsCYRpvLpIY/dPGq6t0Hg9TdONNIld55HuNM23VvgDQEmDpncrenYAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "CP4I MultiStyle DemoScenario",
          "title": "CP4I MultiStyle DemoScenario",
          "src": "/tech-academy-apac/static/598c4ca36b0e293e16510a83830579b4/3cbba/CP4I_MultiStyle_DemoScenario.png",
          "srcSet": ["/tech-academy-apac/static/598c4ca36b0e293e16510a83830579b4/7fc1e/CP4I_MultiStyle_DemoScenario.png 288w", "/tech-academy-apac/static/598c4ca36b0e293e16510a83830579b4/a5df1/CP4I_MultiStyle_DemoScenario.png 576w", "/tech-academy-apac/static/598c4ca36b0e293e16510a83830579b4/3cbba/CP4I_MultiStyle_DemoScenario.png 1152w", "/tech-academy-apac/static/598c4ca36b0e293e16510a83830579b4/7ea17/CP4I_MultiStyle_DemoScenario.png 1420w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`In order to implement this demo you will need to deploy an instance of each one of the following components in your OCP Cluster:`}</p>
    <ul>
      <li parentName="ul">{`API Connect Cluster`}</li>
      <li parentName="ul">{`Event Streams Cluster`}</li>
      <li parentName="ul">{`Queue Manager`}</li>
      <li parentName="ul">{`App Connect Enterprise Integration Servers`}</li>
    </ul>
    <p>{`The following diagram provides a high level implementation view of the scenario with the core capabilities:
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACQUlEQVQoz3WSzWsTURTF8xe59g8QBDfiouKmC9241KUIIuhCammxohWkxRZXARG0paUGq22SpqmNzXx/NDOpMR8zk0mDlbTLn++9mFJFF+fdx5u5555778kUCgVWV1fJ5XKsrKxQLpfRdR3DMPB9nzRN6Xa7pAKdKMUO+7RFTNOuepdIkuT0nqnVapimieu6WKYh7gaapmGIN8/ziONYIUliGs2IshHRaMVEUaQgyc4i0+v16Pf7HB72uDF/wsWpE2zXpx54qogsJtXalonthcxmPTZKNt/qvvju0Wq1kBwSSqFsSRKmacT5Bz85d/eI7YpFvqSzVzVE+xq7uxWh3iT79hPTc0UKOx7liovtOIqw2WwRBIHqJKNpOsViHtOLGXt6zO3FAR+KPhOvPEpfLBxbjEGvqFFcvf6YO/ees1YIeTRvU/m6R7NxwMbndRYWFjk4OCCzuZln6f07nP2Ey9MDrj07obznk9/2MCypwmX5o862IJ+ZfcPc4jKaWWN9S8zcsvDDNmEjESq/D2coj57cZJpwYWLA+Owxa3mXhy9NdioOpu0y9dpnKWdwaew+N289IbdVVwq1apWSFmEERxz25La7knC4btn/+IsfXJkZoJsOnlNFOkCqCGsOQc0XLQXU6wH7vks99JQLoo5cym/rjBQOfZQIn8U020M7mKZFNptVhFGc0G53BNoqdjqd0zjM76p8pfBvc0oDSwvI5MnJSaVSumD037/wh7EdsXopfVTprEnDMFSjGCX9D2dJfwFJ5AMENCcQNwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "CP4I MultiStyle HighLevelView",
          "title": "CP4I MultiStyle HighLevelView",
          "src": "/tech-academy-apac/static/547d04df9baa90fb6ffd67d28dca1303/3cbba/CP4I_MultiStyle_HighLevelView.png",
          "srcSet": ["/tech-academy-apac/static/547d04df9baa90fb6ffd67d28dca1303/7fc1e/CP4I_MultiStyle_HighLevelView.png 288w", "/tech-academy-apac/static/547d04df9baa90fb6ffd67d28dca1303/a5df1/CP4I_MultiStyle_HighLevelView.png 576w", "/tech-academy-apac/static/547d04df9baa90fb6ffd67d28dca1303/3cbba/CP4I_MultiStyle_HighLevelView.png 1152w", "/tech-academy-apac/static/547d04df9baa90fb6ffd67d28dca1303/0b124/CP4I_MultiStyle_HighLevelView.png 1728w", "/tech-academy-apac/static/547d04df9baa90fb6ffd67d28dca1303/e957c/CP4I_MultiStyle_HighLevelView.png 1920w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`To demonstrate the added value capabilities provided by CP4I you will deploy an instance of the following components in your OCP Cluster:`}</p>
    <ul>
      <li parentName="ul">{`Platform UI (formerly known as Platform Navigator)`}</li>
      <li parentName="ul">{`Automation Foundation Assets (formerly known as Asset Repository)`}</li>
      <li parentName="ul">{`Operations Dashboard`}</li>
    </ul>
    <hr></hr>
    <h2>{`Automation Framework Introduction`}</h2>
    <h3>{`What are the Production Deployment Guides?`}</h3>
    <p>{`The `}<a href="https://production-gitops.dev/" target="_blank">{`Cloud Pak Production Deployment Guides`}</a>{` document and demonstrate how to design, deploy and operate cloud-native solutions leveraging IBM Cloud Pak capabilities in Red Hat OpenShift environments. The guides focus on Production level qualities of services such as High Availability, Security and Performance including how to design, install and manage your Cluster in the popular managed and unmanaged Cloud environments as well as tackling disconnected or air-gapped environments.`}</p>
    <h3>{`Production Deployment Guide objectives`}</h3>
    <p>{`There are a number of objectives behind providing the Production Deployment Guides. The three main goals of the Guides are provided below:`}</p>
    <ul>
      <li parentName="ul">{`Provide opinionated, validated Production topologies`}</li>
      <li parentName="ul">{`Provide a GitOps driven automation framework`}</li>
      <li parentName="ul">{`Enable IBMers to setup Production topologies`}</li>
    </ul>
    <h3>{`What is GitOps?`}</h3>
    <p>{`GitOps requires us to describe the entire system declaratively in Git where the desired system state is versioned, managed and applied by software agents.`}</p>
    <p>{`Automation is key for scale in the Cloud world and OpenShift and Cloud Paks are no different. The implementation code and artifacts provided along with these guides are based on a GitOps approach where infrastructure and everything deployed in to an OpenShift Cluster (including Cloud Paks) is described as code and is managed in the same way that application code would be.`}</p>
    <p>{`More information on the gitops structure can be read in this `}<a href="https://production-gitops.dev/gitops/structure/" target="_blank">{`page`}</a>{`.`}</p>
    <hr></hr>
    <h2>{`Lab Environment`}</h2>
    <p>{`For this session you will use a ROKS 4.8 environment with 5 nodes (b3c.16x64). Following this video, you can have a personal environment for you, including GitOps operator and configuration. But for this section, your lab proctors pre-installed this cluster for you. They already installed GitOps, created an empty GitHub Organization and forked the automation repositories that you will use, for this empty organization (check the video to see the steps already completed).`}</p>
    <p>{`Because of time restrictions, the proctors already installed some core services of Cloud Pak for Integration, avoiding you to wait almost 90 minutes to complete this installation. In the previous sections, you will check what are installed in this environment.`}</p>
    <hr></hr>
    <h2>{`0 - Preparation`}</h2>
    <p>{`In this section you will do some initial steps to prepare your environment for the lab, including accept the Account Invitation in IBM Cloud, access your cluster web console and by command line interface. Let’s start it!`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Log in `}<a href="https://cloud.ibm.com/" target="_blank">{`IBM Cloud`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open the `}<strong parentName="p">{`Notifications`}</strong>{` page (click on top right ring bell icon).`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "70.83333333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACcElEQVQ4y4VSS2sTURSen9Q/oBVEak3TaKW4cKEbEYRSQbGCFtwILkV05UJL/4G6FP0BXbixdtI0D1ObTJLJZN73zvPznBPTKlid4ePce797vvO6Rq1Ww+rqKpaXl7G4eImweIylpQqYr1arwp+gipWVK6jRulKp4OrlGm6fP4f1tTUYcRyj1+uh3W5jNBohDEP4vo8gCMT+DZZNvO/h45cQ97Y01rdSfPrcQdRtwEgSjclkgiAMkKYaWZaSnSLLsj8wO0tSWpP1owyWk6PnlgicAO7eVxhKxXi+fYRbD9q4s3aI7TdjKBWCM4+iSOB5nlg+kwpoHwQ+0kRBRZ4g0UoSM7SOcffJd5xZMLEw38LTjSG63RZ2d7+RPYTjODBNE81mE8PhEP1+n7hddDodETfNOvb2TGqXDdd1STCJ8HDzBy7MN3Ht7BFebbqwbUscLMuSntXrdezv74s4i3KAg4MD6XO32xWe58B3jSSN8ei+hYtzh7g+Z+P1BpWmfInm+9PBtFqtYwfLGoggD5FbwYKNRkN4pRQLKrx9aePxzT6e3Rjj/QsPtjOUEjgDLmswGEgAXntkec8c99S27V+vY7qnHmqJNB6P5SBNE5lknufH052tU5purHO5xwPgjJljRIq4mDLMspwIDzk9l9O+kv7ZV9ByNn0OInxZIi9AJWsYU/UcoSrpbZVCnoaiKOipaARRipGXwwkKTMKSbAk/Lk8EJ2GBgVsgiAtyLMTxNHiRD0Vt0klGNqEkCsmO6+BgIuiTUJ7/OzsGO4X6pNTfmxLpEhNfTQU5snTqP4JZzmVTv0hwdsaJsO+7nQIfdmL8BNXc+TrelC6jAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "gitops 0 1",
        "title": "gitops 0 1",
        "src": "/tech-academy-apac/static/33584a9e453a85b3e4166418ecc21413/3cbba/gitops-0-1.png",
        "srcSet": ["/tech-academy-apac/static/33584a9e453a85b3e4166418ecc21413/7fc1e/gitops-0-1.png 288w", "/tech-academy-apac/static/33584a9e453a85b3e4166418ecc21413/a5df1/gitops-0-1.png 576w", "/tech-academy-apac/static/33584a9e453a85b3e4166418ecc21413/3cbba/gitops-0-1.png 1152w", "/tech-academy-apac/static/33584a9e453a85b3e4166418ecc21413/0b124/gitops-0-1.png 1728w", "/tech-academy-apac/static/33584a9e453a85b3e4166418ecc21413/4ea69/gitops-0-1.png 2304w", "/tech-academy-apac/static/33584a9e453a85b3e4166418ecc21413/b8a32/gitops-0-1.png 2522w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`On the Notifications page, you should have an `}<strong parentName="li">{`Account`}</strong>{` notification informing you that “You are invited to join an account in IBM Cloud”. Select this notification and click the `}<strong parentName="li">{`Join now`}</strong>{` link.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "70.83333333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACOUlEQVQ4y3VTW24TQRD0xRAiEor8Cov54xdxFC7AV8Ql+OUGCIggRiROiAnYZh073oe9M/t+FF1jr1kLMVK5e6d7arqrxy3LsjAYDNDpdNBut9Hr9dDtdg36/T4YP8RTnDyxcGI9w6PjAR4c9fHwsYWjY8ucbZVlCd/3sV6vkaYJuKqq2tsm5AdpViEvKlzZJV6clnj5psLz1xVevQWiKEQrSRLkeb5HmmVI0hTcz8RvIo5jk8NVFCWitESYFNBRJufED4VQaW2clARCRBvLd8Q9fgtIRktCdmPbNlarFXzPhVYBQq2kgBhKKSF0Hfz8fIbF9RV+nX/B9ccPuDn7hOnwHPZ4DM9fw/M83N/fG0sEm41ckO2lqZeW4lrK9/B7dIn5zXeDycU3TC4vsBB/OZvBJUEQ7HXeiB+L1lqHpnIjk1RfFMWWkO3qKJak1GAjZQcSyESjMIpMmxwc5SjELqYzjIdfMb39AXs+x0wuXUr1mjwk5A8riOWwFjK25AuoITUhYT2QTKq4G99iMhwhclYyPO5HKIv8b8s1IaeqakJpjwSM0TJWEzsyDGd5JwXEhiyMM5l0JdVDhtMgZHJNSK0oxUbE535NSK2Yw1U/sywvRaoKZdUg5EEeYLLruvsKHfGbT4aW+f+u7bRVTUiwinCnG59FGGoDahsJGKMlafPf1PTjiM9mV5XjOMYa+NrA2UGp7aXM5cUk4ORrVIJU5rJYqS0hWz5AoA7AnP8hkHiRKrwfhTh9p/EHNiQL8pBGdSsAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "gitops 0 2",
        "title": "gitops 0 2",
        "src": "/tech-academy-apac/static/f2ef38824fe541404e2c9112f37a4954/3cbba/gitops-0-2.png",
        "srcSet": ["/tech-academy-apac/static/f2ef38824fe541404e2c9112f37a4954/7fc1e/gitops-0-2.png 288w", "/tech-academy-apac/static/f2ef38824fe541404e2c9112f37a4954/a5df1/gitops-0-2.png 576w", "/tech-academy-apac/static/f2ef38824fe541404e2c9112f37a4954/3cbba/gitops-0-2.png 1152w", "/tech-academy-apac/static/f2ef38824fe541404e2c9112f37a4954/0b124/gitops-0-2.png 1728w", "/tech-academy-apac/static/f2ef38824fe541404e2c9112f37a4954/4ea69/gitops-0-2.png 2304w", "/tech-academy-apac/static/f2ef38824fe541404e2c9112f37a4954/b8a32/gitops-0-2.png 2522w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">
        <p parentName="li">{`Follow the steps to accept the invitation.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Now back to the IBM Cloud dashboard, change your IBM Cloud account to `}<strong parentName="p">{`2543884 - itztsglenablement05`}</strong>{`.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "70.83333333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACrUlEQVQ4y41TS08TURTurzCBxJqyAeoLIaGJCsQFVPoQoWpUjBpXGqJgYgJoiCtdGxJXJiYm+gM0/gD3rFxAZFGkUCjttJ33687M/Tj3FmuIQZ3ky5k595zvnPOdO7FcLscKhQITNp1OH8L4+DjL5/Msk8mwbDYrYwSGh4bYYCrFLqRSwWhvd5Ts6WFjY6NsZmaGxWzbRrlcRrFYRLVahWEY0HW9DU3T2hDfjUYDVAydHR1IJLpwvPMYTg7m8e27CUtXEPN9n2uaym3b5EHg8TAMyP4Jxhidhdx1XT5VKPDeZJL3Dwzw+Ik4z00UuGEHXNc1HnNdB8ufdvFwcROP57bx8UMTtm3ANC2I7h3HgWVZ0lJx2eXkxBUku7vRd+Y0EvE4rk1N0plLU+iQhLMvN3Ex/QNjwxt4NV9DaauIjY2fqFQqUFUV6+vrWFtdRaPZxO7WFq5fGsH5U0mM9J1Ff1cCt7MZ7FX2pCwxz7OxsFTG6EgRN4Z38HZJQ3lnkwjWpLaiu1KpJMkt6lglDZ/PPsGDWzfx6P49TE9excLTORkrCRlz8OLZHi6f28Z0Xx3v5m001RoF7MgFiFFFoGmaktymb4X8Sr0Blfw1RaH3ujwnfWkpzMX75ToW71bw+k4dX97oRKgQWRMW6ShIxPabNK5IMkhDpVaT+npEoJK/LgkNWZxG9lrXgSo6dkt42uoh0HYJARi9O14oyUQBkfcrxnbpzKEOAwoW7GHI8D9PxNHefhCEB16OKAKN7CEmqltOAMvl1AEH50cjoqyAJjBthpoWomlGUC1OlsNw+G9C1YpQ1SKYTkSJkUw8CjrdUZdk8vyArE9NUJGo1SXzDwgNIqKf4K/dCYgki66Z0Ozww+H4HJrhtghFZen+B2FIYTSAXFLbF3KZ+3klwtcVB/vqC8e7dElkoAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "gitops 0 3",
        "title": "gitops 0 3",
        "src": "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/3cbba/gitops-0-3.png",
        "srcSet": ["/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/7fc1e/gitops-0-3.png 288w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/a5df1/gitops-0-3.png 576w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/3cbba/gitops-0-3.png 1152w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/0b124/gitops-0-3.png 1728w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/4ea69/gitops-0-3.png 2304w", "/tech-academy-apac/static/3fae56861c204833ffbdfc4963553a2d/b8a32/gitops-0-3.png 2522w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">
        <p parentName="li">{`Now, click `}<a href="/tech-academy-apac/environments/" target="_blank">{`here`}</a>{` to open the `}<strong parentName="p">{`Team Environments`}</strong>{` page.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open your Team’s section (A) (check the number of your team with the Lab’s proctors). Take notes of your Team’s Github organization name (B), you will use it in next section. Then, open your team’s `}<strong parentName="p">{`Cluster page`}</strong>{` (C).`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.66666666666666%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABhElEQVQ4y41T226CQBTkW+tD1ZgatD4YX/wS/8f3NkZaqchNwv0u1+kuBYMViZtMzgl7zuzM7oFZLpegWK1WWK/XeF8sMBwMMBq8YDoaYjp8reIbjeMx2NkMLMveYD6fYzKZYLPZgMnzHFEU4brSFNJ+B+0oILUdXPwAqeMg8z1kjo0yuaAkZWVZXluaPMsyMKKk4CQIMHQdXhAgsEycPj+w332D25/wdTBx5M8wRBHO8QduXed5XicY03JgWRZ830cYhhXOwhFn/gBTlqCLMgxJhSlJsFWlqvMJIY0BFVCD9tm2DQatVRQFQmJfUVVYxG58SRDGUY0YAdlrCB4SUv8N6H3SDVkmqgy9yitFLTxNSFdDqCgKTNO8ErYbG7IuQnp1d4T0xf8UGqQouiPrU+i6brdCTdOq09pqutB10A1hUeRVoUhGhNruIwzq0Wny5nunZYmMiK7rD+/wv2Wap+SHiMkkdFpWydj0PUqbkEZKxHFc1ffUK/fZpjFJEmy3W/A8j19WeMnFPDOjBwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "team cluster",
        "title": "team cluster",
        "src": "/tech-academy-apac/static/08e66a2942eea5e70ba987c5e064d030/3cbba/team-cluster.png",
        "srcSet": ["/tech-academy-apac/static/08e66a2942eea5e70ba987c5e064d030/7fc1e/team-cluster.png 288w", "/tech-academy-apac/static/08e66a2942eea5e70ba987c5e064d030/a5df1/team-cluster.png 576w", "/tech-academy-apac/static/08e66a2942eea5e70ba987c5e064d030/3cbba/team-cluster.png 1152w", "/tech-academy-apac/static/08e66a2942eea5e70ba987c5e064d030/b485f/team-cluster.png 1302w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`On your cluster’s page, click `}<strong parentName="li">{`OpenShift web console`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "66.66666666666666%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACN0lEQVQ4y3WTy27TQBSG84qIZQlCCFoFK0qySB6CDYuIDQsknoAtqwooEkrKbVUESRoualI7deLb2HOLf86ZxBYV9EhHnrFnvvOfixveIw/dbg+e56HdbmMwGKDf72PQ3z17va5732614N2+Be9uE807R2g2Wzg4OML9e4fodDp4+OAQw+EQjWx5icD3Ea5DBEGA9XpN6zVikaAoCnKJsiyx3W6hhUA0X+D5iws8eRbg8VMfJ8c+lDQoNJCkAo3JdI7fP39guVzugSGSJIE2BlJKhGEIQSDDe6VdwCy8gowjJCsfq8XCnbP0fbPZoOH7AeaXl0izDEWewydgJnKwWWuxoCBSKrfPZYGIglWmtEFKZ0tSzxbHMRqsZkkLBuakJMkKKGVciqxKmRKW1tYaaAJoWzo17hvtLbH4LHsURWhwOgV5xkBSmCQxKSrqQ0pJd5mN95LqyjWtMuCsqu9OIYMqZ2Capq4WrJxrw++UUjUwdwBdB+TGVUAWdw0o9krTLKV0lEs1JsUiF25tSFGUGqqxJoitlQKlW3OwGsjK2I2k6NLgJtMEsnanjlNmsCgsNYye4i9gQjBNsNH3T3j54RVOzsd4Mxvh7Wzs/HjyHl/96U5PrWxnu8bgX4WShngyO8PpdISPBHn9bYTT8y94dzbCePYZv9YXe8BOXVXHyq8BqxoKmvY8ETemzA0yWtd/D4OrEvwXyEoFd5aaUmgaE/JtuXe6xH/OarVyk8Bzx6PCE8Hd5vt/ADBYyb7nDYQqAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "openshift console",
        "title": "openshift console",
        "src": "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/3cbba/openshift-console.png",
        "srcSet": ["/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/7fc1e/openshift-console.png 288w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/a5df1/openshift-console.png 576w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/3cbba/openshift-console.png 1152w", "/tech-academy-apac/static/7dbb56dc17771ea07c3394514d12e940/b485f/openshift-console.png 1302w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Great, you are almost ready for the lab. Last but not least important, let’s copy login command to access the cluster by CLI. On the top right, click your `}<strong parentName="li">{`username`}</strong>{` and select `}<strong parentName="li">{`Copy login command`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "77.08333333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC8klEQVQ4y41S2U4TYRSeGCNcGiUsbiBUKEJLSwUtFDDGGy94BkkLJYAQRXkOXsHwACQar018BkOMNqIkpthpZzrT2dfPc/5SCHf+ycmZ9TvfcqSehQUMLS1hcHkZN6lfLxRwNZOBNDmJK+k0urNZdNN9p3dNT6Mrl8M1Kr4eyj/GaGEOifk8EnQtjQ0OYWYsidlMFvf6+lGYmcXu5iZera1hu1wWvVNbq6t4Q+/2trext7OD1+vreL+/jy8fP+Dz4SE+HRxASk5OYYxq+EESN3oHUN7YAh/daOF/TlCvoXb0FUrlB7Tv3yA9ff4C+bkF5OcXkZrKYfftOzRND4puw/c8eFSu68KxHdhUjnNR/FytVvH76Ainxz8h/zqGNL/4DLNP5pDO5DCcGMP6xiZMy4babELXNGhUlmUhCHyEYQDfbw/h8n0ffhgiiGLExNag/6SHk2mMT6Rxf2QUPST55UoRjuujoWqoKypahoEoiuBYPhTZgOcEZ2Jj+I5BTC3YliHU8GCJwUaTE0iMjqNv4A5WiiW4ng9NN4ilTh/ZbU81E9U/deqGkBoSM11ToaoKFKUhGNs2MUxNTYNZjlAo/bfuolhaE9JYbqPREFP52I5NQ5owiLFhmII1d12/CE8wnMrmMJHKXACuronp7A8zCYK2RA6hXq+jSd62Wi0ByO+Y2SVADoNZsmQGLK2WCSyA6RID8ku3A7h+CMvxUddsOHTN/gU01HBC+i6ERv5abtBh+Ojcww4gM7PJO07WJxYhsYkIgJkzq05nFdzZc9PxYJpmm2HyYeoslDagRclpuiZk0d9wWwZsL0AcR3QbnYcSx7GokNbGC6LLofAOtj0khh5Jc3n3QkTsk2kJQJYaEQD7JoadHR4iLCBvJQ6EQZklr02xVAYiktBqolo9hSzXxZJrVIqi0JqoIhiuRkMR20DkYJOH/E6aSGeQzc2K5e7tvy0YBr4LufYXlUoFJycnYn044VqtJrosy6JzMYjw0HLE838dCKbE1x3tNgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "gitops 0 4",
        "title": "gitops 0 4",
        "src": "/tech-academy-apac/static/3275732910f9cd2705338d12a035df98/3cbba/gitops-0-4.png",
        "srcSet": ["/tech-academy-apac/static/3275732910f9cd2705338d12a035df98/7fc1e/gitops-0-4.png 288w", "/tech-academy-apac/static/3275732910f9cd2705338d12a035df98/a5df1/gitops-0-4.png 576w", "/tech-academy-apac/static/3275732910f9cd2705338d12a035df98/3cbba/gitops-0-4.png 1152w", "/tech-academy-apac/static/3275732910f9cd2705338d12a035df98/0b124/gitops-0-4.png 1728w", "/tech-academy-apac/static/3275732910f9cd2705338d12a035df98/4ea69/gitops-0-4.png 2304w", "/tech-academy-apac/static/3275732910f9cd2705338d12a035df98/b9a51/gitops-0-4.png 2372w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Display Token`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "9.375%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVQI12N4eury/693b///+fXL/58/f/7/+eMHhCYTM3z6/O3/l0cP/3++ef3/D5hhFBgKAPS1m0501g19AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "display token",
        "title": "display token",
        "src": "/tech-academy-apac/static/957994fbac60dbcd01c14e87c938f91d/3cbba/display-token.png",
        "srcSet": ["/tech-academy-apac/static/957994fbac60dbcd01c14e87c938f91d/7fc1e/display-token.png 288w", "/tech-academy-apac/static/957994fbac60dbcd01c14e87c938f91d/a5df1/display-token.png 576w", "/tech-academy-apac/static/957994fbac60dbcd01c14e87c938f91d/3cbba/display-token.png 1152w", "/tech-academy-apac/static/957994fbac60dbcd01c14e87c938f91d/b485f/display-token.png 1302w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Copy the `}<strong parentName="li">{`Log in with this token`}</strong>{` command  and paste on a terminal window.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "35.416666666666664%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABI0lEQVQoz23RbW+CMBQFYP7/f5tmmwhOKRRUoC3lvbzFnF0atxj1w5NTDuFCLo4UApxz5FmGwRiYvodZ8xF14zBgHMdXaz9NmObZXju5lOBJgkuaQlcl6rZF03VWS4PWXLtpWbDcbm/NdM+wI8a+g5OFDKfNBj/bLS6HAzQNl2EEyULIIICKIhQ8tikZgwrDB8z2au9Cn07o6UsdQeXxY4Pg8ws+Zfi9Q+R6SFwXZxLvPZz9g31Z6vu4Prl4PjLPQ6VL9GaggVrjyBN4AYfPYkRXgbMokBCeKcS5QpIX1lWVUFUD3bSvqF9X5DSNQSpq5KpGQaXUFURR3bP8P69UWdsH64b2SkMeVaTrDQ2sJ5TFTH9yxrKQ+Sn/znezNb010Q5/AX+3EFYGskzbAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "login cmd",
        "title": "login cmd",
        "src": "/tech-academy-apac/static/c12631ad6b2eb20aa23740170f562cf6/3cbba/login-cmd.png",
        "srcSet": ["/tech-academy-apac/static/c12631ad6b2eb20aa23740170f562cf6/7fc1e/login-cmd.png 288w", "/tech-academy-apac/static/c12631ad6b2eb20aa23740170f562cf6/a5df1/login-cmd.png 576w", "/tech-academy-apac/static/c12631ad6b2eb20aa23740170f562cf6/3cbba/login-cmd.png 1152w", "/tech-academy-apac/static/c12631ad6b2eb20aa23740170f562cf6/b485f/login-cmd.png 1302w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   `}<inlineCode parentName="p">{`Notes`}</inlineCode>{`: You should have received an invitation for the GitHub Organization of your team. Don’t forget to accept it in your Github account email.`}</p>
    <p>{`   That is it! Now you are ready for the lab. Take a breath and enjoy your lab!`}</p>
    <hr></hr>
    <h2>{`1 - Clone Repositories`}</h2>
    <p>{`As explained before, you already have Github repositories for your team. On previous section, you took notes of your GitHub organization’s name. Now that you have the name, let’s clone the repositories in your local machine.`}</p>
    <p>{`To clone the respositories, you need to have your Github personal acccess token. If don’t have it, follow `}<a parentName="p" {...{
        "href": "https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/creating-a-personal-access-token"
      }}>{`these instructions`}</a>{`.`}</p>
    <ol>
      <li parentName="ol">{`Back to the terminal window, use the command below to define your GIT_ORG variable.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`export GIT_ORG={REPLACE_WITH_YOUR_GIT_ORG}
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Now let’s clone the repositories to your local machine.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`mkdir \${GIT_ORG}
cd \${GIT_ORG}
git clone https://github.com/\${GIT_ORG}/multi-tenancy-gitops
git clone https://github.com/\${GIT_ORG}/multi-tenancy-gitops-infra
git clone https://github.com/\${GIT_ORG}/multi-tenancy-gitops-services
git clone https://github.com/\${GIT_ORG}/multi-tenancy-gitops-apps
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`You are welcome to explore all the four repositories of the GitOps Automation framework.`}</li>
    </ol>
    <hr></hr>
    <h2>{`2 - Explore the Environment`}</h2>
    <p>{`Now that you have all the repositories locally, let’s check what have been deployed.`}</p>
    <ol>
      <li parentName="ol">{`Let’s start by exploring the GitOps Automation Framework YAML files. First, let’s check the kustomization.yaml in infra layer (/multi-tenancy-gitops/0-bootstrap/single-cluster/1-infra/).`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`vi multi-tenancy-gitops/0-bootstrap/single-cluster/1-infra/kustomization.yaml

`}</code></pre>
    <p>{`  Check that `}<strong parentName="p">{`tools`}</strong>{` and `}<strong parentName="p">{`ibm-common-services`}</strong>{` are the namespaces enabled. We will explore these namespaces in OpenShift later. Go ahead and close vi.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "49.30555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaUlEQVQoz41S70+CUBTl//8nWmXNtWrzo2WrVVTWYqKA8hsUN7AUMBhqwOk+lh/8kHG3s7t34Z533rmXsw0Drm0jWiwQzueET2Rpiny9Rr7ZVLnIcxRFsRcskiQBpzUbEBqHEI4P0KPcOzmCfHYKo3UBvXUJ67yJ74+gaijLEvuCfecmpgl1MIAqSTCGCixVha1pSKMImzTBOvlCSQq3DX+BRU7/cV4QQCECWdWgWRZ0ev7IMBGQBcX25n/Idgjd7jPk+zsoBI1/hP7EQ+Uf4Lx1ERtaLXU7hHanjWHnCqPrNvTbDuGmwvSFx/z9FQUNpmANtQktE6IgVJBEEQp5OZJlSH0RFvkbkpfl7xRrEfrkoUGNJvnnuC7Gkwm86RTueAyDVsr3faS0RvU9dB30SZnI1ClKBUY0m80Qkbosy1A32D5ynudVBAwmKWXZcZyKMAxDLJfLijiOYyxo8gyszmrbOjuzWK1W+AERxPPdlunVQQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore1",
        "title": "explore1",
        "src": "/tech-academy-apac/static/90ca87f31681398fe6e773707e4df260/3f968/explore1.png",
        "srcSet": ["/tech-academy-apac/static/90ca87f31681398fe6e773707e4df260/7fc1e/explore1.png 288w", "/tech-academy-apac/static/90ca87f31681398fe6e773707e4df260/a5df1/explore1.png 576w", "/tech-academy-apac/static/90ca87f31681398fe6e773707e4df260/3f968/explore1.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Let’s explore the kustomization.yaml in services layer (/multi-tenancy-gitops/0-bootstrap/single-cluster/2-services/)`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`vi multi-tenancy-gitops/0-bootstrap/single-cluster/2-services/kustomization.yaml

`}</code></pre>
    <p>{`  Here you can check that Platform Navigator, Asset Repository, API Connect and others are already installed in your environment. Don’t worry, in next steps you will install other operators and create new instances.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "698px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "49.30555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABt0lEQVQoz4VS/0/aQBzt//8X7BddpkucIDI2ZZLMMLPMIOXLNqVeaUtb0H6LraXASC/tvd3VkrBlzk/y8l6TT17fuzvJsKx05jhIVivGAGyALZ3n+YsQs1wuIYW6Rj2VwB8TFpkTzipi20Ia+Eh9D1kUlu6b3zw/jO9IN/Uj2qm+w/B9jQ3qNXSrh0Jj2DhGv1aB9eW8WBYZMp6ElcaCtyEmyzJI9q2Sjq460L4PmTroQ5G7Qhd825Mx/vkDU10H38P9dIr1ev2soagumbuv6OjNDsjeDlP3X0Pd3xW6gPqWf3M2DvYwOW2AlvX/NvvDcFyv0mHlANe1ChvVjwRzHOLmuFroEWf9pIEVP9Ns/etlQ6XVpJcfP6B31mSD1hnkT6foNk8KFrhun4N8+4pIU7FSFeSL5P+VA0OnE8/HnR+wmR/AvHdgux6EtlwXQRwjWiwgsonKefjw9JzKC9rGU+XPLapctEEu2szsXGLW62IqX+GuL2M+JlgaGhKeLuZ6QRSgrP2vKQxtw0gNfoMTQpitadjAsUw8uA5Czy34kb/JkJ/jI08chiFizgLz+RxRFCFJElBK8RvlG+I9xfPNDAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore2",
        "title": "explore2",
        "src": "/tech-academy-apac/static/2102ee8d8ae9d25a906a558503f34313/bc9df/explore2.png",
        "srcSet": ["/tech-academy-apac/static/2102ee8d8ae9d25a906a558503f34313/7fc1e/explore2.png 288w", "/tech-academy-apac/static/2102ee8d8ae9d25a906a558503f34313/a5df1/explore2.png 576w", "/tech-academy-apac/static/2102ee8d8ae9d25a906a558503f34313/bc9df/explore2.png 698w"],
        "sizes": "(max-width: 698px) 100vw, 698px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Let’s check the installed operators in your Cluster Web Console. You should have the web console page opened, if not, there is a URL available in the Team Environments page.`}</p>
        <p parentName="li">{`On Web Console page, open `}<strong parentName="p">{`Operators`}</strong>{` (A), then `}<strong parentName="p">{`Installed Operators`}</strong>{` (B). Here you can see all the installed operators (C).`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZ0lEQVQozz2SWW/TQBSF/R94KG1V+oBImrpOmrRJo6SUUKG+UEoXUAVCqOL3Ih6QEEIlCW2c2HEcb/E6Xg53pstIRzNjX38+d5Ger6+jWVVQ3qigVCqj2+1gp76N3UYde80m2q2W0MN5r9XEfqeD3sEB6SUOul0c9no4fN3DK3omyUodla0allfXcXrxEfZIxeB3H/0/AxgjDfZYhTMZI5qbcPUJZjdDBDMDoTmDOdZhqLq4L0Y3iGiX5GodG3IVS8trODm9gKObmM4DzJwALM0QRRHiOAZfURLDcmwURSHuhsegzhOkeYGcJWDWHFJFrkFWtgXw+OQMzHEQRgwBKc9zZFkmBGLwPUmSe2ABzU4wmsfIcvESzLYglcndJrlcWnmGd+/PEcwtjGYBVDOkmJzcRQLCV0wOPc+jHxGAoF6Ywo8y5HQu0lSUQTps7GBfVlArVfCWgDk55Cn/010wllLK4WPKHOi4jgByl1GSISTxc0EO/ekU0nG7jaujI7zZbeHr1TfEto3rsY8fAxdOwJAQ7MFhQnVyPfcx5YjlQmIRMDAI2G620W13oVS2cPnpCzIq+lD38evWxSJKkaZc2f03mXApHJFSXhICihrm90C52kBpU8GTpVUc8xqaFoaajxsjoOC7JjDG7hymDAvff+yyQzU0FwxuSA2h2HBGwOr2Dl6UZTGH5x8uqcsu1KkH1XAFKAwITKPDm8Ab5PIaktNcuE2F66LIUVCsr2uQtmoNlCsKnq6s4ezyM9jgGv3vPzH8q8LTNLgTvk/EjHnaGNNhHzF1M6FB1251WJMpEstETEMdmCb+A+ojyqx7Szn4AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore3",
        "title": "explore3",
        "src": "/tech-academy-apac/static/e1b4c432681c9374901be1d3c69f7b15/3cbba/explore3.png",
        "srcSet": ["/tech-academy-apac/static/e1b4c432681c9374901be1d3c69f7b15/7fc1e/explore3.png 288w", "/tech-academy-apac/static/e1b4c432681c9374901be1d3c69f7b15/a5df1/explore3.png 576w", "/tech-academy-apac/static/e1b4c432681c9374901be1d3c69f7b15/3cbba/explore3.png 1152w", "/tech-academy-apac/static/e1b4c432681c9374901be1d3c69f7b15/26482/explore3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Now, let’s open the ArgoCD UI. Let’s get the ArgoCD Admin’s password first. On Web Console page, open `}<strong parentName="li">{`Workloads`}</strong>{` (A) > `}<strong parentName="li">{`Secrets`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACFUlEQVQoz5VSXW8SQRTdP6FJW62tRnELpYChCxT5TjSxFrAaNZr0f/vSqEFZW9hddmd2Zr+Od2aBPvjkJOdhPu65554zxuNHB6iXyyiYJgqFArrdLizLQqPRQKvV+gfNZhOdTgeDwQD9fl+/Hw6HGI1Gem8Uy1WYxxXsPjzA5PIDhBBwXVcjyzL8z0rTFIZZLOPwyTPc33mAt+MpPM/DfG7Dtm2sVj54KOAzASElZBRpRAQRxWAiAZc5ojgBCwIYtUYbvdErPD06xsfPXyDjWBeFnGm1UkZgYYwkSbViBaUkR6aRpOoc4JzDOG+/xKTXw1m9gU9fryBcD54TIKCuCRWp0R1nqQkkqQxYsB3R8wP4AdvuNaFVqaJaorH3D/Fm/A7JYoHZz1t8v2UIwkg/CkmpWqEM4bjO2ttMjxwQNl5rwgIFUj/rYJcIzy8m8OjBryXH74VPBUTIGMIwzAlFiOVarSJZBhFsTyJe26EJ+7UXeH16ippZ1CnTHXxOo3GBjArjWPmXaMI4iSkkjk34M0fi+kZoD3VDamwUj0qolivY2dvHePoexAfbFbhZya1vKlW1opgCIsVZmo+88COtMk3zsFRz43npBCb9xXv0bcbTy7zzguN6vqK0E0idtNTnQgp4K2+btvouIrpLXxOWTmqwmm3skYcXk5zwxx+GbzOPCGhEfuehoFCWKhSlcE3I1qFsCP8C0uDUei+kK2QAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore4 1",
        "title": "explore4 1",
        "src": "/tech-academy-apac/static/5b6185a170a3cec3f80a732d69d593bb/3cbba/explore4_1.png",
        "srcSet": ["/tech-academy-apac/static/5b6185a170a3cec3f80a732d69d593bb/7fc1e/explore4_1.png 288w", "/tech-academy-apac/static/5b6185a170a3cec3f80a732d69d593bb/a5df1/explore4_1.png 576w", "/tech-academy-apac/static/5b6185a170a3cec3f80a732d69d593bb/3cbba/explore4_1.png 1152w", "/tech-academy-apac/static/5b6185a170a3cec3f80a732d69d593bb/26482/explore4_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Filter by `}<strong parentName="p">{`openshift-gitops`}</strong>{` project (A) and open the `}<strong parentName="p">{`openshift-gitops-cntk-cluster`}</strong>{` (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/klEQVQoz42SXU8TQRSG908YkQJFTCy17LYgBMquaWNLJSrFxeq1iYm/0l+hFyYtgUS9AJXt7Pf3vp4zS4lWTdzkZObMzHnnOe+OslZdxY6moVavo1ZbR7fTwU5Tw7aqYm+zBX2/DcMwYOi6HHUau90u+v0+er3Hcj4YHMA8OsSTQR/KA20TdbWFO0tVmKPXSKII1ukEztkpsm+X+J+voPjwJcZ3J4HSIMF79+tYqKzg2HwJ27bh+R6yPEfKkabIswwZRU55URQ3MfuiJMP7jzYmXwUREt32blsSPh+aCEMfQZyWYkkC4QZISYwFYsr5AklFueu6dD6keS7XsiSCUt9oYqO5hcXlVQxPXsE9H+Pi0xhXZ+ewJ2OEvo/8mogJf6VkQY6ELsrygjrzoaitLTSI8vbiMobmCP7FZ1iXP+BaAoGw4ZAFgaQo/mib7ZlOp4jId9lBHJct7+mPsFRdw7OjF0gCByLIYEdEQ20wged5fxXkPRZlwvzab2W/08PB4VOorYd48/YdUl/gyolgB6k8JISQRUwx37LjOHKfyTiXgusN7cZDfjZFGsILE8RpWcxFPnnD5s8L8loQBOVLmBHyT2EPby1U6NmMkEcupm4MLyrbsyxLinLhv1r+jZDpdtsGKit3cXzCgh6EF8MNy2IumAnOE7K3vMcecs7jTxzR0kBVz1pKAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore4 2",
        "title": "explore4 2",
        "src": "/tech-academy-apac/static/29f86b39a1a0d0d1cba054f87f4a3b9d/3cbba/explore4_2.png",
        "srcSet": ["/tech-academy-apac/static/29f86b39a1a0d0d1cba054f87f4a3b9d/7fc1e/explore4_2.png 288w", "/tech-academy-apac/static/29f86b39a1a0d0d1cba054f87f4a3b9d/a5df1/explore4_2.png 576w", "/tech-academy-apac/static/29f86b39a1a0d0d1cba054f87f4a3b9d/3cbba/explore4_2.png 1152w", "/tech-academy-apac/static/29f86b39a1a0d0d1cba054f87f4a3b9d/26482/explore4_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Scroll down and click to copy the `}<strong parentName="p">{`admin.password`}</strong>{`. You are welcome to take note of this password.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABlUlEQVQoz41Sa0sCQRTdPxGVmokFsta62vuBhgaS2sNH9QeK/nT0IQ0MidZ9787uerozEsS2hRcOd2a4c+bMuVfayOWwr6ooyDJkQrPZRLVWQ41Qr9fRaDR+gde02220Wi2x7nQ6AnwvFUsVyEoZq5kceoN7MMbgeS5lH0kRhiH+C2lbrWCzIGMlnUW3f4vx5B0fmgEWRJhRgcBshlkUISL4vi+yOIshCAJI8raK3YNjUriOy5septNP6LoO33UQeDaYayEMGCK64LO5uiQyHoKwSISKuoPUWg5X3QGYbcAYP0Mfv8CcvMKZTsCIOE70vf+ZXdflX95BkTxcTq3hutuHbtrQDOeXN3GiJIW2bZNCIjs6rSGdzeO6N4BuGNA0TciPEyVHjPDk7BzNiw6U8h4eHp/wYUfQLOo0mxuPBDV/KRRfLhQVbNHo8KZ0B3fzDhK+X14EIdUzumE57rzLW6UyllbSuKGx8TwPpmkK4kXAtTHLgjUawSSrJKW8i8OTKjLreUHIi7gX3MOFQcPuvA0xHQ3xBZeQ2aMrncCPAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore4 3",
        "title": "explore4 3",
        "src": "/tech-academy-apac/static/da430e519ddfef5cfc683be68aca3d73/3cbba/explore4_3.png",
        "srcSet": ["/tech-academy-apac/static/da430e519ddfef5cfc683be68aca3d73/7fc1e/explore4_3.png 288w", "/tech-academy-apac/static/da430e519ddfef5cfc683be68aca3d73/a5df1/explore4_3.png 576w", "/tech-academy-apac/static/da430e519ddfef5cfc683be68aca3d73/3cbba/explore4_3.png 1152w", "/tech-academy-apac/static/da430e519ddfef5cfc683be68aca3d73/26482/explore4_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Now, let’s get the ArgoCD URL. Open `}<strong parentName="li">{`Networking`}</strong>{` (A) and `}<strong parentName="li">{`Routes`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABmUlEQVQoz5WS7WvTUBSH81eIw2lVhl3SNC9N2m2drRXxyxhdX9TPgvhfi+Ani9AlTdK8NcnjvRmFzXZjHni495B7fveXc4/yuvESV9fRBKqqctY/w7JtbEG3271Dr9er136/z3A4ZDAY1PvRaFQjc+Xk7Yh3Hz6imx2+fvtOFEVcL5f4vk+apmw2OXmei3VDlmUEQVDn/7L9rmhtC8N2eXJwyGT+GT9YsfRDirJiX8jC+6IsS5SWYWHeElwFHv5KuJDuskSsMYVwWYoLsvxGrKqqHbaXKW9aBu7pOc9fHXF5NaNMI8LFD1a/fxL++UXsLciTaEdoXy5bpLiid6fdE1rHLcaTOUEYCZcRlbC/PXi7+CGHSZKgXDgOF5aJq2qMZ5/wPJ9rQVEUO0L3xR3Bc7vD+46D0VS5ms5Y+AlelJFkxc3BPW4edHismxhOj6fPGlyOp6SZeICKR4lskQ8ma+I4RmlbDkdNjYPDBhPxy3IOJXIEHkNVlWyKkjgrCSMhqJs2Ta0tHL5gOv9S9269Xtcj8D/I4ZZG/gLdxdflqal0vgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore5 1",
        "title": "explore5 1",
        "src": "/tech-academy-apac/static/3b7634f890c14f748755d4989ff8db9e/3cbba/explore5_1.png",
        "srcSet": ["/tech-academy-apac/static/3b7634f890c14f748755d4989ff8db9e/7fc1e/explore5_1.png 288w", "/tech-academy-apac/static/3b7634f890c14f748755d4989ff8db9e/a5df1/explore5_1.png 576w", "/tech-academy-apac/static/3b7634f890c14f748755d4989ff8db9e/3cbba/explore5_1.png 1152w", "/tech-academy-apac/static/3b7634f890c14f748755d4989ff8db9e/26482/explore5_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Click on the `}<strong parentName="p">{`openshift-gitops-cntk-server`}</strong>{` location to open the ArgoCD URL.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVQoz31S2W5SURS9P2FtFWqbEMaWyxSFKAgWfXCCStEHY+Jn+g0++ahJm6YqaCgpXLjTme5ynyOlhVRPsnKGrLP23mtv614shmImg2Q6jWQyhUajgUqlgnK5jGq1uoJarWb2er2OVquFZrNpzu2DA3RePMWzdgtWOpdHLl/ExlYch0dvwRiDM5uZ/X8riiIDvUKu8Pl4ju/jEFZ230a+UMbGnTi6b/rwPQ+e6xqyEAJSSnNWSmmVG8U9pvDpywRfBz6sXL4Au1jBrc0YCR7B5cDc5+CcGcGpM4Xv+0bQmbsImAQTCkIKuk/pXQe5CkQZFlB72MBuIoWXr7ugYJDqiqA/amH9Mpgw/LxguHAFmFTg8tIWqobukoJaGfJwzy5hezdhBEOKHpAnIZeGJASHIKIkK06/neH0ZGjgDIYIAw+BiEzGl55aduk+8lRyfCeBXv+dIWhBTdKZci1IPqogwNlwhl9uhHMf8J0ZAtdBKEEcZSzRsB48auLxk7bp9PsPHxd+RKYBpouLRvDxOUY/fmM8mhj4oxE98mXJWsxkmNmzYZcquE1dfv6qsxyF62OhaITYcEBZ+lS6+xd0NpwFd9kU7V8ilcVWbAedw97qnK2R/zWP13cSLCKV3cfm3W10e/2V7NazvQnron8ARBzViNH7QmYAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore5 2",
        "title": "explore5 2",
        "src": "/tech-academy-apac/static/30b972ea4717c653209b1b9f5996a37d/3cbba/explore5_2.png",
        "srcSet": ["/tech-academy-apac/static/30b972ea4717c653209b1b9f5996a37d/7fc1e/explore5_2.png 288w", "/tech-academy-apac/static/30b972ea4717c653209b1b9f5996a37d/a5df1/explore5_2.png 576w", "/tech-academy-apac/static/30b972ea4717c653209b1b9f5996a37d/3cbba/explore5_2.png 1152w", "/tech-academy-apac/static/30b972ea4717c653209b1b9f5996a37d/26482/explore5_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`  If necessary, accept all the risks, and log in with `}<strong parentName="p">{`admin`}</strong>{` user and the password that you copied in the previous step. `}<inlineCode parentName="p">{`Note:`}</inlineCode>{` Don’t log in via openshift, because your openshift user doesn’t have write permission.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC+klEQVQoz0WTyU8bZxiH589JQ9htiMcG79gYGy9g44Ah0DqYmj1kZS20JIG0KCESIFo1pVJR2wNqoyhKDpGIKrUXDpXannpr1EvUiDUjOzh+8s6QqJ80+uYyj57f731HOVUS5IPSMCXlUc5UtlBaFZc7TpkpSYW5g4qaFFVnuzBbezhbfwGLI0Odp59KS5p7q1sYZ/dfyB8Yr8rpsgglFTEDVFadwGRJ4fRmcHj7cPqy+EIj8ozibhwSWB82dz923zAmWx+rXz7gSNP4fWeHv/74Ey2XRymtbDVA5eYklTUdAuxCtaexOtJyX8DuyeLwDVLvHcTmkbthGFdgjBr7AOv3H/H3P8/ZfPiUHx9v89/uPkq5qU1itVNVm6Laokfrxqx2ywd91AUuYfEOozqzEnNQzEZxNo7hCV5FdY+yuv4Aiscc7+1SPNyncHiAYoCkI5MOsX0oPaWpFVi0c47fpgeZyE6jBq7h8o+K2WXcAvOFx7H5rrC2siWQPbSjI47zeY4PxNCknsds66G2Lo3FnsHq+pgaRz+92UW0jVk25pewBifxNF3GE7pOQ3iCQGwae9ME62s/QSGPJrBCUWRzOZTauo/EqhdVCre6stRLNItnmJbmEZ5fCrHQlcHSOIFfrHyRKfyxGYLxOVzNMwL8WYA5tFcarwVW0A1VWQNVQDb3gBQ/JD2N4JDuetOTPBxq59bAGIHELH6BBVpnaYp/Sjh5A29kjq/uP4HcEXsvXqC9fMlr6VKxyhoYhTcIyH8Rp8DcTVeJtE3Smpoi0akbfSKwOUKJeZqTN4l2LOKLzfP1d9vG7hX5/yj6Gtj9J9NzBa7IBK/hbR6XvsbxhqdoiMwYVqG2G4TP3SLScZuWriUC8QW+2XxmQAqFAsVi0XiUE9DJ9LzvSvdHp414QQMkVjqofZFo6nMDluhZJpj8go3vfzGAb96cOBpAPd776emlN0rperxg4rN3VgsS8TaxziVaz98h3r3MufQK4dRdvv3hVwOUkz9Et9TPW4s9RSGC4c3cAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore5 3",
        "title": "explore5 3",
        "src": "/tech-academy-apac/static/61dc5aa8817acf9d7d4bd95d4a0c1be8/3cbba/explore5_3.png",
        "srcSet": ["/tech-academy-apac/static/61dc5aa8817acf9d7d4bd95d4a0c1be8/7fc1e/explore5_3.png 288w", "/tech-academy-apac/static/61dc5aa8817acf9d7d4bd95d4a0c1be8/a5df1/explore5_3.png 576w", "/tech-academy-apac/static/61dc5aa8817acf9d7d4bd95d4a0c1be8/3cbba/explore5_3.png 1152w", "/tech-academy-apac/static/61dc5aa8817acf9d7d4bd95d4a0c1be8/26482/explore5_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">
        <p parentName="li">{`Now, you are in Argo CD. Argo CD is a declarative, GitOps continuous delivery tool for Kubernetes. Here you can see all the applications. In Argo CD, application definitions, configurations, and environments should be declarative and version controlled. Application deployment and lifecycle management should be automated, auditable, and easy to understand.`}</p>
        <p parentName="li">{`As you can see, you have 20 `}<strong parentName="p">{`healthy`}</strong>{` applications in your environment (A), including `}<strong parentName="p">{`ibm-platform-navigator`}</strong>{` (B). You are welcome to explore the Applications tiles page to see the other applications available.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACgUlEQVQoz21TyXLTQBTUd7Mc4ABOYl+pgiMFR+ATgDiVpJIQk82OLdmWLFmLtS+jzXaaHuXKVL0q681M95vuttI/eAfD9mDaLizH60r+btoW7XbX1R7AjvWE/6+8aREVJfKqhvLi5Suc3UwwvLrBMWv45xZno3usXB+mF8AJY9i6AXOhwzUtRLaNaG3DdxzEuUCYFVhHKfyYlWRQXr95i6rZIs5yRJnAfOMhywt4QYiEvZKss8kDPMeFy4rCCHVRsDeGHQTYBBECkiZphoCgSn8wQMVnNU2DhIwqmUVZwgufAUVZwTCWyNkL0pTEGeq6gWnoSEWBIEkQssqq4l4B5bA/4EbKqfIOUE7YUhMhyu5ixQklYE3CkuA197a7HSzTIIlAzf2GPXm2A3zfO6ABWxQEkIBXqobh5Qgn1FM+R67x/R2GZ1c4Pr3E0jCBqoT2cI+T0R1OqblmWN25DrB3eIRy94SCTAVZJryg8sDCdLCmKV6U4PFxisnNHdSHCRxjBX+1wnQ6w2y1JtgaLjWMCGb7IZSjXg8Op/I0DcF8DtUyUVCvKH2WIS8EFoGPTAhKIyBIKqO09H2CpNQ56zSXT/YJrAz6fUSLKcLlAr5pQqOGUi8JWBBAuqwHm04/aUhKkoaXV3Q4o4byO06fjQriBMqHj5/Q8v3N/gmxqPC4tsgUYc2AS2N2+z3mnguPz9mwZODl0jmhzZI9GTO5IpnDz1++ouli0yJl2q/VOX6eX9OUW1gMt9wbM9C/L0Y4vvjbGSBN1JjJXzRP9sfasut58snfvv9AxY+KI4dpjhn/CT6N8GOZr6xzTrUdbHhYVIxOLYkFDJLpbgCDxumOD81yu94/AMp5CxpSVWUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore6",
        "title": "explore6",
        "src": "/tech-academy-apac/static/a03a3a3c511585c2a2a66f88411d358f/3cbba/explore6.png",
        "srcSet": ["/tech-academy-apac/static/a03a3a3c511585c2a2a66f88411d358f/7fc1e/explore6.png 288w", "/tech-academy-apac/static/a03a3a3c511585c2a2a66f88411d358f/a5df1/explore6.png 576w", "/tech-academy-apac/static/a03a3a3c511585c2a2a66f88411d358f/3cbba/explore6.png 1152w", "/tech-academy-apac/static/a03a3a3c511585c2a2a66f88411d358f/26482/explore6.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Great, now let’s check your Cloud Pak for Integration environment. First we need to get the Platform Navigator URL and password. Let’s do it! Back to the OpenShift Web Console, open `}<strong parentName="li">{`Workloads`}</strong>{` (A) and `}<strong parentName="li">{`Secrets`}</strong>{` (B) again.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABz0lEQVQoz42R3U7bQBCF9yWKVMlAKdSEFCeBJG6diuBYjVDVAG4QiLuqUh+yD9GLXvaqUiV+pKoFBxzH3l3vYXaD8yNQxUgj767PfjNnli1aFuqVCtZKG7BtG77vw3VdNJtNeJ6HVqs1l/qs3W4jCAJ0Oh1a76LbfY+wt4e9bgC2W9tCUG/AsTfQPzmFEAJxHENKiacGJ+n3X0OcXQmwdwRzKzWUVl8hPDrG7c2NAeZ5buA6lVJmr7/jUHPAYSrx7cc1fp4nYPZmFY3WDhasF+jtHyJKqMORAOeZgUWDCEmSGODgNsYok8gEFZOC9hGdq7kCzN+u44P7Bm75NfbDPlKhIPNpdX2x6PLsKjP5LxYEleAim3Qs6JKkoswpO2iQ5aWlFfQOP5FQYcRzpDQYLSqAOQEvrzOcU15GGWl0p5nR6o71f12Ulchyyanh2XMLvYMQo3ugFkmywwUn+5zAEr//prgg4J8BJ40gN6lxxMV4vga4Wd3GW5qhtfwSHwk4Gfq9oBiPnlU0pLkl4xRy9oHUFLiuLbse1tbLOAiPxhJVCKbrx2KqU5M9q2w1UHaqWCDLYf/4gfB/OdtZAWXeTgd+0IW2/vnL1zngU2O2wztpyNl0UXqCWgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 1",
        "title": "explore7 1",
        "src": "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/3cbba/explore7_1.png",
        "srcSet": ["/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/7fc1e/explore7_1.png 288w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/a5df1/explore7_1.png 576w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/3cbba/explore7_1.png 1152w", "/tech-academy-apac/static/1ffdc06eb354c68fd92a5d5607d74158/26482/explore7_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Now filter by `}<strong parentName="p">{`tools`}</strong>{` project (A) and open the `}<strong parentName="p">{`ibm-iam-bindinfo-platform-auth-idp-credentials`}</strong>{` secret (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB0UlEQVQoz4WSa28SURCG+RMaFTA0mlKXW5HWVsCGa0zUCKWt30yMf1obDVEMEbDd7pW983jO6pJWbd1ksju7Z55935lJ5bJZdstlthSF/OYmB/t77BYL1Gs1ms3mX9FoNGi1WvR6PbrdLu12m36/H0en0yG1VaxQqDzmXjbH0fEbvNmUxcdTPMPkf1cURYRheOVdqrRdQyltc/tuhoEA2l8/M/kw5tunCfp4jGXocVFSnDzLME0TXdfxPC/O5T31SCjcqzdJZzd4+XqIPZ8y+TJj/v0MY77AtW2i1YqViAS0+p3b4ptlWfi+H+cxsH7Qof/8BUWh9O279ziWxlTzUZcRywCWy+Ua8ifwskKZB0EgFAq7leoOmdwDhkcneLbO7MLlzPTxgxDHca4FSoUSmij8BSyWkbZv3UkLy4cxcKF7/DB8gjDCdW8GXrYcA4tiwvv1Z6Tvb/BqMMIzz1FND0P4lcWyQA5CFiRDSeDSrqqqsYs1MK+U2HnylId5hcHomNC1ODddNDvA8aTl63sof2YYxtUelqtibWLLGQ7F2kjgXHMxnECoiW4cyj+BhXIVGXIPh6MTAlsTll1cP4p7aFnmGpLsYALUNHFWvVhblr38CXqb04eAejyXAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 2",
        "title": "explore7 2",
        "src": "/tech-academy-apac/static/1e0f212a02b884f9cfa55812fd223a0b/3cbba/explore7_2.png",
        "srcSet": ["/tech-academy-apac/static/1e0f212a02b884f9cfa55812fd223a0b/7fc1e/explore7_2.png 288w", "/tech-academy-apac/static/1e0f212a02b884f9cfa55812fd223a0b/a5df1/explore7_2.png 576w", "/tech-academy-apac/static/1e0f212a02b884f9cfa55812fd223a0b/3cbba/explore7_2.png 1152w", "/tech-academy-apac/static/1e0f212a02b884f9cfa55812fd223a0b/26482/explore7_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Scroll down and click to copy the `}<strong parentName="p">{`admin_password`}</strong>{`. You are welcome to take note of this password.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVQoz6VSW08aQRTeP9DaVsECQmprtBWQi5eKIDQaXnxrH3xrLaLWmAiECIRe/6R9apv2obZNqLAXl9nZC1/PjvrkkpB0ki979sycb77vnJFmtraQ2t7G7IvnCBaLGFtbw+1MBrdWV8XXt76OyUJBwJ/Pi/ydbBbjFN+jvbu5nIiv/6VHwRCWozFMhyPIrTzFu5MTVA4P0azV0CI0qtUrVChXRZPidr2OD80m3jcaeEvnP7Za+NRui5wUSy9jLpaALxDGwdEx/ndJ8eQi4sk0fPdDePW6DEuX0fl+ir8/PhNO0fv1Ddr5HzBdA+cclmV5wrZtsS8lSGEml0cw/AA7pT1YnEHu/IahdcHUcxgXMqEHQ1dgW1yoGAwGN+Aux3EgZQubeLZRRHQhhUqtDr3P0VP1oZaui70IXaXSfDwpyPyBKVJYhqb3oagqyTfdKs/CYZcIy7FEGi7puD+IlzslMNrQDRvMdDyteeKKmHPD7eGS6GEo8pCGskuNsGGZ5tBeeSm2DQOMO+ibNqQn9GRSSyuITM9gd+9ANFZRFDG1UeAQqdHpQPv6BerZ2eWU5+bjZDmA8v4bcWu324VJKkeFRTVMlonw56XCx9EFTEyGUCrvCwuMsZEVCrjvkJz1aSj/ANenAxmnf66LAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore7 3",
        "title": "explore7 3",
        "src": "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/3cbba/explore7_3.png",
        "srcSet": ["/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/7fc1e/explore7_3.png 288w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/a5df1/explore7_3.png 576w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/3cbba/explore7_3.png 1152w", "/tech-academy-apac/static/e60321abef975a46b5c7f1875f67d1ee/26482/explore7_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Now, let’s get the Platform Navigator URL. Open `}<strong parentName="li">{`Networking`}</strong>{` (A) and `}<strong parentName="li">{`Routes`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABy0lEQVQoz6VRTU8aURSdP1Bt1QoFtSQMaNU6gihfjnbDwqbduHGjVVAJjYkYIxBMP35k22XTrkjTVqd8DDPz5uP0vldJF8CCeJOTd+fed8+c864kv9xBfG8P0d1dBHI5jGcyGEun8SCVEudjVYVve1tgemtL1B9ms5ikfIJ6jzY3Rd77luTgDFYiUTylU02mcH11hfNSCdWLC9QIlXL5DudUK6NKef3yEu+rVbyrVMT9D7UaPtbroiY9U+KYX1Yw6Q/i9O0Z7hvSMhEq8XVM+QLIHxfhmS38+vYJv79/IXyG1viK9s0PGHoblmXBtu2BcBxH9CVldQ2q+gLhyIIghGtD+9mA2b6F0bqB2flD0GDqTTi2JVR4ntcHHq7rQtpJJPBqIwlZjhLhKUzm4LbZGWqpNzyIkCuVckT4mjYXCoWx/+YIHd1As9Ui+YxPDRwc9pN/lpUYNhJJ+AOzODjMw6SGbjowmDvQ2jDwYJxwaSWGyMISfER4mD+G69AjMzb0rfqICI7rkQAPumFCek5LkecXiXAOR4UTYZVb5lsbBRazoXe7/xVOP5kRhLbNoGkaGKkcFV1OGKP34/AH51A4KQqrhmGMrJBvmBP+BR95A7816F7AAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 1",
        "title": "explore8 1",
        "src": "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/3cbba/explore8_1.png",
        "srcSet": ["/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/7fc1e/explore8_1.png 288w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/a5df1/explore8_1.png 576w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/3cbba/explore8_1.png 1152w", "/tech-academy-apac/static/ace7b62eb2aeed845d96cbcbe20a3df1/26482/explore8_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Scroll down and click on the `}<strong parentName="p">{`integration-navigator-pn`}</strong>{` location to open the Platform Navigator.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACGUlEQVQoz2VSa28SQRTlT/hoK8RqClso0G4VkJIVvmtpq43RGH+3TWorUqqwvLrA7ryPd2ar1nSSs3dm58yZc++dzGY2h/1SCXnPQz5fQLPZhO/7qNfr99Bo2FhDq3WAdruNIAho3kKn03Gw64xXqqBAeLSexdHJKbTWiOMYSik3V0q7KGkdxQJMKAip3P5/sBwpkdneqaKyu48Ha0/QPX4HboAVfWJOBG3ABYPgnA4APyYcFyGjKGg/QUJ78S3XGOOEM8XyLl61Ajzb8pygdIIKXKYkLjiEEOTQoDdm6E8YRjfWKb+FJmFF+5SNdVgsV7FT9bGR28Th0QkUQDfatFJBIYVLRZHbwZQ7jBeSLuS4WTHnzoo6QUWCtWaAxkGA/HYZnz5/ASOL9jBg7glezzhGkUBIYJQeN1Yk5RI5raFfa6L1uoPnhSJOP3xELEhEpWJ2pILCCdqUr6cMw0hhNZ8hmYTQjpXynaBXLKNAeLiWxZu3XdeQKFFYMttlA0bF50QUyxUuzvq4uBxh0B8j+vYV0+EQ01hT6vJfUyp7L7DlFbGefYpDaoo26W1/o049iChC7/wKg58z/BqESMIQgv4nVG/m6g1weg2ZUmXPOXy8kUOXmrJgmhxq1xi4A4kjSiFx3pvg7PsEvas5Vos5psuY6ikxJ4d22PfrHFb9l85h9/g9cKcmKdK1osl4qTGzKTLjntdd7h/B31UW0c4j+bt8AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 2",
        "title": "explore8 2",
        "src": "/tech-academy-apac/static/3c57a1c0af8186c36ad4878aaa4ec667/3cbba/explore8_2.png",
        "srcSet": ["/tech-academy-apac/static/3c57a1c0af8186c36ad4878aaa4ec667/7fc1e/explore8_2.png 288w", "/tech-academy-apac/static/3c57a1c0af8186c36ad4878aaa4ec667/a5df1/explore8_2.png 576w", "/tech-academy-apac/static/3c57a1c0af8186c36ad4878aaa4ec667/3cbba/explore8_2.png 1152w", "/tech-academy-apac/static/3c57a1c0af8186c36ad4878aaa4ec667/26482/explore8_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   If necessary, accept all the risks, and click `}<strong parentName="p">{`IBM provided credentials (admin only)`}</strong>{` link.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVQoz5WTvU7rQBCFeQgSO04c8Hp3ba+jXIc4QEAC8S+4Eop0JQqukCiQoCQtJRUtFBTUPAC0PAZvwJMcZjaySYIQUIx219Z8O2fm7IzjOKhWq+B1Ovh7rVZDFEWI49iuxb44j++TJMHM74AFJPl8Af37MVBzolZlcigDaK0JYOxZKWnDGDMJ5HU6bIWUnLYyW5km8N/tI3SyDoTwLSjv9um8SBfqD2ABZYDneTZGQNdK3Ty5RdpZR7Pp4O7qBQ83r9g9+I8g9HF0OMRg/xxCzo2ApTyvhkAEUFSFpJsrlUoJXNn6h4SqFGGA89NLPD++4eoeUNkm/iQxUtOmFsQfwFlKbtQbJM9AyRhifh5114XLPSQ4y837GzDtLhbyLvZ3DjE4e4LKDxC2UtvncigVqs53HSwRJA8VciHREyHavk9AD1I00VsbYO/4GlFs0FvcQjdbRsSDWFlDfjG0KkrgLAHTRh2aJFuZLN+hnhZTVgqtdgdZvmqHwhbhihliqLqF/vKkD4sqGVzlfhYx5kOe4Eg6+S+eNLSW8nfGZs999Tq+fSl2P+bL6adXAMoY+8fGfgfM+1ovaWdUDQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 3",
        "title": "explore8 3",
        "src": "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/3cbba/explore8_3.png",
        "srcSet": ["/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/7fc1e/explore8_3.png 288w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/a5df1/explore8_3.png 576w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/3cbba/explore8_3.png 1152w", "/tech-academy-apac/static/f8d1105326e922dfbb8708a2a47ebc25/26482/explore8_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Log in with `}<strong parentName="p">{`admin`}</strong>{` user and the password that you copied in the previous step.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+klEQVQoz5VTu27UQBR1SYlQbI8fY69f4xl7tdi7TpQNKEDCQwkoWoSUggiJAimUSbtlaGihoKDmA6DlM/gDvuRwZ9a7bEJSUByN74zvmXPvPWO5rgvHcaDXq9D7nuehLEtIKc26/F7G699KKVjXEd1MuCRR/15AZ4ZQJ23Y9go2xU4PuycUOlEUq+QsTyCEIILKxEWRG1RVBUsnZIMYIssMAsbgM9eszHXAtEJKroeNUSaI+PnjY7RNizTlhqibTCneogsFLMlDtLTZ0I9j2lARR+4xFL4HFfhgRKxL3XvzCXX7AFHk4vP8J75+/IWnhydIMo7jo3PMDk6R5jGsWquTFcIoBo8XCDmnOIIMQ3g94c7+KyhSmWYJTt+e4ce335h/AYpmD3eVRF2NqAUSluI+xMBGOvCRJCkpiAxiIpZhsOghVaDL7aaPUI0mGHcTHDw5wuzddxTdIbJhbfpshqIShfD+HHz4AlHggoecECIiVIbQR55G2Nyd4dnrC5RUzebWPibNNko9iJ1ddO/PTRWGMB+QBR5+QDF6iZII8iBA1vewJDCjsMBw1KLp7pmhaItoxZqkInXj6fZfHzrOBtidW2D2bRqA33twYXR7zYd6govSyX/ysqFFnl82tuN6BLbyn3PF2NpzN72Oa1/K/zy9JcEKa2fa2H8AUk1eGhwkGc4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore8 4",
        "title": "explore8 4",
        "src": "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/3cbba/explore8_4.png",
        "srcSet": ["/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/7fc1e/explore8_4.png 288w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/a5df1/explore8_4.png 576w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/3cbba/explore8_4.png 1152w", "/tech-academy-apac/static/1c101359e9491a1e71bfad8d59907fca/26482/explore8_4.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Now, let’s explore the CP4I. Close the `}<strong parentName="li">{`Welcome`}</strong>{` dialog.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+klEQVQoz3VTyW4TQRAdYrxgW8KxZ+mZnh57PKuXKMIKPmCyiEUKCLhx5JJDjrlEHJH4ASQO/O+jqpx25gCHp+qaqXpV9arbUUqBEUURgiCA7/ti/wfP55gA6sHneIbWBuk8h6O1RhzHYMuwAb7vwvfchk8ggpiLkx17nnxTQUjEPsbjY+Q5EdoOLTgoCikpzhCZDDpSsEU9KlCaGOf5HOt5ilmxwXb7GYtyQxOGRFjA4UAGtx+GIabTKRIT4vL9V9zc/EFdVCjKElmW4fztJ6xOX2BZFDgrcpi0xurlNZKkJg6NqqoeR+bumJDPs9kMu90OVxfXWNRrCazrCq+/3OFksyO/RDJLZVStKTdQlJdguVjDaQprz0qRVialApEk7aXwMNYruL6m0T36Fop+jCikCT2FulruO+TOmtuVrT1snbfPMaPRCJ12C71eD47jYDgcypj8n8FFCpLCsdt97E7tkzsddLtdsUzSbj8VIovhYCDSGGMOOyhJ64OGTcJ+vy9JrVYLA0o8OnqCbu8Zvt3e4/7HL3z/+Rsnp2cijTGJdMi5QsgOj9y81FYCHoN913XFbl9d4uLNB1y9+4h5Vhyuk30UsuV/EfLV4UvK1mrEo/FiPHeC49FzOfM0HM+Wi0qHzWfV7NAWshc+SRLRjMFn+whszmQyEcK/ePQ+hD1IeZ8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore9 1",
        "title": "explore9 1",
        "src": "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/3cbba/explore9_1.png",
        "srcSet": ["/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/7fc1e/explore9_1.png 288w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/a5df1/explore9_1.png 576w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/3cbba/explore9_1.png 1152w", "/tech-academy-apac/static/846f80f6ac47b34e9d34fbf4f122ced2/26482/explore9_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Let’s check the instances available. Click on `}<strong parentName="p">{`Integration instances`}</strong>{` link.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACEUlEQVQoz11Ty5LSUBDN0lmwwMn7QUhCEkISggQcBZRChCrLQlfzD+Pamo/yC/y8Y58bgqOLrs7te+7p049onuchCAJEUQTbtmGaJizL+sdsMfNqt5hg6U3TgGHomGQF2rfvoU0mE2RZBvokSW6EisDs/L3EfCHwXyTUdV0Rec5Izibu7l5ht9tCo0LXdUFPMwxDmS0gj0qEIHIcfIhCBEJoqEQmmnmJd6cfeH7+jW+nJ0RxiO12B43qptOpKsH3fTTNXC4T5L6HbV3hYV7jIYkUMcks8bbjIysWWG0vePz5C3XzVThSfDp+hhbHsSqZZOwlycPxGPlIvuUuku8i8FX5Xd9EuR8izir4riP4EoEXoJot8f3yCI0glviyN6/v7+HIObEtZZFjQ7+2QhFbNhzbEcIQviPk4xyuGeLL6dINZTQaKXA/PaqOpexIvCeqXektB0ZT+DBUFfXnJIlhmDr2+48dIS8caTxVknC9XmOz2eDNYoFyNkOaplguWxVfSIxtSdNMYkt1rutaiToejx1hnuc3QqosigJVVamHZVmqhFU9R9suFbYXQSLieOaGHA6HbiihlGBd14EKCWRmKuPCR1GMmShlIsb6UonpE1Ph+XyGNpYp/k+4Wq1UtrZtFZiPqZSPmazvO/e33+HhcNgpJMHf36grmaq4SvR9QvaLPWSypmlug+xFDAYDGcoefwCjQlEK3vcmgAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore9 2",
        "title": "explore9 2",
        "src": "/tech-academy-apac/static/205335d1fc1af9ce960adc175809f968/3cbba/explore9_2.png",
        "srcSet": ["/tech-academy-apac/static/205335d1fc1af9ce960adc175809f968/7fc1e/explore9_2.png 288w", "/tech-academy-apac/static/205335d1fc1af9ce960adc175809f968/a5df1/explore9_2.png 576w", "/tech-academy-apac/static/205335d1fc1af9ce960adc175809f968/3cbba/explore9_2.png 1152w", "/tech-academy-apac/static/205335d1fc1af9ce960adc175809f968/26482/explore9_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Great, here you can check that your API Management (including Gateway and Admin), Automation Assets and Integration tracing are `}<strong parentName="p">{`Ready`}</strong>{` to be used.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABsUlEQVQoz6VS7YoTQRCcBz0hIoRAwCiiT+FvH8A38E30wDsuesFw2SzJftx+zczuzO6W1XObIyqIhwNF9+xsd1fVjFosFlgul1itVpjP55jNZk/Eczy7uMDy5Wu8evMOqq5r5HmOsiwh+f8ulWcZDodDQJqm0E2DhjBGo+97DMPwV4zjyDbDI5RpWzgW9jyQ6LwPsXMOcmYF1nKACfGUG2PRO4vNvsHbjwYvPli8/2SgttdXuLu5Rnz7Hdurr/hB7NY3AbdfPiOJ90jIPIqioCCjIsmPxyOtyrC92+NyfcTltxTrbQ5VxDGqSsOTiaGH92kCRxa+6+CKe4yULqKEmSNrTLmnEll1azAE2Vyjh6rSDIZn8k0KKjYN/vDc08uR8uT3lgM7DpElUfxlFTS/t26c6tmwTHgR/sHSno00p4ufoaF+aDhMrEzb/8ZwRGVNaCgrNEw2G6S7GJb+VPSriHbME1h6ZfYRhkmysO/8qdBNDAFDtrbzVNWHIarm+ytpbiPvsCigq5KoHnF+u9aaP25boqYSrXXYK3lzDTenWDP+Anr6FKhT0pyjOc+bf4b0+Qknknybz44dDQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "explore9 3",
        "title": "explore9 3",
        "src": "/tech-academy-apac/static/c4460cecc17999e55b8223df1b8f7768/3cbba/explore9_3.png",
        "srcSet": ["/tech-academy-apac/static/c4460cecc17999e55b8223df1b8f7768/7fc1e/explore9_3.png 288w", "/tech-academy-apac/static/c4460cecc17999e55b8223df1b8f7768/a5df1/explore9_3.png 576w", "/tech-academy-apac/static/c4460cecc17999e55b8223df1b8f7768/3cbba/explore9_3.png 1152w", "/tech-academy-apac/static/c4460cecc17999e55b8223df1b8f7768/26482/explore9_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`3 - Prepare the Subscription`}</h2>
    <p>{`Now it’s your time to do some actions using the GitOps Automation Framework. Let’s start by preparing some subscriptions.`}</p>
    <ol>
      <li parentName="ol">{`Edit `}<strong parentName="li">{`multi-tenancy-gitops/0-bootstrap/single-cluster/2-services/kustomization.yaml`}</strong>{`.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`cd multi-tenancy-gitops
vi 0-bootstrap/single-cluster/2-services/kustomization.yaml
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Uncomment the lines below to enablle the ACE, MQ and Event Streams operators. Then close and save the YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- argocd/operators/ibm-ace-operator.yaml
- argocd/operators/ibm-eventstreams-operator.yaml
- argocd/operators/ibm-mq-operator.yaml
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops folder: Add, Commit and Push the changes to multi-tenancy-gitops repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`git add .
git commit -m "adding new operators"
git push origin
`}</code></pre>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Now let’s check the operators installation in Argo CD. Back to the Argo CD console, refresh the `}<strong parentName="li">{`02-Services`}</strong>{` application. Maybe you need to wait few minutes to make sure that all the status are Sync and Healthy, before progressing.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACfUlEQVQoz3VTS2/TQBj070blAAeg0PK4IDgDR4q4gyhUqKQPkqYPh8RJ7CS240fsrN+OkwyzG66s9Mny+NvZ+Wa82sH+I1iOh6kzx8z1YLs+y0OzarBZb1RtN1tsWP9bxWqNpKiR5AW0e3t7OL3ScXJxperbRQdfL9rQpzZ6MxsDHjQJFhj6AcxFhFm0K3e5VDWLY+iej97cx5BP7f6DhyjrBnGSIk5zXNoWOu4Ed6ELfTFH15vhZNzHmWWg7Vi4Ja6wUR+npoEz1o3voD2foju1oB0cPkfZrFHXNZYkHDgOyqJERvmrqkbDw6zAR57lSNMMNTE0G6oOkPBdiAQFe0GOKBbQnh0cQuSCH1NFaHhzKq6w4DiCWFYUGIcB8rLEMss4SYKcB1rERJFD/MPSPEfEKbXH+09RNw03lgQy9OwZ/HChgqmoZrvd0j8PHj2aGCPVJ5fp+3Co0iEeU6VcgoK0JyTMqpVSKJsvB0Mct37j5LyDKROvmbbOcI5/nuHL0WcY1zeo1zzEneMHQ/zeauNmMEbFvkCOLD2UYQjKFcpDFwt+yMsKBRVGIoXhugiiJVIqyV2HfRkM9nlRTHXSKnpJj332aC9evkKeLhmC9KNA33GUdx5/DYlVDEuOHAuBgL4m9FL+o2OOHIolxSTKZ3qjiLXXb94qD6t6hQVPG3Fzw3dJWlKlxE0GIIlTqsiZaMNEJ2FIq0qFqd6q2hG+e/+BhBt6tVIKu6YJfTCCMZ6gKHcB/HFshfVHlrJGLqnwliHd9YdwvWAXCsm1j0efUHKEkn7FTLk7NPGrc4fz6x5MXkmVPG9Nq6urGkxshRm8QS32SEwfTThdBjeM8BdQsnjoOLVTlQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "subscription 4",
        "title": "subscription 4",
        "src": "/tech-academy-apac/static/f92c7cafc7e9bfa1111246cd4a458df4/3cbba/subscription-4.png",
        "srcSet": ["/tech-academy-apac/static/f92c7cafc7e9bfa1111246cd4a458df4/7fc1e/subscription-4.png 288w", "/tech-academy-apac/static/f92c7cafc7e9bfa1111246cd4a458df4/a5df1/subscription-4.png 576w", "/tech-academy-apac/static/f92c7cafc7e9bfa1111246cd4a458df4/3cbba/subscription-4.png 1152w", "/tech-academy-apac/static/f92c7cafc7e9bfa1111246cd4a458df4/26482/subscription-4.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   When completed, you should have `}<strong parentName="p">{`23`}</strong>{` healthy applications (A), including `}<em parentName="p">{`ibm-ace-operator`}</em>{`, `}<em parentName="p">{`ibm-mq-operator`}</em>{` and `}<em parentName="p">{`ibm-eventstreams-operator`}</em>{` (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACkUlEQVQoz3VTyXLTUBDUd1NwgIMrIQ5XCo4UHIEfgCROoLLYCV4lb7Jly5ZsSda+WLKcpp84M1Vdkrrem+meGUn10xoWxha6scHK3GK9sQgbh0OJ4/G5wvMzwMd/Iz0cEWUFoiSD9OLlS9x2FNy0OkQXF/eP+HHXxHCxrDDWV1hsNlANE5plYUXohOE4FXTbhrw2oKzWUClIevX6DbL8AC+K4XkBmnIbTaWDu/5T9fwz7uOq84Db7mPFtacy2pMBrtoP+N1tVbz4bo16aPfbkOrn77AvSqKAbztQtXlVwA8j7Pc5yvKIxW6HJM0QxgnyvABoXycXpSltpsiyvOpJQKXSWf0cQewj3e8R+wGmCyYscri+jzCKEDHJ3LaYMGWRsEKWZVjQapDECHhGcEmSwDdNSLWTU5THI0aajkF/iOlSg0XrYjBZToVUozLhdudivbUrRSKEaoMwtw5cuhERstfSydszFLzkBSFcXnpqtXD58xqNyxssJyr2ngdZUdC4uMHVxTXGA6XippMJGo1f5K/Ra3eRbkxYoxEV1mro9GX0lCF0dYbxfA7bcpDQSsgi4n2kadhwgr7rIaKanbPDaK7BMDewuGYhW+U4Qq3NHp7VoY9laJMpjKWOsWnQVgInCBCzVzmHNaNlMSSbfRWWy7KExh7u2Lut63JDIhTFv02R3n/4iJL+S26vF6eYWVsUh4ItCKqBiOlqjo09+xnygkBKbkEu3meIWVxwMQt5IRN++vyFKspqHfwoQZf2lMkM8nhWHRYxMtYVNxircDkwEaLwYCrOqZVVEQHvS1+/feeaHJBx50SFrqrhri2j2R9B4y/pkhvqa9x3FTz0xBYYPJdgyl/1nt+CV2ZL2o9hOi7+AnwWcUtC96czAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "subscription 4 2",
        "title": "subscription 4 2",
        "src": "/tech-academy-apac/static/d0c7ed9d993897ad2305ddda8d784201/3cbba/subscription-4_2.png",
        "srcSet": ["/tech-academy-apac/static/d0c7ed9d993897ad2305ddda8d784201/7fc1e/subscription-4_2.png 288w", "/tech-academy-apac/static/d0c7ed9d993897ad2305ddda8d784201/a5df1/subscription-4_2.png 576w", "/tech-academy-apac/static/d0c7ed9d993897ad2305ddda8d784201/3cbba/subscription-4_2.png 1152w", "/tech-academy-apac/static/d0c7ed9d993897ad2305ddda8d784201/26482/subscription-4_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Back to the OpenShift Web console, open again `}<strong parentName="li">{`Operators`}</strong>{` (A), `}<strong parentName="li">{`Installed Operators`}</strong>{` (B). Check the new three operators in the list (C).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.94444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACRUlEQVQoz11S604TQRjdJ1BBG5oQlRITDVIKrCU0DaiB+qelf3wGH0o0DRSIJPooJv4gQSkSaUOgt233fpuZPX4zvSQ6ycnObc+cc75Pe5bJQM+uYCGziEKhgNKb13hbLGJ3exs7W1vYpXWpVCK8G39HKJfLqFQqhDL29iqoVqsK2ovsKp4v5/Bwbh71g0Nw20evbYC5LsGBGBgAZ4g5x2QkSTKdDwP8M7RSfgMST54u4vP+J8DxcNe6hdvtwu114N60wHwPYRyDE6kQAkEQII4jekSg2Q9g+0w+Q3sxtPdk7QNJ33mVx+nXb5A6zq8HsNwQgUcqGQcTHKZlqrkk9TyPSH0wmg89Ro9xpZoxBk1f07GezSGdnschWRZOgItfTfRvSV23g7DfB4sCmLalyCaEURSR2gRuSHukeqpwaWUNOX0DD1Jp1D7uQ5g2jHYHntGHS/k5rSY4ZSktS7tSifwxoXnME7SMkXU5ZBTacm4den4TM4/mcCAVkucfP9vodkwE5gChbZMqBs/36Uwo0jAMFTitTY9NCX26o70khdlVHfdnU6jXj9TB96shujYVgdg5KRKJgE+ZSTIJaVeqFHQWMaEwJVyitpG4N5PCyZdTVZTLOwdOwBFTyGJMKHP7n5CRMsOJVWEisi8LpUl1+c0iZinD4+MTupygcXlD+Q3gDcmyOaSihHCoLydFUW2jijJSN+nLqWVJmH68gKNaDdbvazTOGhg0W+j9uYLZuCBSA4YkjplqDcuylBpOVVYZji3LXP8CsBPa81Az9j4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "subscription 5",
        "title": "subscription 5",
        "src": "/tech-academy-apac/static/5c4cab50dea2edf640def7a0fd7bcc6c/3cbba/subscription-5.png",
        "srcSet": ["/tech-academy-apac/static/5c4cab50dea2edf640def7a0fd7bcc6c/7fc1e/subscription-5.png 288w", "/tech-academy-apac/static/5c4cab50dea2edf640def7a0fd7bcc6c/a5df1/subscription-5.png 576w", "/tech-academy-apac/static/5c4cab50dea2edf640def7a0fd7bcc6c/3cbba/subscription-5.png 1152w", "/tech-academy-apac/static/5c4cab50dea2edf640def7a0fd7bcc6c/26482/subscription-5.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`4 - Deploy ACE and ES instances`}</h2>
    <p>{`Now, let’s create App Connect Enterprise and Event Streams instances using the GitOps Automation Framework.`}</p>
    <ol>
      <li parentName="ol">{`Back to the terminal window. In `}<em parentName="li">{`multi-tenancy-gitops`}</em>{`, edit the file below.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`vi 0-bootstrap/single-cluster/2-services/kustomization.yaml
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In the CP4I for SKO section, uncomment the lines below. Then close and save the YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- argocd/instances/es-demo.yaml
- argocd/instances/ace-infra.yaml
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops folder: Add, Commit and Push the changes to multi-tenancy-gitops repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`git add .
git commit -m "deploying ace and es"
git push origin
`}</code></pre>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Back to the argoCD console, refresh the `}<strong parentName="li">{`02-Services`}</strong>{` application. Maybe you need to wait few minutes to make sure that all the status are Sync and Healthy, before progressing.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACi0lEQVQoz3VTy27TUBT0d6OygEXVQlrBCtgiWPJYsEOI0iK1oaVNQxs3seO8/X6/HScZ5l7WXGkU5fjc8ZyZY6VzuI+Z6WBh2lhaDlaWSzho1y22m63EbrvDlvjfKdcbpGWDtCihPNrbw/mtirOrW4nvVz18u7qBuljhYbmCxhfNvQCG62EWhFiFIZaEFccSyyiC6rh4sF2M+as8fvIUVdMiSjOiwO/VDD1rjoFvQQ1s9J0lTicjXEx1XPPZHeu3NmvGCOes/SLuXBM39gL9xQxK5+gYdbtBXdckzKGbJqqyQk7567pBy5dNXBd5XiDLcjRVDdCGGRWn/J8kKUr27sgRxSmU550jJEWMsiyRlzV0x0bdNAg4TpJlrJUwfBdFVSEuCglBNPE9JGWBJM8pJEXGuhCk7B8cYrPbYTiZ406bQrMtuH4gg6mpcMdnmuvAcTzMBypiXQOL9NSF6Xkw6V1EleIkWQHl4PAZGqYUkCSIElxrY5xcXOPssocFE2+Y9j0DOvnZxdfPXzBUh6g5sm7ZOGWIP7o3FDJBzT6P95WDzjGGQQzNj2AmwkNLEhf0qqTCMMnkZTeIkOWlXBGhRPQ5YUR1GWLhJT12wxjK0YuXcGOxBilcejCyTOmdw9XI6Yvwc8yRxVgefU3pmdhREZSfxIiyVPosbBDEyqvXb9BuNmxaSzUGL7dtK0krqqybNaYMQBAL4wtuQMtE576PvK6ouvjXyy2RhG/fvUfTbunVGjFH6k+nUDUDOkMqmaw4Q3MlayNjhoT7Ko5QeK8bGIzGsBiYDIXkyoePn1BxhIp+idj74ykuegNc/nnAlJ9kyNoDQ+n2VQltvpI1nV9Qlz2iphpzBPTf8kP8BQGLd7m75XQzAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "instances 4 1",
        "title": "instances 4 1",
        "src": "/tech-academy-apac/static/a056878d83ecce15533f2dcd2bf97f71/3cbba/instances-4_1.png",
        "srcSet": ["/tech-academy-apac/static/a056878d83ecce15533f2dcd2bf97f71/7fc1e/instances-4_1.png 288w", "/tech-academy-apac/static/a056878d83ecce15533f2dcd2bf97f71/a5df1/instances-4_1.png 576w", "/tech-academy-apac/static/a056878d83ecce15533f2dcd2bf97f71/3cbba/instances-4_1.png 1152w", "/tech-academy-apac/static/a056878d83ecce15533f2dcd2bf97f71/26482/instances-4_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   When completed, you should have `}<strong parentName="p">{`25`}</strong>{` healthy applications (A), including `}<em parentName="p">{`es-demo`}</em>{` and `}<em parentName="p">{`ace-infra`}</em>{` (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACm0lEQVQozzVT2W7TUBD1d6PyAIKqK68IHhE8Ai8ICSGU0oqlVZc0TZrUtZ04q+N939PDubfiypY9M/fOOXNmrnKwuw1zucZsaWG+WmO+djGzHBR1g6ppUW8ewAdNu0HzwH8aD/z+X+IvLEq4SYaEX+XJ1hb+XA9xcn6Nk4sejjvH+HV0Ans6g79cwZlMMF8uYfkhsrKSSZq2hRNGCOMEWVEhJXDBmBfFUJ4+e46iahAw6BNlZegokgSO4yChr3AdaBMDYZLCC0PEaYqqqqFbFlzaXhQh4v6yqmB7AZSDw1coiVCWJZOmWJCRCAZEE4yKOKYkc4LWkpE4LBJOPRdpkSMmkPCX3OsGIZT9g0NEWYg8z7mhxETTiOTLoFx1BX06geV6sB2PyR7LNlnBfG1LX5YX0hdECZTtnV20mw1GuomhMUXv/BJfv3zDj+9H0EYqQsNAfzRC56yLn2dX0MwFK2igsYkd2p2/l7i505GXNZwggrKzt4+arQooskMEdbGATzY+WcZCeL7aagWfEoSURMiSZDl0JnRYRZLmchoi6m+zccr2i5foDYboD0eYGWMizxFnGVyKXbA8wV631/CZeO158Jikpn9s21j7lMH3ZawoStlYZX9vD3N1CJPaLc0ZjLWFpmnIJpa6igZN2Omqrsksk/aGIFOXTSkL5MXj25ClmATl9Zu3aCloy4GN8hLXponBvSF1iVmaWHerJQa0e0MVrh9In2B4o2q4VQ2sbFf6QpatvHv/geitHIUozdC96eP09ym6F12y1uGYU4zGE1zcqrga3mPCWyUOaouV9F0OVNyzUUJbS8zhx0+f5TUTc+axS/ptHyk1a6IQG85cNtahjw0JlnCoxS2puV8Mtk9ZEpZZUyIhicvz/wAI1HoREMff9AAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "instances 4 2",
        "title": "instances 4 2",
        "src": "/tech-academy-apac/static/9d55368f9b1fe3846639660f5abfd68c/3cbba/instances-4_2.png",
        "srcSet": ["/tech-academy-apac/static/9d55368f9b1fe3846639660f5abfd68c/7fc1e/instances-4_2.png 288w", "/tech-academy-apac/static/9d55368f9b1fe3846639660f5abfd68c/a5df1/instances-4_2.png 576w", "/tech-academy-apac/static/9d55368f9b1fe3846639660f5abfd68c/3cbba/instances-4_2.png 1152w", "/tech-academy-apac/static/9d55368f9b1fe3846639660f5abfd68c/26482/instances-4_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Now, let’s check the new instances in CP4I Platform Navigator. Refresh the Integration instances pages (Menu > Administration > Integration instances), and check if the new instances are available and ready. `}<inlineCode parentName="li">{`Note`}</inlineCode>{`: ignore the warning in Kafka cluster, it is only informing about a new version.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/UlEQVQoz6VS224TMRDdD6VSkFAUKRJRJYT4CT6Ad/6ArwDEA72mSUvUFJJsmt3EXl/W9tqHGW8jUN8QlkZzxjP2XM4Uo9EI4/EYk8kEw+EQg8HgH+UlTk5eYPz6FKdv3qFomgZ1XUMIAcb/e4q6qlCWZZbdbgetFZRSMFqj6zrEGBH/1kcce5wII3X0FeuIwrYtAjm6lOBJuxDgA2nvYcjXkmaxz7B1nhJ6LDYGbz86vPrg8f6TQ3F/fYXldIrVfI5lxtdY3c7xcDPF3dn3jH/NZlhcnmNNmGVxeZH9m7tbzM4u8O3LDb5+nuHq/AfNcPsIoSOCD3DWoqFZRqoyOJclcYvBQysD13pQWTA0Ek3zTl2AMSq/BQJSvaUZ/nyAaqhtY+F5fvs92kaSrbMdW4vOGljJdwaJWyfMdiKflgK2sYhUTLstUVTrFep1CUMfCSZneY/mcQtDzOu6gqOK7WEPScHmyRaEVbWDkwfsyg1kdaD7AyxJobSFDT3lTISkdvjExJIyTtnHZIWnuJBJ5GNoHD727ztivJBSQZpERkIgJ+9i4Bky25Qg0UNeE0PtGuvo95Qx+xgLGo11Maflu0IICWU79uULDu73LOY9zBWmPrj1fVWOyDr6DGHn+w+5CKpQQsgmB2la5mP258J+5/5g1oGTEEn8hrUlYn4DqJR82Cd/bIoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "instances 5",
        "title": "instances 5",
        "src": "/tech-academy-apac/static/f969f9317199b837585163d2f211db36/3cbba/instances-5.png",
        "srcSet": ["/tech-academy-apac/static/f969f9317199b837585163d2f211db36/7fc1e/instances-5.png 288w", "/tech-academy-apac/static/f969f9317199b837585163d2f211db36/a5df1/instances-5.png 576w", "/tech-academy-apac/static/f969f9317199b837585163d2f211db36/3cbba/instances-5.png 1152w", "/tech-academy-apac/static/f969f9317199b837585163d2f211db36/26482/instances-5.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`5 - Activate MQ Queue Manager`}</h2>
    <p>{`Now, let’s start the application layer. First we need to create the MQ Queue Manager.`}</p>
    <ol>
      <li parentName="ol">{`Back to the terminal window. In `}<em parentName="li">{`multi-tenancy-gitops`}</em>{`, edit the file below.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`vi 0-bootstrap/single-cluster/3-apps/kustomization.yaml
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In the `}<em parentName="li">{`SKO sample apps`}</em>{` section, uncomment the line below. Then close and save the YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- argocd/sko-sample/mqmgr.yaml

`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops folder: Add, Commit and Push the changes to multi-tenancy-gitops repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`git add .
git commit -m "mq queue manager"
git push origin
`}</code></pre>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Back to the argoCD console, refresh the `}<strong parentName="li">{`03-Application`}</strong>{` application. Maybe you need to wait few minutes to make sure that all the status are Sync and Healthy, before progressing.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACkklEQVQoz3VTS2/TYBD070blAIeqhbSCE3BFcCyIKxKqaA9t0rRJ0zZJE7ux8/DbsT+/H0mGsXPmk1aWxrv7zc7OJ7WOD6HpFha6iaVhYWXYDAtVWWG72Tax2+6wZfzvpOUGYVogTFJIrw4OcHU/wmX3vonzbh9/uj2MFiuMlytMedHc8aDYDlRvjeV6H0YQNLH0fYwsG2PThsKv9PrNW2RFBT+M4EcJblca+sYcQ9fAyDMxsJa4nE3Q0WT0dA1PxBvsZYIrVUaH8Wjr6JkLDBYapNbJKfJqgzzP2TSGrOvI0gwx6Zd5gYqXaY6NJE4QxTEKYqi2ZO0gjGKIIETK3B17CNZL71snEEmANE0Rpzlky0ReFPA4jogiYilmroMkyzgBpwhDJLxQIybShLVpg0VJgjWnlA6PjrHZ7fA8m+NxqmJqGrBdr1lMTjb8RW1MWM4ei1lYnxlZ6zYXqMzgB6LBBCWTjo7foeCWPDbxfIG7qYLz6ztc3PSx4MYLjjKcL3HR6eNvpwdZW6IkppgWLtq3+H32Cw/tLnK6wWG9dNQ6xbMXYOr60EXMrRpYC+pCdnWsRQTZMOCsfY6fIS3KhonMPJOYILvUthBQT8vzIZ18+Ag7qG0QwqaoE0On2BEsWqMer9ZTYYEvBBn4CLmY2qMzjuuKAC61DphXMK92ivTp8xdUmw2TyobNC4vLqmwKS2I5GalcQN24Fj7hkiqOPHddxPneDfXFJS/xyVL6+u07ddpSxxJBnGKgqhhNXyCrc2S0Un2e9VWDTV40WiPaL4UMn2QFE0WFQ8M3S6G1pLMfP5Gxe5YXjQ8HTLjuD3HzMIa6smiFGGO+mvZg1MR0vmowmS+ozZw2X9lQ0eBRf8Nd4x++kngQo/RVNAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "queue 4 1",
        "title": "queue 4 1",
        "src": "/tech-academy-apac/static/da7904b0e9d3158fc54b16d45108e0e9/3cbba/queue-4_1.png",
        "srcSet": ["/tech-academy-apac/static/da7904b0e9d3158fc54b16d45108e0e9/7fc1e/queue-4_1.png 288w", "/tech-academy-apac/static/da7904b0e9d3158fc54b16d45108e0e9/a5df1/queue-4_1.png 576w", "/tech-academy-apac/static/da7904b0e9d3158fc54b16d45108e0e9/3cbba/queue-4_1.png 1152w", "/tech-academy-apac/static/da7904b0e9d3158fc54b16d45108e0e9/26482/queue-4_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   When completed, you should have `}<strong parentName="p">{`26`}</strong>{` healthy applications (A), including `}<em parentName="p">{`mqmgr`}</em>{` (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACjUlEQVQoz3WTSXPTQBCF9bupcICDKyEJVwqOFByBH0CKAD4kzuLEcrzLsuRFshZrs3bZfrwR5Iiquqb0aqb7zdc90tlJA7phYWGssTQtrNY2w0FV7bDfH7A/HHAQK+N/X1ruEKUFoiSF9OLoCFedAZp3HYaMH617XFzfYjDTMdB0jOcL6I6Lqe1CczdYeR6WDDMI6lh4Pvo0MWRMLRvSy1evkRUV/G0M3w9x23vE3VCGrPTRVYdoj7podu9xM1fRtZbouSZkrk11jCtNQXupoU+tvV5AXuiQzs7fIqflvCwRCCeaxgIlQhYoywq7ao/5TEUSJ0jTDEVeAEKzHUTcE1PP0hwH5gijGNLp2TnCOECa54iDEIo+Q1YWcH2fB7ZImETTmDDL4EdRHSKx7roI04SFt7W2ZWIv2kJqHJ9gt99jpC3QexpAmWuweXV74+O5D+p0AsshPzYtTpJa0xwHBsMkuyCMADYvoGPp+M0pSh70KfpMcndzg4vvl/h92YQ2VrA1DPQe2vjNhv1qPfAGSxScgKm5ptbBT2pPY5XIKjhBRIeNBjpdNmAwgj5ReECHzY5uXI/c4nqdrFZwPGLJin98EyiGiTUNbDkqoqkB+Vn8l07pcD7qY8Zky5mGsWmQaQyTjGLRBDZLtS3eIIRDroJZRTcz24YbBrUWkGFRFGRJhu/ef8CeTHZk4CdZfbiqqnqTAJ3UDXCQ84DgJ1Yx9HNRMM+opSycciLKvww/fvpMFztWEEICmWMzmKjok8tzA0bGqtbGql6PiviEw54yxWiqwdl4tRbSgPTl6zeOSYUsF5ZjyNxw/djH7dMIGp+kR224WKElD+qY6KtaU/hUW90hWnxl/amOTSgwefgDrP51EmQPUoMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "queue 4 2",
        "title": "queue 4 2",
        "src": "/tech-academy-apac/static/86f3cc1f08bc16f86129012048260e00/3cbba/queue-4_2.png",
        "srcSet": ["/tech-academy-apac/static/86f3cc1f08bc16f86129012048260e00/7fc1e/queue-4_2.png 288w", "/tech-academy-apac/static/86f3cc1f08bc16f86129012048260e00/a5df1/queue-4_2.png 576w", "/tech-academy-apac/static/86f3cc1f08bc16f86129012048260e00/3cbba/queue-4_2.png 1152w", "/tech-academy-apac/static/86f3cc1f08bc16f86129012048260e00/26482/queue-4_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`On the OpenShift Web Console page, open `}<strong parentName="li">{`Workloads`}</strong>{` (A), and `}<strong parentName="li">{`Pods`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACCElEQVQoz51Si24SQRTdn7BGtA2NDwQLVNJqkRWRQDSxFVF8JU1/3agJkNB9P2ZmZ3eP9w4sH+BNbmYmcx/n3HOth/U6zjsdNJpNNBpPMRqN0O/3MRwOYds2BoMBOZ10r94cM5lMMB6PzX06ne7detZ5jmb7FLXDOuaLb8iyDHEcQymF/zGrddLF8aMGDu49wNVsjsAPsFqtsVytEAQh0lQgTASEVKZJ5UJpxCJHIreustwAsXoXNt5M3uFxq43vP6+h8hyZziBFCiklBWpK0MiLAmVZGhR8FkVpzurOJoSAdWUP8XX0Fq9fXODH9Q2kF8B3I0TUlYv4vg/PdSmpMMjiJKaKW3pBGCOMkz1dU/DD2Rned7sYkV/OF8gdB8u/t/hzmxCljCinRFeaBKkEPN/bIS0N1Zi8Qs6xJMopKThE7egYlx8/IaCApZti7USUQAWTxHQ2CTKF4zoGLVWBE2VY+wo6347DIGSVu71zHNQOMZt/QU7NwkQhSiUFFdCa5kdzZdO5Nkk7QFh6Cr82kkZT7v5zWE+aJ2Cl79aOMPu8gKY/N5RwI2ECWBheJTaVUaM4QllsKW/CDH6izZ0RcnOrRTvIKO/Q2jDCgodLqrK6TK1yNkbKxasZMsIVUa7U5n+r3e3h5Ssb92mGhjKF/t6k5IlRmSlWS84IwyjcF2R0Qar3K8TN/gFaL9WlOGgDOAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "queue 5 1",
        "title": "queue 5 1",
        "src": "/tech-academy-apac/static/5329ccc1a7b844f4c440b4671c0b0fab/3cbba/queue-5_1.png",
        "srcSet": ["/tech-academy-apac/static/5329ccc1a7b844f4c440b4671c0b0fab/7fc1e/queue-5_1.png 288w", "/tech-academy-apac/static/5329ccc1a7b844f4c440b4671c0b0fab/a5df1/queue-5_1.png 576w", "/tech-academy-apac/static/5329ccc1a7b844f4c440b4671c0b0fab/3cbba/queue-5_1.png 1152w", "/tech-academy-apac/static/5329ccc1a7b844f4c440b4671c0b0fab/26482/queue-5_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Filter by `}<strong parentName="p">{`qmgr-demo`}</strong>{` pods (A) and check if they are running (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/klEQVQoz5VS224TMRDdrwB6JbRS04U0KRWFQKIqipICIr1RyjMS4iv5CnhAfW5C1W028d68613bOYydpKVCIGFp5IvGZ86ZM856qYTdahVl10W5vIlWq4V6vY5Go3EbzaaNptnpbnI6nQ7a7bY9d7tdHPde493bfThPqk/hbm1jcaWEk9OPKIoCUkr87/p2IXAZ6Cng+oaLB0urOHr/AUEYIk1TKK0R9fsYnZ8jvB4hFhqZkFBKYTKZ2NB6cnP++p3hx4DDeUzsnj1/iQVi2Ds4QpZyJEkMnmUY+wzJcAiZF8iVAdDEZfJPpo5bqaFS28HS6iMcHB5jdDGA/9MDG/TBvSsIKpAJAVnkiLhAkhVUMEGe51MlxJgxBp5m0MTU2Wvvo919g9rOLj59/gLmEVhMycQwCxgKaoGiRNIFP1EIUgUhMttrQYXMHgQBOOdWOvVwG/XGHpYfrqFHDEN/RJ80hFTISbqMIwKElTriGozT+wzIABoDQypqAK1kY4phd29hmUw5A/eHGHs+OBsjvfYgCVQbQKoephJRpqDk1Bw526MosvIt4IZbgenj/cUVGpszJKnA4HIMHoyREKj5PDeDxQLDqJi1/9acO4DGZcPSMjw5tY9E4mbNx8KOCUWh9J03E7/nOVvk8ItXTXJ5DYczQFP9zw/468jMc4ySX7610+ol5TktAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "queue 5 2",
        "title": "queue 5 2",
        "src": "/tech-academy-apac/static/b6d7341aee36acaac86f71e8de7ba10b/3cbba/queue-5_2.png",
        "srcSet": ["/tech-academy-apac/static/b6d7341aee36acaac86f71e8de7ba10b/7fc1e/queue-5_2.png 288w", "/tech-academy-apac/static/b6d7341aee36acaac86f71e8de7ba10b/a5df1/queue-5_2.png 576w", "/tech-academy-apac/static/b6d7341aee36acaac86f71e8de7ba10b/3cbba/queue-5_2.png 1152w", "/tech-academy-apac/static/b6d7341aee36acaac86f71e8de7ba10b/26482/queue-5_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`On the CP4i Platform Navigator page, refresh the Instagration instances page and open the `}<strong parentName="li">{`qmgr-demo`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAByklEQVQoz6WS3WrcMBCF9aIp2xuzYSnblwiUPkFynffIVaDQu/6Q0paQTbZO1rv+qS1bGslrnczIMSwJFEIFA7KkOfPNGav5fI7FYoHlcokkSTCbzV4Zb/Hm6AjH797j5MNHKN22KMsSdV1Da43/Wfv9HqosCmRZhmy3Q87RdR1aLmKMiQ+GYfhnIASOIQp6T1CWHHpOdNkDiMXIOTgOIoriRBbW2lhAzqa9McRIFp9/tkhODZIzwvlFA3X74wp/vn/D/adLpKsVtkxZMPVms8F6vY777XaLNL1HnhccOe/TeFYWOa5XKb782uHr7wLXdzlUfnOD7DZD+7CBrUp0xnIXQ2xXQlbg1owl7iTEb6GULmTVTDstTwaq7Qw6YgFO8n0f2wrsy6GgeEWu5zcheiZvxrsQLSI/FupYS1XVX2gjyQGeL2Ug3vuY0HOBSdAyoRSVYoYJx7uAhgndJGiEUCbKjyVJzC7LKrbznNDR+CY8I9Sc65+skHxVNxqNHafvHKFpmpgkBIeEMnG5j4RPv5QIVtym6w8EtW7Zw8BJo4gcisALD0m8OiCUfzAS2peEk6B4JySTmBQQgYH3lkUmQZnyRNiIYCQczx8BwDOCupgHkrkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "queue 6 1",
        "title": "queue 6 1",
        "src": "/tech-academy-apac/static/1587160082bde0beb01370ba724a7fe4/3cbba/queue-6_1.png",
        "srcSet": ["/tech-academy-apac/static/1587160082bde0beb01370ba724a7fe4/7fc1e/queue-6_1.png 288w", "/tech-academy-apac/static/1587160082bde0beb01370ba724a7fe4/a5df1/queue-6_1.png 576w", "/tech-academy-apac/static/1587160082bde0beb01370ba724a7fe4/3cbba/queue-6_1.png 1152w", "/tech-academy-apac/static/1587160082bde0beb01370ba724a7fe4/26482/queue-6_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   On the MQ Console, click on `}<strong parentName="p">{`Manage QMGRDEMO`}</strong>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACP0lEQVQoz4WS3WoaQRTHBa+MD+AH2OC7+AINpZBW0RsLvehTlEKhtrHog3jfZwgVpKRR2zXbGBvj7O7szn6q++854wckN10Y9uzsnN/5nzP/TKPRQKvVQrvdRrPZRL1eB+/x4vh/i8+9fnWON2/f4f2Hj8i8eHmOs7PnqNVqGAwG4EcpBd/3sV6vkSQJ4jimd4x0E+t4s9kc93f/EkRRCM/zkCmXy6hUKshms+h2u3AcB6PRCOPxGNPpFMvlEj4VELaHydynJBemacKybYoVbEdCWLYWwbmZ09NnqFaryOfz6Pf7SNMUq9UKNiUIIeiQROB7WKx8fBsqRL7EZDLVyd9nMf7eP8AwZgiCYAcsFotglblcDr1eT7fsuq5umRe3EUURzNlvXA5/4FasYVkWrq5/QboKIzPG1cSEdGxI6SJTKBRQKpUeASVVYpDHQIJz9cXiDsbNLSwZaiVCWAgDhet5gJ9jg2AOLfkESC1rIEEUqfII4v4xNZjVhgT2lbe/NLVTH3g6Ps7wCDw5Qe9rFxuqJAjiEEwML+FZAn4Y6gQGqD2cF+8ptYuDwH+ikC6l1/mErSsR0oGYIDEpDalqQvZJt1ttEW6fbcKW4u+Qzh2+efaPgP0vnxHRpjmf455uOiVvhTTsgNrnZ0vQgzq+KIYcPMuFOH4M7HSQ2BZuDAM2AdfUvk2tW6SSD7MSthPPiiFscD1bUsl247e2zXGGFxdIrBWWMwPO3RzBwxKCjC33N83Jzh5+mCF79mAt/v4H+XkUSqn33agAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "queue 6 2",
        "title": "queue 6 2",
        "src": "/tech-academy-apac/static/55b06532f7b5fba31d1d12909257b77a/3cbba/queue-6_2.png",
        "srcSet": ["/tech-academy-apac/static/55b06532f7b5fba31d1d12909257b77a/7fc1e/queue-6_2.png 288w", "/tech-academy-apac/static/55b06532f7b5fba31d1d12909257b77a/a5df1/queue-6_2.png 576w", "/tech-academy-apac/static/55b06532f7b5fba31d1d12909257b77a/3cbba/queue-6_2.png 1152w", "/tech-academy-apac/static/55b06532f7b5fba31d1d12909257b77a/26482/queue-6_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Here you can check the Queue Manager.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACI0lEQVQoz4VSyW4TQRQcyScb371giPwb4QssRdy4BC8XS0hI+QqExAGUxLG/ArjwCxw4c+No4rE9+/Tsu4v32iRxLCRaKvWop7tevXqlDIdDTCYTTKdTuQ9HY4zHD+Azxmg0At89Bp+/Pj/Hm7cXePf+A5Szs5cYDAZ4cXqKz1++oqiALEsJmUQURQjDEGVZ4n8ry3MonafP0Ov1UKvVcHl5BccNsN6a0HQdtm0RbKiqKknTNEVRFKiqShbgnZHmFeIMiJMMysnJc/T7fTSbTdzczGWlvChR8kUiiOMYu92OCCqp1nVd5KSECZMkQRAEslgchfA8D0q73Ua320W9XifCGRGViIQLkkItZHAdh0gjlHks1Rmk3Pf9fYtkSRD4kjQIQgghoLRaLXQ6HUk4n8+RkTrTMJGl5F+ckAWC4EnyJEnpkUcqBXVRUIsJfCJihVkSUqEDwieNOj5dzWGGwO+tA9XwoOoCWzvGVpQw/BIiriCiCi4jLOEQ3LCAJgr82lT0JnggbDQauL6eSV8Mw4BlWQQbpmlJGKT69naF1WqF9WYDXTew1Qz4roHvPy28+hjg2w/xmHA2myGIUmx0B5bjSa94ygxBw1gul1iv19A0jXZVFuU7PAy2Qg7l0MPFYiHN9uPdo3zxlI/Xv3LJQzoayp7Q9gsyvZJEPNm77B1mkK3h/3dZrP7GTMbmWKEXFRSfHUu7J9hnsbwn4Szy9yG4yB/1shurKdcaBwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "queue 6 3",
        "title": "queue 6 3",
        "src": "/tech-academy-apac/static/12f6ea6afbb66f8a136c4dd604d0ed23/3cbba/queue-6_3.png",
        "srcSet": ["/tech-academy-apac/static/12f6ea6afbb66f8a136c4dd604d0ed23/7fc1e/queue-6_3.png 288w", "/tech-academy-apac/static/12f6ea6afbb66f8a136c4dd604d0ed23/a5df1/queue-6_3.png 576w", "/tech-academy-apac/static/12f6ea6afbb66f8a136c4dd604d0ed23/3cbba/queue-6_3.png 1152w", "/tech-academy-apac/static/12f6ea6afbb66f8a136c4dd604d0ed23/26482/queue-6_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`6 - Customize Event Streams`}</h2>
    <p>{`Now, let’s create the Event Streams resources for our Multi-Style demo.`}</p>
    <ol>
      <li parentName="ol">{`Back to the terminal window. In `}<em parentName="li">{`multi-tenancy-gitops`}</em>{`, edit the file below.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`vi 0-bootstrap/single-cluster/3-apps/kustomization.yaml
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`In the `}<em parentName="li">{`SKO sample apps`}</em>{` section, uncomment the line below. Then close and save the YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- argocd/sko-sample/eventstream.yaml

`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops folder: Add, Commit and Push the changes to multi-tenancy-gitops repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`git add .
git commit -m "customize ES"
git push origin
`}</code></pre>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Back to the argoCD console, refresh the `}<strong parentName="li">{`03-Application`}</strong>{` application. Maybe you need to wait few minutes to make sure that all the status are Sync and Healthy, before progressing.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACkUlEQVQoz3VTTW/TUBD070blAIeqhbSCE3BFcCyIO6iiRbRNS5OmNEkTO7ETx9+Ov5+/kgxj98yTVpbG+3Z3duZJncN9aIaNpWFBN22sTIdho65qbDfbNnbbHbaM/x1RbRCLEnEmID3b28PF3QjnN3dtnN708eOmh9FyhbG+wpSNFq4PxXGh+mvo66cww7ANPQgwsh2MLQcKv9LzFy+RlzWCOEGQZPiz0tA3Fxh6Jka+hYGt43w+QVeT0TM0PBBvsdkEF6qMLuOvY6BnLTFYapA6R8co6g2KomDRFLJhIBc5Uo5fFSVqNtNcB1maIUlTlMRQbzm1izhJEYYxBHN3rBHxvvS6c4QoCyGEQCoKyLaFoizhk06UJMQE5p6LLM/JgCziGBkbasQikXF3AiGxJMuwJktp/+AQm90Oj/MF/k5VTC0Tjue3whSchr+4Gwu2+4SlvNicOSc0HQe6PEMQxS0WcWXSweErlFTJZxE/iHA7VXB6eYuz6z6WVLwkleFCx1m3j5/dHmRNR0VMsWycd2/x/eQb7n/9RkE3uLwvHXSO8eiHmHoBjCilqibW7Cg4XRPrKIFsmnDXAennEGXVTiIzzyIWN7lUPSRd2w8gHb15CydsbBDD4VInpsFl8yeTGnrNPhXHJq2IE7AAhWk8OiddLwrhcdchBSuZ1zhFevf+A+rNhklVO82Ml6u6ai9WxApOpFKApnCz+Iwi1KS88DykxZMbWkewSUDVpY+fPnNPW+6xYieBgapiNJ1BVhfIaaXmPBqrFpvMNFojeRKFEz7ICiaKCpeGb0XhpNLJl6/IWT0vytaHAyZc9oe4vh9DXdm0QooxX83VYNTGdLFqMZkv6Io5V3xlQ0WDz/2b3hr/AMf+eBedJEAXAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 4 1",
        "title": "es 4 1",
        "src": "/tech-academy-apac/static/1172c9b5fc85c277e6e26bf227eb4f19/3cbba/es-4_1.png",
        "srcSet": ["/tech-academy-apac/static/1172c9b5fc85c277e6e26bf227eb4f19/7fc1e/es-4_1.png 288w", "/tech-academy-apac/static/1172c9b5fc85c277e6e26bf227eb4f19/a5df1/es-4_1.png 576w", "/tech-academy-apac/static/1172c9b5fc85c277e6e26bf227eb4f19/3cbba/es-4_1.png 1152w", "/tech-academy-apac/static/1172c9b5fc85c277e6e26bf227eb4f19/26482/es-4_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   When completed, you should have `}<strong parentName="p">{`27`}</strong>{` healthy applications (A), including `}<em parentName="p">{`eventstream`}</em>{` (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACjUlEQVQoz3VTyW4TQRSc70bhAGJL4nBFcERwBD6AiEAskRgTJ97G69gz43X2ffPYLqpHcKSlUneXut+rV69bqp2+gLY2sFhvsdwYWG1NwkJZ7nE4HHE4HnEUM/G/ke72CNMCYZJCenRygpv2APXfbaKDb407XN42MVC1CmN9Cc2yoZg2VNvBynWxJDa+X2HhepApYkgohgnp8ZOnyIoSXhTD83w0+/doyA+4G3bRnY/Q4rpO/NJn6BpL9O0NOpzrszFu1ClaSxUyudZ2gc5Cg1S7eI2ckvPdDr5QoqlMwHUYYVcesM9y6LqGhOWkaYYiLwDyumkhpIg4TpClOY6MEYQxpPPaBfzYR8KLsR9gqs2r4I7nIYgiJGEIlZmTPIfHtYAIrNk2gjSpzgguYmCXIqSXr05B16lsiUF/iKmuwvQCmI6Hkg1hN6CoMxi2ixWbFidJ1QjVsrAmNvTOD0LGOMKnYunZ6TkW2R49w4Fm2LhrNnH59QrXV3WoEwURy+33erhmw340WqxgiYIvQNlsybXxvXGP3njGqkpYfsiAz57jZ7uHm66MyXgKRddhsqMOFSXM6Dgupus1LNdHmhWVv0GUkNtgyyoieiua6tM/g3updnaG1ViGPlWwns8xWa8QxDE29CgWTaCfM9OAFwSw/vpaUs3cNGEHfsX59LAoCnpJD9+8fYc9PdnTAy/JqstlWVaHhNFJ1QALOS8I/8QsHr0uEuYZuZSJU+zEKxEevv/wkSr2zCCIBB1VxWAyg0xf/jVgRNWCG8+06qmIIRT2WdVIUWHRFjECCpA+ff6CjCVkuZAco8MDtw8ymr0RVH5Jl9xwsUKjM6gw0VYVN+VXbXSHaPCXyYoGJxA2ufgDshh0kcqKtUoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 4 2",
        "title": "es 4 2",
        "src": "/tech-academy-apac/static/95bc16c01c26db72cfc27ef8d50c19d6/3cbba/es-4_2.png",
        "srcSet": ["/tech-academy-apac/static/95bc16c01c26db72cfc27ef8d50c19d6/7fc1e/es-4_2.png 288w", "/tech-academy-apac/static/95bc16c01c26db72cfc27ef8d50c19d6/a5df1/es-4_2.png 576w", "/tech-academy-apac/static/95bc16c01c26db72cfc27ef8d50c19d6/3cbba/es-4_2.png 1152w", "/tech-academy-apac/static/95bc16c01c26db72cfc27ef8d50c19d6/26482/es-4_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`eventstream`}</strong>{` application.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACjklEQVQoz3VTTW/TQBD170ZwAKFCRYvgBFwRHIEfQEWhPbRpaNomjfPROLFjO47t+PsrjpM83q7gyEqjXb+dmX3zZqwcHR7AWLgwF0tYjgt76dF8NM0Wu91e2h7ADv9f5WaLtKyRFiWUR48f4+JugPPfd7QufrSucXLZxkA3MJgZGFs2TJ41tY9ZEMAOQ1g0J46lmWEElSSGNM31oDx5+gxV3SDKckRRjHb/Bi31FtfDHnqzETqDO1xcnuFq1EfPtdFfOei6Fs6nY1zoE3QsHSqxztJE1zSgHB2/xpqU15sNYn8FzdD5AM9phk2zw7Zaw7BMFNzLskK9rgHic89HShJ5XqAq19gzR5LmUF4dHSPOYxmQxwkmxkwmD6IISZahSFPoc533FSKehYnExmqFpCykj8AyJg5JQnnx8hDY76HNLQz6I0wY7EUJvCBCQ1zeGVO4qxA2m5YXhWyE7vtY0BxqFyep9IvJWHnOhPOsQs92obPT11dtnHw/xdnpOfTxBMXSgToc4oxN+9W6YQUWak6A5iwl9pPY/XjKqhr4cQrlgCV33JCirqBHGSamCZ/6BGRU8MUgCDFZLOCHMcqqlvomWUHMwZJVZBwV0dSY+rn8Vo7fvMUqieAmGVZ0HJNRkudwqFFOrYSemuciShL4f3VtyGbmeYyLJRZTw7quqSU1fPf+A5rtlk4bhEw6ZXDTNNJJCF3IBvhYM0DoJ3Yx9HPx4LoiVvLhEhsxJULDj58+U5MdagHkJbq6jsHDFCp1+deA0cKW2HhqyFERSzDsTzSMNB0+ZRErIQHly9dvqFhCtRaUc3TpcHmron0/YpNcjkKOoWmj1R1IezBsiU3YwFZviBb/MlUzECRCphB/AE7LdXMfX1OoAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 5 1",
        "title": "es 5 1",
        "src": "/tech-academy-apac/static/4d228d56bd5a97002d21bd091ca5e8af/3cbba/es-5_1.png",
        "srcSet": ["/tech-academy-apac/static/4d228d56bd5a97002d21bd091ca5e8af/7fc1e/es-5_1.png 288w", "/tech-academy-apac/static/4d228d56bd5a97002d21bd091ca5e8af/a5df1/es-5_1.png 576w", "/tech-academy-apac/static/4d228d56bd5a97002d21bd091ca5e8af/3cbba/es-5_1.png 1152w", "/tech-academy-apac/static/4d228d56bd5a97002d21bd091ca5e8af/26482/es-5_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Open the `}<strong parentName="p">{`es-demo-setup-job-???`}</strong>{` pod.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACBElEQVQoz32SWW/TQBSF/csBVdCkpK2QKsQbQjwhwd8AHqBK0zXxvi/jfcNxUnK4M22CFRZLRzO+nvude+9YOpmM4SQFTNtDVbeIkgx+yOAGEUKWwPEjsecxP4ph+yH61QrbZ72+R1zWYGWDou0gPXn2FOc3C1zOFRh0+IL2325lfL2e48vsCp+nl7iRNRH7fqfgitT+6HbAvu9RNy2W/QrL1RrSweGh+LAk16Qo0LQt4qpGQwfjukTVdehIYZqhowT+bEj3m43Qz0fwhvZc0ujoJVhRI6BWzYDBCGLoXkiKYNHeZSmsMIZD8uIMhqrDMUx4lo3A8eBqBgzbhxkmlB9DGk+O4cQFNDckGINKq0KSnYBGwOCRUVJV6JY9rQ2U6QzmfA57IUO/ncO4mEGjkWhBAo2KkA5ejOCmJWRymSmmAERZgZBkRyl8es9pBHxGPKY6PhTLhWy6uNNtLEj6+RQ6FaFTAdLz0RE8Ai4sn4auwU1SpHRrfpKLFsIsp/eKZtsJoEZJOh8LyXhceXe8OgEcT07Eb8MDFs1BdSPR8sJ+aDkhWEbiN8vy8iGRpA3EQcKIA49PXwmgOnDZigMduhQ/zcGyUlS8A2zB/OwALJ29fkOXkv8GDl1pVbncSHxXB/F98x3w7bv3sFn2Zwt7CfuJ/4pLHz5+ghVlf3UdHvyf4TD2C/OsbYNixFG8AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 5 2",
        "title": "es 5 2",
        "src": "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/3cbba/es-5_2.png",
        "srcSet": ["/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/7fc1e/es-5_2.png 288w", "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/a5df1/es-5_2.png 576w", "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/3cbba/es-5_2.png 1152w", "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/26482/es-5_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Open the `}<strong parentName="p">{`LOGS`}</strong>{` tab.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACFUlEQVQoz4WTW2/TQBCF/T8pkKQJCMEDQjwg+B99oVxLUkRCkqpNW0QoEm8ICcFDeACRtrnZaWI7vqzj9do+zG4uBRrBSkfjHa8/+8yMtUI+h+3XdTzbKuJt8wi94Rj94QidgYHTnoGOMcTY8+FMOSZBCNvxYHtsqY9fv+HDpy/43PoOc+JCu7S2ho3NJ9h4+Ai1xj6MsY2TvoH+mQl9ZOGUZJoWej/b0FstjI6PYfoBTAKbro92T8ePTh8ngyEsymmXMxm8e3+E3cYeDptNOHTYZgG8kGPKIzDSlPaTbgeuriOY52WUiuIYIk4QiZieZdCyuXWU67sovaqg3jgAm4ZI6NBiCSHACZDgHytNVfCCKQHXCyhRDR+/2CbLhwroM0ZvFJDHokiQCJgkSKXo4b+VzKPHCHglk6Wm7GDzeQlb5ZqywYJAAeVyyUZXP8OE6iVXsgI4E2bAq1nqclUCi3j6sqK+MORcHVI2qH6yUTL+bynLuXxBjY20vLP/RiUXNjlFTlEIWfgY4TJ3UfKeSw3V8teuL4HVvQP4NGsOF6Ro3sGZInF+/bv4/CULN9qNm7dQqpwDZQ19smz9YTFdrZTGJeIYWzbanZ4ql3b7zl0C1pZAmWQ8RNemgWY+rMCnPTUqjC7Ip79HgjlBjdGY9lTDe/cfoFiuLoGyhtKKHTAMHBd920VAQDk28QolaTL/YpoIcvULUNdwxEWkmf8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 5 3",
        "title": "es 5 3",
        "src": "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/3cbba/es-5_3.png",
        "srcSet": ["/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/7fc1e/es-5_3.png 288w", "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/a5df1/es-5_3.png 576w", "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/3cbba/es-5_3.png 1152w", "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/26482/es-5_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`You should see a failure that statefulsets.apps is forbidden.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACX0lEQVQoz42T208TQRTG9/8UlavG6IOJPhj9P3gBbwjFWKFtuGvFaIyJoigBEQmXdgvd+3232+22+/nNAo0vJE7y5cyZnfObM+fMSmOjw5idK+P5ixm8ra6joZk4UXTUT1UcN5qoKxpMP4AbRHAo2w9heUEu4X/Z2sXHjZ/4/mufaz6kKwMDGJ98ivGJxygtLUOzHJyYDhTLhcNgxfFgM9CgFZAgbiPupIjaSQ6sNTUc5gfrsFwCrw4O4t37dSwsLmKtWoXJxYZuwglbqH7+ho3fB1D8CHuqiYYbYJN++c0HfNrcgSYO4X4vinOZ9KWh4REUywsovCqisrQKg0G6w00Ebu3u41A+QdztwWdmYdKhf4qvP7ZxxKxa9COutyg/jAgXwJExFFjDJ9OzKC+v5jVyz2slhmUa0FQVuqYhDAJk3S4uRtbrIct66HEtpewghHRtcIhNqWByqoDpYikHCYn6JJ0ODMuC5TjMIESbGQnFSZKrze9ij5gn7TZsRYV0fYhdnq9gYmoGz17OncEElMAOg01Zhl6vwWrI8DUVCeFd30N6Ic9FN+Jhcg3GwQGk4dGx/NmIK1dW1vpA0ZQOs5J3tlH7swfl+Ai6XIfHq/u6Dk/XEBh6Pg95i0hpwjJMSKM3bvaB84sr/euKDNM0hcrsDGYnQI6iwGk24apKPhdWyNe1XJbtQLp1+w4Kr8+ApaV/gLQpu2uKGto2fDYkYMa5jaK+QqrF+kVxDJvvVLp77z6BpUuAXcTcGDFI2BZtyiZkWYYeO3yh7Nza4k958PARZorzlwL/d4hDHP6ifwHVfGGJ6Pb1MQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 6 1",
        "title": "es 6 1",
        "src": "/tech-academy-apac/static/e56898db5bb53ff1bd26993850fd84ea/3cbba/es-6_1.png",
        "srcSet": ["/tech-academy-apac/static/e56898db5bb53ff1bd26993850fd84ea/7fc1e/es-6_1.png 288w", "/tech-academy-apac/static/e56898db5bb53ff1bd26993850fd84ea/a5df1/es-6_1.png 576w", "/tech-academy-apac/static/e56898db5bb53ff1bd26993850fd84ea/3cbba/es-6_1.png 1152w", "/tech-academy-apac/static/e56898db5bb53ff1bd26993850fd84ea/26482/es-6_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Let’s fix it! Back to the terminal window, go to the `}<em parentName="p">{`multi-tenancy-gitops-apps`}</em>{` folder and edit the file below.`}</p>
    <pre><code parentName="pre" {...{}}>{`cd ../multi-tenancy-gitops-apps/
vi sko-sample/eventstream/es-demo-setup-job-sa-role.yaml
`}</code></pre>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`In the Rules section, create a new rule with the content below and save the new YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- apiGroups: ["apps"]
  resources: ["statefulsets"]
  verbs: ["get", "watch", "list"]
- apiGroups: ["route.openshift.io"]
  resources: ["routes"]
  verbs: ["get", "watch", "list"]
`}</code></pre>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "49.30555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABfUlEQVQoz42S23KaYBSFfYRedCbhKAKxUEGxWsQgB2UUknRMT7bT3jQ3ef9H+LKhTg/T1ORiz7r59zdr/Xv1iqJgtVoRBEE30+mU8XhMFEWEYchgYKHrOoZhnBxVVfE8j15T19S7HW8E1ALOz85QlHNURUGTR6ZpYJmmqIlx1MemhbqOQ29xmRIvl4TiKJrNCCYRo/EEPxB37gWKuHup6Wiy0D8uPgZsU7iuS+/7puT+/S1fRe+ur/hx3XAocurphMR1mDk2h8Dj8+gVTr+PfgroCPBbteGmadgKpNlsRAvyZEEUBkTyf4eRx60/5EJgpyL/An7MV1RVRbZMKLOMdZ6RzGfdUWLXJhToC1X7r7N/gHfbikNZ8KXM+ZSt+JBechPPebeIuZLYgcQ2noD9BcwkYiq1eRvHvJbauMMhlm3TtyxMa3CM+Uxge5Tddkst1ZnLhZPFouuhLcD2gdk5exrWAQ39Z23KsmS/37Ner0nT9DfsGZA/R9M0fN/nAaxXJVvjC9IkAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 7 1",
        "title": "es 7 1",
        "src": "/tech-academy-apac/static/e3845618a9a0b3c638d0d07744cde781/3f968/es-7_1.png",
        "srcSet": ["/tech-academy-apac/static/e3845618a9a0b3c638d0d07744cde781/7fc1e/es-7_1.png 288w", "/tech-academy-apac/static/e3845618a9a0b3c638d0d07744cde781/a5df1/es-7_1.png 576w", "/tech-academy-apac/static/e3845618a9a0b3c638d0d07744cde781/3f968/es-7_1.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops-apps folder: Add, Commit and Push the changes to multi-tenancy-gitops-apps repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`git add .
git commit -m "adding rules"
git push origin
`}</code></pre>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Back to the argoCD console, refresh the `}<strong parentName="li">{`eventstream`}</strong>{` application. Maybe you need to wait few minutes to make sure that all the status are Sync and Healthy.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB80lEQVQoz31Sa2/TQBD0LwdUQZOSFiEhxDeE+IQEPwIhUdQCogFKkzgm8evsu/jtOn7kMexd0+BGBEujXZ93Z2b3rJ30urCDBFPLRZYX4EEE5gs4HocvAtiMq5zJfKRDv+ijyjLIZ71eY7FcYpbmEOk1kqKEdu/BfXy9HKI/0DFhPi4oPyd8+jnAaf8HPn77jsvhGJ+vdJydnuH8/Qckg18AEcmnrhvk13NUFKtmAe3g8FB9qJoaYZqiLCtExRxZVUFkCfKqRNM0EHGCYnFD0qQJanK5XAOr1WrrVkLrHD2GSHJ4NOrUE4QZOeWYuBwm5Y4IYfEADsGlfMoEWJTCj1MIiiyIqf6mT0Lr9o5hzxIYjo8JEeoUJUa2pwpdEgrIzbysEdCudNuHvREwSdj0A4xJ3NhAO3jUgROmGFkMfX2qCHiUwCdYPCQHEeI8R0k78kMSJhHDFRiT6NDylMBvdcZV1B52juAS4dBk+HJlwAlC2mUOdxapEfwopvcMOe1VEW4aJSabeOtOEXZ7J+q3kQfKvsPVyFJdNgREFhGKeUkXk94hbBNtCY+fPFWEcoR28a0Dmy6ChTGtIVWOdwna5Irw2fMXdCnxX8IdVQnpui1oML6f8OWr17BEtG3e52C3cd+59ubtO5g8ukP2r8L/CbbP/gBfdG43sXsp1wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 9 1",
        "title": "es 9 1",
        "src": "/tech-academy-apac/static/eac25440874ff6e7cdac171ae42acc0b/3cbba/es-9_1.png",
        "srcSet": ["/tech-academy-apac/static/eac25440874ff6e7cdac171ae42acc0b/7fc1e/es-9_1.png 288w", "/tech-academy-apac/static/eac25440874ff6e7cdac171ae42acc0b/a5df1/es-9_1.png 576w", "/tech-academy-apac/static/eac25440874ff6e7cdac171ae42acc0b/3cbba/es-9_1.png 1152w", "/tech-academy-apac/static/eac25440874ff6e7cdac171ae42acc0b/26482/es-9_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Now you need to delete `}<strong parentName="li">{`es-demo-setup-job`}</strong>{` to re-run the pod. Open the context menu in `}<strong parentName="li">{`es-demo-setup-job`}</strong>{` (A) and select `}<strong parentName="li">{`Delete`}</strong>{` (B).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+0lEQVQoz4WSbW/TMBSF88sBTbB2dENICPENIT4hwd8AJBiCMkbXZmmbN8fOi5M0aZOmTQ/XLi0QIYh0ZOf6+jn32jYuBn24cYa542NRLCFiCcZDeIEAD2O4TOi5ijERwWEc66bB4dtstojyAmFeIltWMO7cu4tP12MMb0zMKPkLzT+Q3n+7wbvhFd5+/orrsYWP3ye4JF2NTCyr6ghU8KJcoV43qJsNjJPTU71QN2skeY6qqiGXKyzqGlGRo1zXaGhTmGao2p3ObXc7bLYtaYu2bXVsRzElo3f2EGFWIKBW50FIiqhSgZkvYNPcDxM41KofSdijMazbGTya8yQlkxwsTil/v0/J6A/O4UYZLI9jRkCTRqWJG+hEn4xiVfl6g2A6A6PzlNSFyyPYZGzzGLdkbv2UcfKgBy/JMXEYhuZcA4TMwEmOSKgCibQoNDAJOErfQ8n3hhMngOlyTMlYwdRo3O+dwSfg2Ga4HFnw4oTOstAtqha4TOl/gWJVIWIBmGnqSqeqA1o/wI7A/uBCPxsV0OV7Qrc8dvYtxwSTiwVKehIRPQ2LqrYoz+qAjsDzR4818JYgh+BBCujSpTC6ACFzfWk653BmKq8LfPL0GV1K+gvYcVVSVXcNu+ZH4PMXL+GE8ri520JX/4sbr16/gS3kH7C/Jf7L8PfYD/nKbz9Yd0INAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 10 1",
        "title": "es 10 1",
        "src": "/tech-academy-apac/static/866af58b3498c73687fb47d02179bdd6/3cbba/es-10_1.png",
        "srcSet": ["/tech-academy-apac/static/866af58b3498c73687fb47d02179bdd6/7fc1e/es-10_1.png 288w", "/tech-academy-apac/static/866af58b3498c73687fb47d02179bdd6/a5df1/es-10_1.png 576w", "/tech-academy-apac/static/866af58b3498c73687fb47d02179bdd6/3cbba/es-10_1.png 1152w", "/tech-academy-apac/static/866af58b3498c73687fb47d02179bdd6/26482/es-10_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Enter `}<strong parentName="p">{`es-demo-setup-job`}</strong>{` (A) to confirm the deletion and click `}<strong parentName="p">{`OK`}</strong>{` (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACCElEQVQoz6WS2W7TQBSG/bCkcMGLFAmhwCVv0jZOSsUiUhW64NaOl/E6XuPExHGcxPk5Hqeh3FXi4tM/51jzjWeRRkMZzPVhMRt+wOG4HmzHhW07cCgZZYvo7eswjBDHsSCKIrh+0EHzpZPTEzxMdGi6Acu2oE1UqlXcayoU7R6KqkDXNdF7oJwQYeghTUKCkzBAwLkQc1pIOh0MkKYJeJTC4RX8qIbNazjhGoxqN1ojiDZgQQWPMp4CPNkeCBPqJRkS8bcxpIEsw/ETuOwS/s8e/OtXSH8ddSgvkREJjeO7HmWvS8ER1S/Ab17DNK5hOhwmHYck0xmabgRm/UAdf8SKf0DpHhNvsHCOD9T8LTYt0Ttskz42cR9N2kcZvIdu3MKwAxiMhGcDGZbjwHIz1MU5ZkyFcWXDUzzEOm1jQodPTK0MczbFcgMsG6DcAhVlsQJ05sIkmUEpncmt0CMhRzX7jLIMkBcL5HmCeZEjn2Uip3mGfD7FvCxQViWqeonVukKxmEO3GG3X7YTycNQJ6UnQoohNG+rtHX43O6ybBvW26XLParsVdctmt0O5qkho/xUOR+ck88X+wySGrii4GV/CixME9AwCurkgesyndD2P3t4/wk8XF+Jht0LNsKDTB5PqCY21ZzAxmZjbCelSvnz9Jrb82BQ8HT+b/aV8H48Pwv+hleqUfwAQ0GO34kVoPgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 10 2",
        "title": "es 10 2",
        "src": "/tech-academy-apac/static/d288c2de206c7fb28e6712adf5144d8b/3cbba/es-10_2.png",
        "srcSet": ["/tech-academy-apac/static/d288c2de206c7fb28e6712adf5144d8b/7fc1e/es-10_2.png 288w", "/tech-academy-apac/static/d288c2de206c7fb28e6712adf5144d8b/a5df1/es-10_2.png 576w", "/tech-academy-apac/static/d288c2de206c7fb28e6712adf5144d8b/3cbba/es-10_2.png 1152w", "/tech-academy-apac/static/d288c2de206c7fb28e6712adf5144d8b/26482/es-10_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Wait few seconds to recreate the job and pod. When ready, click on the `}<strong parentName="p">{`es-demo-setup-job-???`}</strong>{` pod again.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACBElEQVQoz32SWW/TQBSF/csBVdCkpK2QKsQbQjwhwd8AHqBK0zXxvi/jfcNxUnK4M22CFRZLRzO+nvude+9YOpmM4SQFTNtDVbeIkgx+yOAGEUKWwPEjsecxP4ph+yH61QrbZ72+R1zWYGWDou0gPXn2FOc3C1zOFRh0+IL2325lfL2e48vsCp+nl7iRNRH7fqfgitT+6HbAvu9RNy2W/QrL1RrSweGh+LAk16Qo0LQt4qpGQwfjukTVdehIYZqhowT+bEj3m43Qz0fwhvZc0ujoJVhRI6BWzYDBCGLoXkiKYNHeZSmsMIZD8uIMhqrDMUx4lo3A8eBqBgzbhxkmlB9DGk+O4cQFNDckGINKq0KSnYBGwOCRUVJV6JY9rQ2U6QzmfA57IUO/ncO4mEGjkWhBAo2KkA5ejOCmJWRymSmmAERZgZBkRyl8es9pBHxGPKY6PhTLhWy6uNNtLEj6+RQ6FaFTAdLz0RE8Ai4sn4auwU1SpHRrfpKLFsIsp/eKZtsJoEZJOh8LyXhceXe8OgEcT07Eb8MDFs1BdSPR8sJ+aDkhWEbiN8vy8iGRpA3EQcKIA49PXwmgOnDZigMduhQ/zcGyUlS8A2zB/OwALJ29fkOXkv8GDl1pVbncSHxXB/F98x3w7bv3sFn2Zwt7CfuJ/4pLHz5+ghVlf3UdHvyf4TD2C/OsbYNixFG8AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 5 2",
        "title": "es 5 2",
        "src": "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/3cbba/es-5_2.png",
        "srcSet": ["/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/7fc1e/es-5_2.png 288w", "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/a5df1/es-5_2.png 576w", "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/3cbba/es-5_2.png 1152w", "/tech-academy-apac/static/a176b48e6f3103da05914fa1633dea84/26482/es-5_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Open the `}<strong parentName="p">{`LOGS`}</strong>{` tab again.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACFUlEQVQoz4WTW2/TQBCF/T8pkKQJCMEDQjwg+B99oVxLUkRCkqpNW0QoEm8ICcFDeACRtrnZaWI7vqzj9do+zG4uBRrBSkfjHa8/+8yMtUI+h+3XdTzbKuJt8wi94Rj94QidgYHTnoGOMcTY8+FMOSZBCNvxYHtsqY9fv+HDpy/43PoOc+JCu7S2ho3NJ9h4+Ai1xj6MsY2TvoH+mQl9ZOGUZJoWej/b0FstjI6PYfoBTAKbro92T8ePTh8ngyEsymmXMxm8e3+E3cYeDptNOHTYZgG8kGPKIzDSlPaTbgeuriOY52WUiuIYIk4QiZieZdCyuXWU67sovaqg3jgAm4ZI6NBiCSHACZDgHytNVfCCKQHXCyhRDR+/2CbLhwroM0ZvFJDHokiQCJgkSKXo4b+VzKPHCHglk6Wm7GDzeQlb5ZqywYJAAeVyyUZXP8OE6iVXsgI4E2bAq1nqclUCi3j6sqK+MORcHVI2qH6yUTL+bynLuXxBjY20vLP/RiUXNjlFTlEIWfgY4TJ3UfKeSw3V8teuL4HVvQP4NGsOF6Ro3sGZInF+/bv4/CULN9qNm7dQqpwDZQ19smz9YTFdrZTGJeIYWzbanZ4ql3b7zl0C1pZAmWQ8RNemgWY+rMCnPTUqjC7Ip79HgjlBjdGY9lTDe/cfoFiuLoGyhtKKHTAMHBd920VAQDk28QolaTL/YpoIcvULUNdwxEWkmf8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 5 3",
        "title": "es 5 3",
        "src": "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/3cbba/es-5_3.png",
        "srcSet": ["/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/7fc1e/es-5_3.png 288w", "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/a5df1/es-5_3.png 576w", "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/3cbba/es-5_3.png 1152w", "/tech-academy-apac/static/3144d6ff33063951fcb079d68254577c/26482/es-5_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Great! Now you should not see any error message.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACd0lEQVQoz21Sa08TURTs/xSV8tAY/WCMH4z+D76AL4RirNA2PArRQjQYo6JRhIgSsdst3dfdR3e73W5f49zbSGJgk0nOOXt37syczUxPTWBpuYinzxbx6vU2dEugbtjQTk380RuoGRZE2EIQxfAJj7XbjBRk/+HbId5++orPh784C5G5NDaGmbnHmJl9iML6BizXR134MNwAPj82ghBeK4bjh3DZR0mKpNdHnHbht9qoNmz81g1ohgOXZzOXx8dR2dnG6toatioVCA51W/BwgsruR+wdHMH0mzg6taDzki8HP1Esb2OXqizhwaWAZhihSbWC5zLZiUnki6vIvcijtL4Jh4R2wAOUv/fuPX7sf0foOBCGAc+0VL+78wZH+wcILAtBo4GA79xaDa5wSTg5jRwzfLSwhOLGpsooiBN4VDlM2rzVg2mZsG0brVYLg+EA/57BcDgC6zbPCV6YuTKe5VJKmJvPYSFfUIQes/EcF2kYwhECgghZdzodhSRJFFLWEp00pQt7RHg1yy2vlDA7v4gnz5cVoa8IBdIoRERVgc+cmk3EcYxer3emcEh1w8FIsVToSMKJqWn120jLpfLWf4TdKEKD+TjMMAgCpVLajjiXM1VzFrKXeSqFU9eunxGurJXPEWoM+/j4GCcnJ9yoq1RJuzXONU1DvV5HTddhVqtwLRuZGzdvIfdyRFhYL5+zbMsNE1KRw8VIy/1+f6SMMUi1Ef9Tn06Uwtt37pKwcCFhl5YatOLTroRwPRjsZa4myQMS9plhygvazFnwXebe/QdYzK9cQOii6wqYNQ39uMWNN+EZDZhaFVw1bL2mFsE1Eyn6rD3bwV9uD1xOBn39+QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "es 10 3",
        "title": "es 10 3",
        "src": "/tech-academy-apac/static/f470c9afb0e8aafa923e165d892edf19/3cbba/es-10_3.png",
        "srcSet": ["/tech-academy-apac/static/f470c9afb0e8aafa923e165d892edf19/7fc1e/es-10_3.png 288w", "/tech-academy-apac/static/f470c9afb0e8aafa923e165d892edf19/a5df1/es-10_3.png 576w", "/tech-academy-apac/static/f470c9afb0e8aafa923e165d892edf19/3cbba/es-10_3.png 1152w", "/tech-academy-apac/static/f470c9afb0e8aafa923e165d892edf19/26482/es-10_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`7 - Configure ACE`}</h2>
    <p>{`Now, let’s work with Application Connect Enterprise. In this part, you are configuring artifacts, secrets and certificates.`}</p>
    <ol>
      <li parentName="ol">{`Back to the terminal window. In `}<em parentName="li">{`multi-tenancy-gitops-apps`}</em>{` folder, open the folder below.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`cd sko-sample/ace-00-configs/
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Execute the commands below to generate the configuration YAML files. Where:`}
        <ul parentName="li">
          <li parentName="ul">{`SF_USER is `}<em parentName="li">{`[Email addess used to log into Salesforce]`}</em></li>
          <li parentName="ul">{`SF_PWD is `}<em parentName="li">{`[Password used to log in][token received in email]`}</em></li>
          <li parentName="ul">{`SF_CLIENT_ID is `}<em parentName="li">{`[Consumer Key]`}</em></li>
          <li parentName="ul">{`SF_CLIENT_SECRET is `}<em parentName="li">{`[Consumer Secret]`}</em></li>
          <li parentName="ul">{`MAILTRAP_USER is `}<em parentName="li">{`[Mailtrap SMTP User]`}</em></li>
          <li parentName="ul">{`MAILTRAP_PWD is `}<em parentName="li">{`[Mailtrap SMTP Password]`}</em></li>
        </ul>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`./06-ace-config-barauth-github.sh
./07-ace-config-policy-mq.sh
SF_USER=<my-sf-user> SF_PWD=<my-sf-pwd> SF_CLIENT_ID=<my-sf-client-id> SF_CLIENT_SECRET=<my-sf-client-secret> SF_LOGIN_URL="https://login.salesforce.com" ./08-ace-config-accounts-sf.sh
./10-ace-config-policy-es-scram.sh
./11-ace-config-setdbparms-es-scram.sh
./12-ace-config-truststore-es.sh
./13-ace-config-policy-udp.sh
./14-ace-config-policy-email.sh
MAILTRAP_USER=<user> MAILTRAP_PWD=<pwd> ./15-ace-config-setdbparms-email.sh
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Verify that there are 9 YAML files generated in the `}<em parentName="li">{`ace-00-configs`}</em>{` folder.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`ls *.yaml
`}</code></pre>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "587px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "17.013888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAoUlEQVQI1z2OuwqFMBBE8xEpjYKkiGKnkETBR4LGBynz/58yl93iFgO7w9nZESEEXNeF53lw3zfPKSU457CuK4ZhwDRN2Pcd53mytywLi5i+79G2LZRSqOsagsAYI77v4yCa6YlzlkEpJbqu4zB6mnNGKYV58rZtg7UWTdNwqDiOg1u97/sPpKbee4zjCGMMHxA3zzO3op18rTWqqmJRO9IP0v1jUTpfh8wAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace 3 1",
        "title": "ace 3 1",
        "src": "/tech-academy-apac/static/653c46b61b73856e573609c5d7f05858/756e2/ace-3_1.png",
        "srcSet": ["/tech-academy-apac/static/653c46b61b73856e573609c5d7f05858/7fc1e/ace-3_1.png 288w", "/tech-academy-apac/static/653c46b61b73856e573609c5d7f05858/a5df1/ace-3_1.png 576w", "/tech-academy-apac/static/653c46b61b73856e573609c5d7f05858/756e2/ace-3_1.png 587w"],
        "sizes": "(max-width: 587px) 100vw, 587px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Edit `}<strong parentName="li">{`multi-tenancy-gitops-apps/sko-sample/ace-00-configs/kustomization.yaml`}</strong>{` file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`vi kustomization.yaml
`}</code></pre>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Uncomment the lines below (all the content). Then save and close the YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- ace-config-accounts-designer.yaml

- ace-config-policy-es-scram.yaml
- ace-config-setdbparms-es-scram.yaml
- ace-config-truststore.yaml

- ace-config-policy-udp.yaml
- ace-config-policy-email.yaml
- ace-config-setdbparms-email.yaml

`}</code></pre>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "697px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "49.30555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABsklEQVQoz31S2W6bUBT0V1S1WQzmYlYbDDZgNoFNo8iq1b62/9D/f5zOvcFRlER5GJ3DETN3zrL493TB3+uIWxJj2AqMnkAvbPSOjc6xmG9eo6xJtMzvwRZ728JS12EaBlarFXzfx+K5qVH0PbpxRFE3KJsG4X4P293Cj2NYQsCLXqLwA1X7btlKLN3YWFFsbZowGIXjYDHlB6RZhqookGcHFKcT0iSBS4EwCLB1XQXbslQMPA/Geo0jnb4V1OlUkLO4nSscqwr1+Yw8z1HXNdq2xZnfGR+KoggWxTYkSxcGibLN3NkgeS/oUPDeNmiHAdfLBSPb7tn+NE0oyxJ7th6GIRLG3W6nhE2SlxSRgulngs9lgbrr0BMDhaW7io4Paapa1DWNP2sqmjP5IfipwxuXUtFVT7FatsqlNBR351lpJOgkaBIyJ76RfJhnuHwv+Gfocbte8Gu64vfTD9yZ/xzplAuKSYi4zbeICc9ao3Odjw7lUgrhIDV1nPiizAve2IkoXaFqR5JkfOA4x4x1S54LIeeqG/rL2eySFCU3K1taqg0aM3T1+ld4iElonHHAM/sPHlwn4bGdsCcAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace 5 1",
        "title": "ace 5 1",
        "src": "/tech-academy-apac/static/eb47c4f5034e6b0630c772fc85a92e46/3f968/ace-5_1.png",
        "srcSet": ["/tech-academy-apac/static/eb47c4f5034e6b0630c772fc85a92e46/7fc1e/ace-5_1.png 288w", "/tech-academy-apac/static/eb47c4f5034e6b0630c772fc85a92e46/a5df1/ace-5_1.png 576w", "/tech-academy-apac/static/eb47c4f5034e6b0630c772fc85a92e46/3f968/ace-5_1.png 697w"],
        "sizes": "(max-width: 697px) 100vw, 697px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops-apps folder: Add, Commit and Push the changes to multi-tenancy-gitops-apps repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`cd ../../
git add .
git commit -m "ace config"
git push origin
`}</code></pre>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Now, go to `}<em parentName="li">{`multi-tenancy-gitops`}</em>{` folder and edit `}<strong parentName="li">{`multi-tenancy-gitops/0-bootstrap/single-cluster/3-apps/kustomization.yaml`}</strong>{` file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`cd ../multi-tenancy-gitops/
vi 0-bootstrap/single-cluster/3-apps/kustomization.yaml

`}</code></pre>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`In the SKO sample apps section, uncomment the lines below. Then save and close the YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- argocd/sko-sample/ace-00-configs.yaml
- argocd/sko-sample/ace-backend.yaml
- argocd/sko-sample/ace-evnt2mail.yaml
- argocd/sko-sample/ace-fwdmqevnt.yaml
- argocd/sko-sample/ace-mqapidflt.yaml
- argocd/sko-sample/ace-mqapiprem.yaml
- argocd/sko-sample/ace-sflead.yaml
`}</code></pre>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops folder: Add, Commit and Push the changes to multi-tenancy-gitops-apps repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`git add .
git commit -m "ace config"
git push origin
`}</code></pre>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Back to the argoCD console, go to the `}<strong parentName="li">{`Applications`}</strong>{` dashboard. And refresh the `}<strong parentName="li">{`03-Application`}</strong>{` application. Maybe you need to wait few minutes to make sure that all the status are Sync and Healthy, before progressing.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACjUlEQVQoz3VTS2/TYBD070blAEKFihbBCbgiOEIPHBGqaITapI+kKU1CYqd24vgdv99OMoy/nPmklaXx7n6zO/NJx0eH0AwbS8OCbtpYmQ7DRlM32G62InbbHbaM/5283iDOK8RZDunJwQEu7sboXN+JOLse4Od1H+PlChN9hRkvWrhrKI4Lde1D9/dhhqEIPQgwth1MLAcKv9LTZ89RVA2COGFkuFlpGJgLjDwT47WFoa2j8zhFT5PRNzQ8EBfYfIoLVUaP8ccx0LeWGC41SMcnb1A2G5RlyYYpZMNAkRdISb8uKzS8THMdZGmGJE1REUOzJWsXcZIiDGPkzN2xR8R66fXxCcI0RJbnSPMSsm2hrCqsOU6UJMRyPHousqJAkLRTxMwtoBGL8oy7yxESS7IMPqeUXr464lp3UNQlRrKKmWXC8dZCmJJsdtRC4SW2u8dSFrbnkQxNx4EuzxFEscCiJIP0gg0XSYl73YTq+ugz4ezyFudXAyypeMVRRgsd570BfvX6kDUdNTHFstHp3uDH6Xfcd36jpBvcIIJ0yJFvbR+3lgc1TLhDEz5vzMmuDT8iZppw/YDjF8irWjBp8yxiMcfMqXTIr70OIJ28fQcvCmCz0GPi1DS4bP6kNdrx2n0qjs2xIjJgAwrTevSR43pRCI+7DilYxbzWKdL7Dx/RbDZMqgWbOYvrphaFNbGSjFQK0DZuF9+K13DkhechLfduEI7gJQFVlz59/sI9bVGxOExzDFUV49kcsrpAQSu156+xEth0rtEayV4UMnyQFUwVFS4NL0QhU+nrt1MU7F6UlfDhkAmXgxGu7idQVzatkGLCV9MdjkXMFiuByXxBXeZ0+cpGioZ1lML0fPwD8EF3oPfcjC8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace 10 1",
        "title": "ace 10 1",
        "src": "/tech-academy-apac/static/768adfe6a3873c5d13352298147d58b1/3cbba/ace-10_1.png",
        "srcSet": ["/tech-academy-apac/static/768adfe6a3873c5d13352298147d58b1/7fc1e/ace-10_1.png 288w", "/tech-academy-apac/static/768adfe6a3873c5d13352298147d58b1/a5df1/ace-10_1.png 576w", "/tech-academy-apac/static/768adfe6a3873c5d13352298147d58b1/3cbba/ace-10_1.png 1152w", "/tech-academy-apac/static/768adfe6a3873c5d13352298147d58b1/26482/ace-10_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   When completed, you should have `}<strong parentName="p">{`34`}</strong>{` healthy applications (A), including `}<em parentName="p">{`ace-sflead`}</em>{` and `}<em parentName="p">{`ace-evnt2mail`}</em>{` (B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACkUlEQVQoz3VSyXLTQBTUd1PhQA5AiiSVEwVXCo7AD1CQmNgJXogtL7KNbEmWFy1WLFm7ZbtpTYojU9WlmdbMW7qfdH72EsbShrm0MF/ZWFgO4aIo9jgcjgLHI8DPf1dSHBCmO4RxCunZyQnuOgp+NjuEjO+/Wvh234CiGwJjcw7DsjBZrqA7DuaESSzXawHTdTFYLKHMF1BXFqTnL06R5gU2YYTNJkBz0EZD6eBh3ENPG4nvdaeOmtzCffc3OuoA7ZJr11GVm7gjL08UNIYyun0Z0vnFJbLdntjBd9eY6DoTcL8NsdsV2LOdmechZjs+k2bZjv0DpveIMEkQkEvSDMf9AZFlQ3pzfgE/8hGTjHwfqqGJ4B73QRiST6G5DmI+9rdbbIIAKe8aaxdBHIk7JRfHMfzVCtKr12fA8YCJMYfSH+KPrsHxNnBcj8YUQnTVtmCz+pJLmKBcZcCF4woujGLBhTYrPGXAWVqgZ3swVg7avT5+1NuotmSYdDxj24PZHDfkSuPU2QI5JZrQgArPlUYbfVVHxqq9mQnpihrW5T7qfQWT4UhouA62T9pkOR6DkO6tsH70ud8KLghjqHTd2fjwaGSU5vD9AA7fSleXl7DVIZbTKWyibDmIIqw4DhF1yRhg6thCJ2vtCc0KVq1xdLzAh0XDyn95nj9p+Pbde+zZf6nWhtpNZzqK/R4BXf4XUKdeWZaJc8hkOadgxhmM0kSYVXJpkiIo5/DDx09Ck5wGBKygOx5xoE26vUDCh+Ua0xRlyiHX56w+EZzGyvpTHWPNhMu2hSmsWvr85StStlDO3oY6PTRbuL2+xV2lBpW6OsYMPbmL6s0tajdVDDtduORG/QFqlargu60H2JqOxWiMv8QkcQDQ8D6fAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace 10 2",
        "title": "ace 10 2",
        "src": "/tech-academy-apac/static/71aaaececd624bbbb5b388786f88495a/3cbba/ace-10_2.png",
        "srcSet": ["/tech-academy-apac/static/71aaaececd624bbbb5b388786f88495a/7fc1e/ace-10_2.png 288w", "/tech-academy-apac/static/71aaaececd624bbbb5b388786f88495a/a5df1/ace-10_2.png 576w", "/tech-academy-apac/static/71aaaececd624bbbb5b388786f88495a/3cbba/ace-10_2.png 1152w", "/tech-academy-apac/static/71aaaececd624bbbb5b388786f88495a/26482/ace-10_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Back to Platform Navigator, open `}<strong parentName="li">{`App Connect Dashboard`}</strong>{` (Menu > Run > Integrations).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACXUlEQVQoz4VSS08TYRTtTyDFvmBa6bTEEhM1RMoC925x4QZ5hJWJib/CmLjw17g2BMUUSHiEHTtLn9Nh2nnP9JvO9HjvF8pCEr3Jyc1MZs49956Ter36ApVqFSsrKyiVStjcfIP9/X3s7Oxgd3cXe3t7Evy8vb39APz+3dYW3n/4iE+fvyBVrlSgLi9DVVWUy2WcnV+CKwxDCCHg+z48z0Mcx/hfCREhtVZ7gqdFBen5eSwuLuL7wQ9YToBev4/h0CAM0el0JOl4PMZkMkGSJHIAd8Y4ShAIIAgFUs+rFawuV5HJ5STh2fmFnBbRj0wQBAGm0ykRJFKtaZqIokgS8hau68phge/Btm2knqllvCSV1YUCCgsLODk9AcnAlNYVkYA5GhGpjzgKpDp9MIDjOHcrCiJ0JKnrerAs605hRUUpm4VSLKJxfIowCCV8wsi0CLYkD8Mx/WSTSktuEJBCh4hYoQg9GkSEKjn8uKziUSYDRSnh4NclDFugpZnoDCz0hwH6VgzdiWEFCSw/gcnwYowIpjeBZk1w3UvQ0V1yeWkJtVoNebqhoihoNBryVrquwzCGuL01JHT9Fq1WG+12G91eD4OBjr6mwzF1HF0ZePvVxbdjUlgoFKQZGVLI/fBnA7YnoBumvBW7zLDIjGaziW63C03TqHdooCG/YTP4FNKUfD4PRpZuyMG+uLpGQgdnV7nYYY7G38UGPcwhxSadToMxNzeHHBHfE07/HWKOziyH93mkmKXW19fBqNfr2Nh4hYPDIzTbGn7Tenyvm5sbiVarJVeedV57tsEMnMs/WGwEZpZK0hsAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace 11 1",
        "title": "ace 11 1",
        "src": "/tech-academy-apac/static/ae9e4dd04f4febb75e3e9aacf33cbccc/3cbba/ace-11_1.png",
        "srcSet": ["/tech-academy-apac/static/ae9e4dd04f4febb75e3e9aacf33cbccc/7fc1e/ace-11_1.png 288w", "/tech-academy-apac/static/ae9e4dd04f4febb75e3e9aacf33cbccc/a5df1/ace-11_1.png 576w", "/tech-academy-apac/static/ae9e4dd04f4febb75e3e9aacf33cbccc/3cbba/ace-11_1.png 1152w", "/tech-academy-apac/static/ae9e4dd04f4febb75e3e9aacf33cbccc/26482/ace-11_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Open `}<strong parentName="p">{`Servers`}</strong>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABaElEQVQoz61RW0oDQRDca0aSkK+AiIgfXiI/bsw1RLyJ4AEUzNN972z2naTs6uzGBD8E40AxM93V1TU9VrfbxWAwwHA4RK/XU/T7fTB+gMQUx7EG5F90Ori8usbN7R2sx6dncCVJgizPUQjqzQYna7fDb6ve7nfr3h7rIadYUSAnogiZ6yD3POS+j/j1BWXggzUbaXaM7XarBspqf7Ymkwc14EshXaZZhng2hbtcIqZYQAQIpx8IwxDGGOURrInjGOv1WncassbjsXaaz2aIxBmTZrGAR3JipEGuTSLJO46jnDRNlUfB43tVVbBs29Yn+6HRYELB+RS+F4gzcSTuTBjAe3+DJyMI5O66rjpig4U05525siy/BemEHeq6RhFHMKsVUilIZZap84lMhDjfogG5mTinuzbGl1qj0aj5ZaNJhRAzIfDXT9DmG1CwFW1xEOQT2mGfgxNBzvBc/HD4V6G29l8E2zruX+0+bpYDQXzxAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace 11 2",
        "title": "ace 11 2",
        "src": "/tech-academy-apac/static/2d84d32aa6c89cdf9e9c5b9096b53aa0/3cbba/ace-11_2.png",
        "srcSet": ["/tech-academy-apac/static/2d84d32aa6c89cdf9e9c5b9096b53aa0/7fc1e/ace-11_2.png 288w", "/tech-academy-apac/static/2d84d32aa6c89cdf9e9c5b9096b53aa0/a5df1/ace-11_2.png 576w", "/tech-academy-apac/static/2d84d32aa6c89cdf9e9c5b9096b53aa0/3cbba/ace-11_2.png 1152w", "/tech-academy-apac/static/2d84d32aa6c89cdf9e9c5b9096b53aa0/26482/ace-11_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Check the Integration servers.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3UlEQVQoz42STYsTQRCG538mgVwSz4oHzyLIZA85iCCeRBAMguBF0POylxU86B4ED+ay7qJmunv6Y6Y/5rWqYrLrQsSGd7q6u7qm6qmuxuMxptMpZrMZ2B6NRphMJmIfEp/vNJ/PcWs+w+279/DgYY1qtVqBR9/3+N8xDANyzmJ/PjvD8fEJTk8/wFqL6tHjJ+yCRqm987/EI4QA5xxyKXj/7i1ePH+KN69fQqkG1XK5FKdIGaYU94rxsFJKpIySI1wEPp0DXy4BZTyqxWKBVICNsmhdL7K+l4uM4briNTsEQjREfPzqcedZwP1XHdbnigPWGCTDgN6ukXKCod8W2kzhArn/SbwGyWjIHZJbo5QkP6SK6eIFfX5Jla3RqOq6lkXXeTQbCkDl+i7/cdgQKw1GV+h2jD35XEpDdk0xeoO2NZKA1nqb4bbLkbrkBbyjgDyH0Mk+Dw7IQZzz3ENZ3/SRgEfEsKdD1WoEKttzpm0ra7ZZLjg0RkFbI2vrLQzZjWnkzLJoT9FL2ZccoyeG34gVQafSmE/03xG7H8S1oLUtNDHiLHg2xohkTTJU9t8B+04YlnLFRxhaLTa/O364h+Ss25Z8lWEkuG7Pivl4H4SRcKWALaHgyzzf1G7/N60AccDCcNpfAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace 11 3",
        "title": "ace 11 3",
        "src": "/tech-academy-apac/static/1d0594799a249b620fb1f4e6766f1338/3cbba/ace-11_3.png",
        "srcSet": ["/tech-academy-apac/static/1d0594799a249b620fb1f4e6766f1338/7fc1e/ace-11_3.png 288w", "/tech-academy-apac/static/1d0594799a249b620fb1f4e6766f1338/a5df1/ace-11_3.png 576w", "/tech-academy-apac/static/1d0594799a249b620fb1f4e6766f1338/3cbba/ace-11_3.png 1152w", "/tech-academy-apac/static/1d0594799a249b620fb1f4e6766f1338/26482/ace-11_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`8 - Customize APIC`}</h2>
    <p>{`Now, let’s create the Provider Organization and Publish the API in APIC.`}</p>
    <ol>
      <li parentName="ol">{`Go to the folder `}<strong parentName="li">{`multi-tenancy-gitops-apps/sko-sample/apic-cust`}</strong>{`.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`cd ../multi-tenancy-gitops-apps/sko-sample/apic-cust

`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Now let’s configure APIC to submit emails when necessary (e.g.: Portal Users registration). Run the script to generate the APIC mail secret using Mailtrap. Where:`}
        <ul parentName="li">
          <li parentName="ul">{`MAILTRAP_USER is `}<em parentName="li">{`[Mailtrap SMTP User]`}</em></li>
          <li parentName="ul">{`MAILTRAP_PWD is `}<em parentName="li">{`[Mailtrap SMTP Password]`}</em></li>
        </ul>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`MAILTRAP_USER=<user> MAILTRAP_PWD=<pwd> ./apic-user-mail-secret.sh
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Check that you have a Secret YAML file in your folder.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`ls *secret.yaml
`}</code></pre>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops-apps folder: Add, Commit and Push the changes to multi-tenancy-gitops repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`cd ../../
git add .
git commit -m "apic user mail secret"
git push origin
`}</code></pre>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Go to the `}<em parentName="li">{`multi-tenancy-gitops`}</em>{` folder and edit the file `}<strong parentName="li">{`multi-tenancy-gitops/0-bootstrap/single-cluster/3-apps/kustomization.yaml`}</strong>{`.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`cd ../multi-tenancy-gitops/
vi 0-bootstrap/single-cluster/3-apps/kustomization.yaml
`}</code></pre>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`In the `}<em parentName="li">{`SKO sample apps`}</em>{` section, uncomment the line below. Then save and close the YAML file.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`- argocd/sko-sample/apic-cust.yaml

`}</code></pre>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`In the multi-tenancy-gitops folder: Add, Commit and Push the changes to multi-tenancy-gitops repository.`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`git add .
git commit -m "apic customization"
git push origin
`}</code></pre>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Back to the argoCD console, refresh the `}<strong parentName="li">{`03-Application`}</strong>{` application. Maybe you need to wait few minutes to make sure that all the status are Sync and Healthy, before progressing.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1133px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "64.93055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACkElEQVQ4y01S6W7aQBjk/V+mqqoq/6I0IU3CTTjscNv4wPdtYwxMZ5eKdqXV2t8xOzvztXr6Dm1thfZuheft4u9eyv9XbS33y255z4nvV+1fTtQ+LBX8WMzR0TS0RrqGhW1iHwbwyxxekcHNU8wsAxNDx+Zgw4jCe27ruxiQxJrxhWXCSiKEVQEnjVnroKWYBrIsQ1lW3CXqY43LqYEdRjA8D0fG4yTFkfEz43lRYkWwkmcYxjLX1A33CU4QozUzDERpCj+OsecNfhRJcJPnznGQ8xKD58EPkKYZ4rzgiyykORlHMUzXQ8CzYJ3DC1oqk835jBNvECxqnuemgUVAJ4khlmDeMCbySVFg4znA9YpKvugo46cTGYYJWmNq2J8qGE5V9D5nKKtKgjhJgo6i4nO+QGc0hWbYMl4TeEzxh6z9+PmAfqePBrclAZW9ibfxHL3pFzoTlc/2EGcFDD9EX13i41NBl5fNVjtEjLtRirnOnsEE709tdL59h207iPISeycgoGEiiBOEcUodKjI4U7cKW+qpuS5Fz6hXgeZyRcmnudRrYVmIqWdIkDLwUVH/lD2CTGuy1wkY06EAum1LsYXTZhhiQ30TToBGAFFTsSmlhirHJaaRFs0yPV8SOFbHm8sKkxmL0iyXTQKgrmtpiiFuZ6FPVgJAuJ/SiJVzkN+SpWDHXmHm3eXL9SKdvVwu0k2xLIK4aXIzgsVX5q50tqSba9eRceHs9b8eCTjc7fD41sVLZ4jX3pgM81uSYL+GIzy/D/DM3HKry/iRzYPNGo+/u2h3R/jgBFQcnTvgl2GhP19i/LXBSF1Dsz0Kn0B3fYyXWwyVlYwr2z1cjoXlR1A5Gf3ZQvaIbbiBHBnt4OMPw9LI+TuOHRcAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 8 1",
        "title": "apic 8 1",
        "src": "/tech-academy-apac/static/b50f9e09b4d02861d4b023dba588dda9/81f7e/apic-8_1.png",
        "srcSet": ["/tech-academy-apac/static/b50f9e09b4d02861d4b023dba588dda9/7fc1e/apic-8_1.png 288w", "/tech-academy-apac/static/b50f9e09b4d02861d4b023dba588dda9/a5df1/apic-8_1.png 576w", "/tech-academy-apac/static/b50f9e09b4d02861d4b023dba588dda9/81f7e/apic-8_1.png 1133w"],
        "sizes": "(max-width: 1133px) 100vw, 1133px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   When completed, you should have `}<strong parentName="p">{`35`}</strong>{` healthy applications (A), including `}<em parentName="p">{`apic-cust`}</em>{`(B).`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACiUlEQVQoz01TyXLTQBDVd1NwgApLNq4UHCk4At+QOCQVkricBSeRbNmWtWtk7YslO483kwtd1TWtrlH36/d6tIPdd1i4AZauD9sLlFuM23WHddej63tst1v0my02T08A/Ume/1nedojLGiVP7cXLlzi7vsfg8hrHF9cYDG9wcTOGL1YQaa7cWyUIeWZ1q5o0bCZcFwk9DQJEvo+UsbBtaK9ev+GFHkleYJVXmIYBMsZ+JIhyjapuoHsuQhFDsHBZ12iaFsbDPRwWE8wXvF/SxWIB7eDwI9p+g7ZtWbTEhN0axlGSIOUlGS9EhKppEGcZkixHR4S2NUfe1ASRY8WcbBLbDrT9g0OkZUok5IAjPRK6RJhwxK7rsCVfZhTwO0PK3JrFpFnzGQQbpLJYu1a5lcOC7z/sKqKnMwsP0wVG5gxH50OcDm/hhkKJMV7aGFyMcEKeZ7aHDXNTQ8fx+SUGZ5e416dYVxUCXYe2s7uPZbPBX19gFmfQHRdLL0RMNHnVcJwCBnMWN0EkGbKq5kQV9KkJ8+ERlj6BQxCRZcFdWCy48xanozuc3o6hPxowXUcRL9JnGqQwJoXKCylahoJIeio9J68p44Lc1t0zDRkBaPt7e7D1MawJO83mMANfcbciZyXRSH7kz1I0yW1elopHSwiUFKVkUdlMipJSVO3T5y/YsLpcWrlnY3uJpePBCyP0XGpphu/BYs7xQ6W6tHkUYSapsF3VXCEkFdrXb9+5rBs1mkwMjSmO/ozw++pWvaBCNrGWaulPrm5gLGy1DQYbnFC4Y4p1p5u81yBYpdB+/PyFRm4/R4ulAK6nRpM7WHBk6RPPQ5yQU47V8xnWPGUuYk7+J6eTDyBkwX+O53ohnAo5+QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 8 2",
        "title": "apic 8 2",
        "src": "/tech-academy-apac/static/df6f49889e382854452c8cf8067df81f/3cbba/apic-8_2.png",
        "srcSet": ["/tech-academy-apac/static/df6f49889e382854452c8cf8067df81f/7fc1e/apic-8_2.png 288w", "/tech-academy-apac/static/df6f49889e382854452c8cf8067df81f/a5df1/apic-8_2.png 576w", "/tech-academy-apac/static/df6f49889e382854452c8cf8067df81f/3cbba/apic-8_2.png 1152w", "/tech-academy-apac/static/df6f49889e382854452c8cf8067df81f/26482/apic-8_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`apic-cust`}</strong>{` application.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACi0lEQVQozzVT2W7TQBT1dyN4AKFCRYvgCXhF8Ah8Q5u0qJRG3ZS2SeMkjuN993i3czgzFSONPL66y7nn3Ksd7O9hbbnYWA5M21XX4LtuWjRth7brMAwDun5Av9tBnqFpgL7H/5M1HUJRQTBGe/b8OX5f3WH09wrH51cYTa5xfj2FE0QIkkxdO4rh8ZuWFZphB+H7cKe3SFwXiePCdxwkto1gu4X24uUrVKwQZzmirMDCc5Hy7fgBUTYomGRmW/CCEEEcQxQl/VvMZw/YyiT0y9MUeS7gy4QHh+9Rdz3qumZSgUdWq/j2GZwwsXyvAx9FVSFkYJxlaFloY6yQVSWiPENEe01qQteD9u7gEIlIiKSEKGs8WJZCGLPFtm0xkDfdd/mfIqGtITp5jNUSARMlqSzaKFvoMeGbt/t87rBYGbjXDVzqSxydTXA6uYHlBUqM6cbE6PwSY/K8NG30FElny6PTM4xPznB/N0NLQD79tNdMaOQ1bkwHuhtivrWwsT2ERJMVFdvJlc3gJARxipQcJqLA/ULHYv6I9WKJLcH49LFMcrjHliduhIkTYBnn5NBm6yXVfaJBCqNTqCyXopH8okDHcVpS6aQQyMlt2Ty1nIoS2uGHj+QihkskPkWRwZK7iJwpRcnPiqJI0SS3mRCKRyMIICiKYAFZrKpqiiigffr8hTz1Kok0TM0NNlsbtuejo3LyzInaoG3reEp1eVZEuJRUmJYq/oSwgPb123c03cCtaBXkyXyBoz+XOLm4URuUU/mpsVFDP764xnxtqmmYs8CYwh1TrNuZTr8KbpRA+/HzFypyIlsLpQCWrVqTM5izZXkfOcBhTE7ZVkeFS36lzadNxsmVlAvgcaP+AeJpe0yAtDzyAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 9 1",
        "title": "apic 9 1",
        "src": "/tech-academy-apac/static/12dacec548b6745527500d1596086768/3cbba/apic-9_1.png",
        "srcSet": ["/tech-academy-apac/static/12dacec548b6745527500d1596086768/7fc1e/apic-9_1.png 288w", "/tech-academy-apac/static/12dacec548b6745527500d1596086768/a5df1/apic-9_1.png 576w", "/tech-academy-apac/static/12dacec548b6745527500d1596086768/3cbba/apic-9_1.png 1152w", "/tech-academy-apac/static/12dacec548b6745527500d1596086768/26482/apic-9_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Open the `}<strong parentName="p">{`apim-demo-setup-job`}</strong>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACBElEQVQoz4VS227TQBT0lwNCKARaBBJCvCHEExL8BvAAVSFNSlJnE8fX9d2Oc7FT4mF2k9CmSBBppD23OWfGMZ6ddOEkBSzHw3JVI0wy+DKCG4SQUQLHD/Vb5fwwhu1LNJsNDr+62SAqK8TzBfJqAePeg/s4G4zwY2hiyubvfH+9vMKX/hCfexf4dN7DYCR07ttPExfsW67WfwjXda3jVd1gta5hPOx0dps2DdJ5yeRab6vYEFclFk2NmkMyzVBf/9K9LbHdtti2rX63bavzTdPAePzkKaKiQkCpsyCGRUy8EFPCDRMEcQYvSmHrvNS1iR9RDcHcNIh0rHOsG92TU7j0cEKvTEfu4HKQzTIvkS+WWG+uIblUDTkkdwmPiyy5O0C9/STn4gTGo06Xwwl6YwsyKxCRxE8LzMQUnj1D4NhIPA/edAaLF4RFiXLOj8Bem8Tq4oB22LxU1Y0OJQs/xtlQ8KICOf1zuFH0L2GPRggmAoXrwu4PMOn1YccpHJlg7Pj6YkHCMaFUqZyW7KWl9mTs7iRf2QEsWpDmOTJiSdke/zJmbwDBIXNPIPZ+3ngYwjh9/oIXFZrsqKi8SXMElCazUsdCpkc9hwuVbKFiJfnlq9ckzDWhKh62ainuAfJmcD98u/eI8M3bdzQ3+4vs7iX/yh8Rvv/wEbPwmPAuwX+X3SL8DdbhbgIYn0RVAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 9 2",
        "title": "apic 9 2",
        "src": "/tech-academy-apac/static/2f0129c4ca416345d54479d176794780/3cbba/apic-9_2.png",
        "srcSet": ["/tech-academy-apac/static/2f0129c4ca416345d54479d176794780/7fc1e/apic-9_2.png 288w", "/tech-academy-apac/static/2f0129c4ca416345d54479d176794780/a5df1/apic-9_2.png 576w", "/tech-academy-apac/static/2f0129c4ca416345d54479d176794780/3cbba/apic-9_2.png 1152w", "/tech-academy-apac/static/2f0129c4ca416345d54479d176794780/26482/apic-9_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`  Open the `}<strong parentName="p">{`LOGS`}</strong>{` tab.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACNElEQVQoz22SW28SURSF539aY8slGqMvRl+M/goTXiptKkJRKKUVEWtF0xeTvuiDJk1bYykDjAxzYe735T5ngEbCJCuTs8+Z76y19wj5XAa7e03slMrofj3BSNHQH41Jf9EbSLieTKBZDnQ3gG7aUGlfpbdONWmi4dv3nzg5/YFfl1dQNB3CrbU1FF5uo7BZxEG7A1kz8EccYSgrJBXXqg5lokC8uIR0dgb5/BwKwVTDorNT/O6PcNEbQBwrkFUNwu31dXz+0sW7VgtH3S5Mx+OOLM+H6/uw/QCuZUPrXcEkt24Uw6U9h+8HCKIIIdX8MMJYUSFsZHOoNQ9RflPD4YcjeEGIiA7Nn5DWQRgu1kgSrHpYlUfO5PK8h1uvd9FodTjQIkchQdghjzlxPX5JQrBlxfN3nECbGhDubGRQeruHQnEH7U/HHGg7DgFTl54/A8bxSmCyDNzIZvGqWseLzS20jwlIffE8bxHFcB3uNk27Ou58jwNZ5GrjANvlKvbfd2BTxCAI4HOF5Djgl7A+MrHaf5rV2IBUBszfvYcK9bBYqqDZ/giHNnSSMfvAobhsipbjcoV8qjdKL4uol0iB9x88RKV+A2QQw/eg2g7/AEk8ixRTn6LZPFMltA4CH9JYRn8owaBhCo8eP0G5vs+nzIBsKKbnQqRfQLddTJ0UrpM75t7jbWAR05ghWVOnJkRJToFPnz1HudZYANkhl24dTHWIqoGhasF0fe6WTTpeUrRwDT6Uf46kcQDNl7mbAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 9 3",
        "title": "apic 9 3",
        "src": "/tech-academy-apac/static/139843af73982252e01497f10b44f085/3cbba/apic-9_3.png",
        "srcSet": ["/tech-academy-apac/static/139843af73982252e01497f10b44f085/7fc1e/apic-9_3.png 288w", "/tech-academy-apac/static/139843af73982252e01497f10b44f085/a5df1/apic-9_3.png 576w", "/tech-academy-apac/static/139843af73982252e01497f10b44f085/3cbba/apic-9_3.png 1152w", "/tech-academy-apac/static/139843af73982252e01497f10b44f085/26482/apic-9_3.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Check the log to confirm that the apic-setup job is successful.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACVklEQVQoz22SW08TURSF+z/FCKWoMfpi9MXon/ChL1gI1pZqS2kRShVpiQ8YE4MxocSkF+iduZ3OdO7Ty3Kf04oKTrKyJzN7vrPW3hO6GwljcyuHjXgC5aPP6CoM9XYP56Rmp4+GokC3bAyGlpBhuxg6LkzHQ496D4+/oXB0jJOzKr03Ebq1sIDoq3VEV2PIF4rQTRtdZoBZDi56Eloyg2xYOJc0XA6GaEsqHdhHV9bAhjYsz4fjj6gGkFQNoduLizgsl7Czu4uDUgmKblKzCmaYyBbLOPlZg+b6uCCYTO7KX78jnt3Dlx9nUKhH1gbQ9CHBLbpnCC0tR5DO7SDxNo33+x8pngNGLg2qIh7FcBwHLsn3PJimCd/38fc1nU7h0jsBDEdWxAzX3mxie684A/J5EXQ0nkDXdTQaDXQ6HfR6PciyDE3TxHODxBiDbVuYElhWCXhnKYz4uy1EYxvYPzj8FzgawzAMtNtt9Pt9tFotUSVJuhI/ZEDQgHrnkZfxOpXBy9U1FD79AXIFoxEYuanX6wLGXSp863Nn3K2qqqKygQ6FDWaRU9k81hMp5K5FHk8m1CyhUqmgVqsJNzwuh4nI5J6LH2rZDhRaUGjl3n0kaYaxeBL5/Q83gPxjDuPicTmIL4UvisuyLFE9P5hFfvDwEZKZObBwE8gdcVi1WhXL6Xa7AhIEgQD/rlfAx0+eIpHZ/g9wtjnGNFROTwlWF+BmsynmyKMOSRwuXLruLPKz5y+QSGfFb3PdIZ+LRpEvJRkKDV8ngEkfczc+OfPmznySF4yEw189Glyu6LHfFQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 9 4",
        "title": "apic 9 4",
        "src": "/tech-academy-apac/static/5445a0e74a06481559a9b8ef54be2d9b/3cbba/apic-9_4.png",
        "srcSet": ["/tech-academy-apac/static/5445a0e74a06481559a9b8ef54be2d9b/7fc1e/apic-9_4.png 288w", "/tech-academy-apac/static/5445a0e74a06481559a9b8ef54be2d9b/a5df1/apic-9_4.png 576w", "/tech-academy-apac/static/5445a0e74a06481559a9b8ef54be2d9b/3cbba/apic-9_4.png 1152w", "/tech-academy-apac/static/5445a0e74a06481559a9b8ef54be2d9b/26482/apic-9_4.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`Great, now you are ready to publish your API. Back to the OpenShift Console, open the `}<strong parentName="li">{`Pods`}</strong>{` page (Workloads > Pods) (A), on the `}<strong parentName="li">{`tools`}</strong>{` namespace (B), filter by the word `}<strong parentName="li">{`publish`}</strong>{` (C).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABv0lEQVQoz5WS/U7TYBTGexHGiCBOFrYUt5VVp2yrOLcMJCjug/+8BL0Fr8yr0ASJiSHGKPwBtLPr57u2P992YS5KjHuSk/ft6enzPOecKvlcjlqlQlFVKRYKbNe3qGkadV2n2WxOwzDkaWBkZ5NWq0Wn06Hdbmf3brdL78Uu+3s7KPcrVdTyJrfv5Oj3D7G/nmB9PiYxL1kEH74FnI5ilJIkzBdUbi2v8mpwyE/bxvcDYll0/uWEs6NjbNNmHMR4gSCOIpIkySKOk9n9/UeLT99dlA3p7uGjOksrd9k/6OF7Hu7YxvVDzs8ucC4uESIijKYEkPzTqdLYrMp5PaCYW+P1YIjtC0ZexNhxmMQRIprgSZGJEFi2K4UErutKETHNTyaYponjesTSqTLY2eN5d5ftrQbv3r7B9gJ+WIIgDGVx2mIsncWZ+sgJObVChCRJcylpJEeQCgRBkHlXdK3KsydPWb+XpydbnuJ3W1czSiNFlM2N2fM80pyiyqWU9Ro3llZ42RteSzL/wbzgfN3VO6WgltgoadMt94fXFv5PzBymW07/xZvS4cEfhItg5rCs6TxuGCyvrv1FuKjDdEG/ALHS2L1zxnF3AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 10 1",
        "title": "apic 10 1",
        "src": "/tech-academy-apac/static/161aca6cfc8e060ad81f64279098a1b3/3cbba/apic-10_1.png",
        "srcSet": ["/tech-academy-apac/static/161aca6cfc8e060ad81f64279098a1b3/7fc1e/apic-10_1.png 288w", "/tech-academy-apac/static/161aca6cfc8e060ad81f64279098a1b3/a5df1/apic-10_1.png 576w", "/tech-academy-apac/static/161aca6cfc8e060ad81f64279098a1b3/3cbba/apic-10_1.png 1152w", "/tech-academy-apac/static/161aca6cfc8e060ad81f64279098a1b3/26482/apic-10_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`apic-publish-deployment`}</strong>{` pod.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABsElEQVQoz31S2U4CQRDcr/BE0GhWUEAQAeUMaNQHFFF/wBi/0m/wxRcTE+MNiSLgsBfL7pbTI4uEw0k6c6S7uqprpGXfIuKhEFb9AciyjHQ6jVgshkQigWQyORL0Tjn5fB65XA6ZTAaFQgGlw13s7xUgrYejCIQimPX4UK6co91uQ1EU2LYNx3HEPhyWZfXDfbt5YHj60CCtcbBlOYCZea8AZIzBMDqweXK32+0DU1i987h1fdvC3TsHDG5sIr6dEgxL5Qo0TYPSZlD1DpjaESxcpo7zBzgJWPKvhxHksucWFnF0cormRx2fLzWweh0mZ2gYBlRVhWmaaDEVumHyuyLu1JxUNBoNqJoOmzeRssV9FPcOEI7GcXF5hWa1hsf7N2hfX7B4R7s3J84JLcVAtdnpj4JASQE1pMaCIZmSyubhXVoRkm1dh8lNMV+fYbHvvjxXommRbPE4IpdyOGAEG9EtTM16cMwlu8smFhy8lzl2boPzdM+SHAiCnJ4WLp/9JpABA0XOQNFwuDkkXQASGMkWDF3AMQWY4Oowa/FtEjsZzHuXuOSzEQn/reEvREb9AJf513aDPGqKAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 11 1",
        "title": "apic 11 1",
        "src": "/tech-academy-apac/static/41e4e0511671f1a065ef1aa476a9b797/3cbba/apic-11_1.png",
        "srcSet": ["/tech-academy-apac/static/41e4e0511671f1a065ef1aa476a9b797/7fc1e/apic-11_1.png 288w", "/tech-academy-apac/static/41e4e0511671f1a065ef1aa476a9b797/a5df1/apic-11_1.png 576w", "/tech-academy-apac/static/41e4e0511671f1a065ef1aa476a9b797/3cbba/apic-11_1.png 1152w", "/tech-academy-apac/static/41e4e0511671f1a065ef1aa476a9b797/26482/apic-11_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <pre><code parentName="pre" {...{}}>{`Go to the **Terminal** tab.
`}</code></pre>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3klEQVQoz32S227TQBCG/RIcGtIqKFIjh5BARYOcFEdxguCmNG3hARASD4y4R9xUOD6l8SH2rjc/M+ukJBSx0mp27Z1v/vl3jWajgdNuFy3TRKvVgm2/Qb/fx2AwuJvD4VBPXluWRWdsOI6D8XiM0WiE6XSKyWSio9HuvoT5/AVq9QZmVx8hZInVaoX1eo3t+LP6/1BKwXhGwOaxicdPjnBxeQ0/TvDLdTGfz/X0fV9Hj2LgeQhvblBKoYusCcCFy7JEnudI07QCvnpt4YAUnn+YYZHkiG4TFEWBnGaWZVpxISUSjwp8/4bs5w8ogiqCsSq1AfNZw+z00OmdoHZIwNkV4jhGEAQEFBrK1XdbymkvoxDS9yo7CLS1hwsbtvMOztv36J2c4vOXr3A9F0tqW8oKyJDtYLhLdohNEQ3bRB58XrdsndmoN5o4v7hEsAiRkh/cjiQYJ3MC7wsh4ZGP3EG5C90A+ZsGsrqHB3V9KYK8WiQxMqqWsNEUq6QqYRFFEKK4g9wDHpsdtMnHR7VDzK4/0U1lWC7jveewTVClQhglpFrtfd8DtukNssoHpJDfYbISCG/Tveq7iULSM1HauXv/NZBvuG+doXb0VAPjJIUfRHQp8p8q/la9uxZC4DftYNXESnYfrQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 11 2",
        "title": "apic 11 2",
        "src": "/tech-academy-apac/static/dbf9e08c3c2468e49c53c25b1d597242/3cbba/apic-11_2.png",
        "srcSet": ["/tech-academy-apac/static/dbf9e08c3c2468e49c53c25b1d597242/7fc1e/apic-11_2.png 288w", "/tech-academy-apac/static/dbf9e08c3c2468e49c53c25b1d597242/a5df1/apic-11_2.png 576w", "/tech-academy-apac/static/dbf9e08c3c2468e49c53c25b1d597242/3cbba/apic-11_2.png 1152w", "/tech-academy-apac/static/dbf9e08c3c2468e49c53c25b1d597242/26482/apic-11_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`In the Terminal session, run `}<strong parentName="li">{`./apic-publish-api.sh`}</strong>{`. Accept the license. And feel free to accept or not the limited usage tracking.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACYklEQVQoz6WTy08TURjFpyVtE4hKX9MXHdvSIqWUKWVCaXl0oWhwyaKSGENLFwa00Ae0FsuohE4hhIWJQdf9G1jhwpj4f5BQRKObBqHuPN57VTQhcaE3+eV8d+bm3PN9k+G8t6cQvpNAz/Q07JOTuBKL4XI0iksjI0zN4+OwTEzAEo+DJ0qfd46OwkhqA3mnHxv7URNMBO6acBVhfx9cXU6MDUewWsgju7CAR7kco5jNokQo/oTW5UIBa8UiKisrWF1ehlwq4Wm5zJTrE4fg6xsA7xCQvj8Pur7h3xfXL4bR0xsAb3NiNpXG55MTHBwc4OiogcPDBhqN37w/PsaHj5/w5fQUX1sttP6g2WyidXZGDQchRaLEsAt3783ifxcnhodBUzoEN+YfZPB6fx/PNhQ8f7GLVy93sbOzg+3tbUatpkCpVlGtbhCqUBSFsVmrobIm483bd+Di12/hxs0p+IMhrFZkZDIZ6PWd8Hq9cLvdsNvtsFgs0Ol04DjurzyRZXBBkk6KxGDkbSxhIZ+HyWSCx9NN8MDlcjFTq9XK9Bft7e1oa2uDRqM5v2xza4vMcGAQAYLeZMFiNo9K5TE83d0QRRGhUAg+n48Z08SCILDUtNZqtRcS0va53sAA/P0iDGYrMks5yCS2mxhIksRMg8EgAoEAjEYjDAYDzGYzUzoGCs/zLD29gM6ZC4aGWMJOI4+lXIHNUKvVweFwnB+22Wzo6OhgranVapZGpVIxaE3bprq+vk6/soRIjPxedifmHy6iXq8jkUggnU4jlUox5ubm2J5qMpm8AD0zMzODvb09fAem5wXvtce+CwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 12 1",
        "title": "apic 12 1",
        "src": "/tech-academy-apac/static/f296927754f0838522fb077061c3680a/3cbba/apic-12_1.png",
        "srcSet": ["/tech-academy-apac/static/f296927754f0838522fb077061c3680a/7fc1e/apic-12_1.png 288w", "/tech-academy-apac/static/f296927754f0838522fb077061c3680a/a5df1/apic-12_1.png 576w", "/tech-academy-apac/static/f296927754f0838522fb077061c3680a/3cbba/apic-12_1.png 1152w", "/tech-academy-apac/static/f296927754f0838522fb077061c3680a/26482/apic-12_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">
        <p parentName="li">{`You need to authenticate in APIC to publish the API. Let’s do it! Open the URL provided in a different browser session.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If necessary log in APIC with `}<strong parentName="p">{`Common Services User Registry`}</strong>{`.`}</p>
      </li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABo0lEQVQoz41STUsDMRTsD22l0h6KKIgXUTyLePHgwZse/Q2e/DyJnkSQIqzWtWpFu9lks98ZX9KkXVsVA8Nmk7ez8+ZNrdVqod1uo9PpoNlsol6vo9FomKfb6/PfMY+5uQYWlpaxubWNWpIk0IjjGGmazqAoCvx3lVRb45zDIQzDGURRBKUUyrL8E3ppAWNC4Z5CoPqTKJKmWJP+DHs3IRSGjJEaTmAsQGiIR4RSyrHCaWJoGqUtGdmSZVah9s/zPNzcPeLBf4f32MfnkMHdRTLG6+ADXEijpLSeJVkJfxDhbZggoEZkbAllJNB/+8TR9ZAKBEI2RMBIMQ9JYYwspprgxQB5SOBEl+PWV1g8ANYOgYV9oPusCYVrWRDoQ9OqPSNSpTKcXfhY2fGwsdfD+t4zVnd9PHX7RqVMFOJMIc1JcUKEoyEI49m3vR4KTTj5GKB318fxFcf5NcPpFcPJZQD2zmzj1kvnobAK+RTMGd2x+y55nv6Yu+qUx7FxMZmOi3mnqUsaii4vCp03hcLCkUwmXslhlbQKF5vZuGBmr1ee5/gCCiJ6+hvtjaIAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 14 1",
        "title": "apic 14 1",
        "src": "/tech-academy-apac/static/eeffe5d02903f4a956d0686cab233da5/3cbba/apic-14_1.png",
        "srcSet": ["/tech-academy-apac/static/eeffe5d02903f4a956d0686cab233da5/7fc1e/apic-14_1.png 288w", "/tech-academy-apac/static/eeffe5d02903f4a956d0686cab233da5/a5df1/apic-14_1.png 576w", "/tech-academy-apac/static/eeffe5d02903f4a956d0686cab233da5/3cbba/apic-14_1.png 1152w", "/tech-academy-apac/static/eeffe5d02903f4a956d0686cab233da5/26482/apic-14_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Log in with your admin and password.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB9UlEQVQoz5WTu27UQBSGXdIi8P3u8Vw8Xi3eXSdiF4lAwkVJpGgRUgoQEgVSKElJSmhooaCg5gGg5TF4A57k58wku+AlKSh+Hc/I5zvXcXzfh+d5MHZT5j4MQ0gpoZSydvW9Ov/93bYtnMtAVwNXkOafAAPgTdddyyWIkXdhDVAYR8HXzqwuIYRA02h75ry2skDjwPIcgjHImiEOApJvbUDBApMhObejzmYmCHz44BiTboKqSi2on83pvEUBFByVJujosqMfp5KiZinqMEAdhVBxhOQiw90XH9FOdpBlPj6d/cCXDz/x6OA5Spbi+OgUy/0T1LyEMypycKWRZDnS/FxJmiLOMrA4Rk5gTr1b7D1FQ1lWrMTJyzf4/vUXzj4DvNvFraaB1mPoVsPRaQxZeGBFhKqskBOoIGhG4gTMosiWZcrt5/ehxzNM+xn2Hx5h+eobeH8ANmptFbaHqmwQLN4iaA8RhTSEOEFEoIDECFaQrcoM2ztLPH72DpKq2drew6y7DUmB9OIu+tenf4CipEndew8+fgKZxDYr28PQ9DBEYjPkGI0n6Po7dihKKpuxWSNN2U3nczt1Cww8F8mNa0i86zSAeGPK3vmU7b4JCFs67ZwaLrSo6+Eeun5IO+cPdnCwhxT9qtdx+Uv5j6e3Aqy18VJ+A8XxXmOrVws1AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 14 2",
        "title": "apic 14 2",
        "src": "/tech-academy-apac/static/a21d436f1eb7a79765666132c72a39f3/3cbba/apic-14_2.png",
        "srcSet": ["/tech-academy-apac/static/a21d436f1eb7a79765666132c72a39f3/7fc1e/apic-14_2.png 288w", "/tech-academy-apac/static/a21d436f1eb7a79765666132c72a39f3/a5df1/apic-14_2.png 576w", "/tech-academy-apac/static/a21d436f1eb7a79765666132c72a39f3/3cbba/apic-14_2.png 1152w", "/tech-academy-apac/static/a21d436f1eb7a79765666132c72a39f3/26482/apic-14_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 15
    }}>
      <li parentName="ol">{`Copy the code.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABLElEQVQoz42S2WqEMBSGfVAdLHohhUKfopS+UR+iV73pnR0YdOrQ0Szuy98sxDpuzIGfE5KcL2eJ5XkefN9HEARwXRe2bcNxHOXNWu5v6wGHg4PHp2e8vL7BqqoKUmVZoq7rhbquw73Wi7sWYwxGlNKF8jzHMAzo+35X0mQCI5AbzzmmjxRFoS5L6J4mQK5gRGTDhAjJQBV4CdyyGZCp/oVhiM+vI75PF4THCNeUqIcMUJrsp6yAEKq8LHUlQxGUc0Q/V7x/pDglHJSkyEQQmwHbtsH5HCOOI+WTJEHTNOO5BnJTsniZCoAqlY89vc2wx+WXIhG6ZvqsbdtboB4CVz1brudDER5amz3k/D+bqdaACjVobU7ZBM6/y3qGS4jmz4YyhU61Btz7NrKff/j2havdwKLZAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 15 1",
        "title": "apic 15 1",
        "src": "/tech-academy-apac/static/283dc61931efc1513f16c39ab44ee1c3/3cbba/apic-15_1.png",
        "srcSet": ["/tech-academy-apac/static/283dc61931efc1513f16c39ab44ee1c3/7fc1e/apic-15_1.png 288w", "/tech-academy-apac/static/283dc61931efc1513f16c39ab44ee1c3/a5df1/apic-15_1.png 576w", "/tech-academy-apac/static/283dc61931efc1513f16c39ab44ee1c3/3cbba/apic-15_1.png 1152w", "/tech-academy-apac/static/283dc61931efc1513f16c39ab44ee1c3/26482/apic-15_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   And paste to the terminal tab on OpenShift Web Console to continue the publish process.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACSElEQVQoz4WTS08TURiGJ1wKqaktrdpSKy0tvQyWTkWpKWAJ5dImDbEqKiq34MaYqDEuCTvoyl9BDbBzaYjaW2KCP0HdKaZpWBANCaEIj2eG0OBGTvLkfOdk8p7nzHwjeVwuekIh/LKM3+8nFrtBJBKht7e3Rl9fX41oNCqeiRGPxxkcHGRgYIDh4WGGhoY0pM7QFeSuMHaHi/Ttcap/Dtjd3eXw8JDjcbI+bUiXRaDHJ2O72Eb61jiVX7/5sblJuVzWqFQqtXpra4vt7W329vbY39//h52dHarV6lHgtetR7JdcpMZunmpwcJqhHFQIKt20Opyk79zl29cvvFv/QL70ic8bGxSLRQqFAqVSiXw+Ty6X12YVdT8vKBYLrL//yPefZaRYPEF8JKmFvnj5ivn5ecxmM4FAAK/Xi8PhwG63YzAYkCTpvywvLx9dOdof0wwfTc2wsLCgBbrdblyiA5xOJ1arFZPJVKOlpQWdTkddXR319fU0NDRogaurq0eBSncPlgutTM3Mkcks0d7eTki0kiJQLT0ej2aszj6fT+M45CQrKytIPjlIp3iP56x2pmfnWMpkcLS10aUoYj+I1x/A3dGBwWjCKOwsFot2A9XSaDTWrNUD1tbWRB+KHlQtzedtTM0+5vXiIp5WG9GwQtjvIyxsrnbKeGxWzp7Ro2tqorGxkebmZppEraLX6zXDbDaLpH6MSLRf68OJyWnevskyM5bi2eRDnty/J7jL0wcTPBfrdCrFyOgoyWSSRCJRQ12rf04ul+MvgublvcO023cAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 15 2",
        "title": "apic 15 2",
        "src": "/tech-academy-apac/static/11c72b5ea9584af58b2331abbbfd2e32/3cbba/apic-15_2.png",
        "srcSet": ["/tech-academy-apac/static/11c72b5ea9584af58b2331abbbfd2e32/7fc1e/apic-15_2.png 288w", "/tech-academy-apac/static/11c72b5ea9584af58b2331abbbfd2e32/a5df1/apic-15_2.png 576w", "/tech-academy-apac/static/11c72b5ea9584af58b2331abbbfd2e32/3cbba/apic-15_2.png 1152w", "/tech-academy-apac/static/11c72b5ea9584af58b2331abbbfd2e32/26482/apic-15_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 16
    }}>
      <li parentName="ol">{`Great, your API is published successfully.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACNElEQVQoz42Ty24SURjHhy4aFg2kgggVuYbLDFMGCCgISLiHSNMiulBbtL6AMS5ZsyHhEdhQEjY8AWm8ADEh1CeoO4lIWBANNobb3zlH28TEBE/yy/fNmTP/+W6HMRsM8DmdsLEsrDYbQqEQfD4vAoEA/H4/hfiXkOdwOIxoNIpIJEL9WCx2BcM53WB3XdBoDdjPPcTP2Rw/Li6wXC5xuYi/Wq0o6xbDiWJmKwv1TR0ORMHRt+/4PBhgOByKfMVoNPrjDzEejzGZTDCbzbBYLDCfz6+YTqeYiZbhxQi9d+5i55YB9/f210awWBchyzvBC24xZT0OHjzCp/NznL59j86HHj6enaHf76PX66HT6aDdbv8F2SN0u12cvnmHwZcRmHuxFGLJNByCBy9fvUaxWIRSqYRBbJZMJsPm5iYYhvkvarUaGIeYciAUoSk/flpAuVyG2+2Gx+OhlnSddDYYDFKf7BFcLhdYcTI4joMgCDCZTGg2m0TQBcHjhUKlwWHhmAqSg+QDcshiscDhcMAmjhTBbDZDq9VCoVDQTAgqlQpbW1toNBpgrCwPbleA8sYOjp4do1KpgOd5GiGxer0eGo2GloCIXf5Ep9NBrVZTcfJeLpejXq//HhuS9rXrGhw9f4FSqQSj0UjTstvt2N7ehlQqpTXa2NigViKR/LOG1WpVHBuxGbcDITqHTw4LqJ+cIJfLIZ/PI5vNIpPJUBKJBCUej1OIn0qlkEwmkU6n6a1ptVr4BQjf6gdK7du1AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "apic 16 1",
        "title": "apic 16 1",
        "src": "/tech-academy-apac/static/eea3d6df4e90b4ab59631c5b69a900c0/3cbba/apic-16_1.png",
        "srcSet": ["/tech-academy-apac/static/eea3d6df4e90b4ab59631c5b69a900c0/7fc1e/apic-16_1.png 288w", "/tech-academy-apac/static/eea3d6df4e90b4ab59631c5b69a900c0/a5df1/apic-16_1.png 576w", "/tech-academy-apac/static/eea3d6df4e90b4ab59631c5b69a900c0/3cbba/apic-16_1.png 1152w", "/tech-academy-apac/static/eea3d6df4e90b4ab59631c5b69a900c0/26482/apic-16_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`9 - Check the Demo Assets`}</h2>
    <p>{`Great, in this part of the lab, you will check the Demo environment and assets. On the other hand, you will collect all the evidences to prove that you were able to complete the lab (check the 3 screenshots notes).`}</p>
    <ol>
      <li parentName="ol">{`Back to ArgoCD page, go to the main page, and check all the 35 applications are synced and healthy.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACg0lEQVQoz3VT227aUBD0d1cgNYp6k6L2rR9QqX1r+wVVlKZSE5oLAQIEbLCNsfH9bmMMTOec9LVHGqEz7NmdnV0rZ+9ew1i7WNkbWI6L9T+0uxaH/UHieDjiQPzvVLs9sqpBVlZQXnS6uBo+4fJuKHF+08ePm3tMVmtMrTXmLGT6ITTPhx5GsKJnOEkiYcUxJhsPU0JzPSjdTgeF7yNYWQhsB7eWjr5jYhw4mIQbDFwLl8sZeoaKe9vAI3nJLWb4ravoESPPxt1mhdF6BeXs5CUqSq3LEvHGhbpcoq4bFEWJ3bZB27QwfA8l73lRoCGH9kDVPrK8QJpm8v1RtJ2XIuEJkjJF2TBJkkIzmHC3Q8h20jxHUVVYBj7KukbMe5xlKKsaBrm0KpGyiOByCoqyHMrbbgd0HZppYfL4hDkTemGMNb3bUs2Rs9DcDVz6KIZV8KE4OlXbVGnTu5gqxUmFwlfdLsysxpCT1i0H/dEY570+ft08YOV4aNo9xix2QU5ANSzsyGlM/pMxF717jGYLbLkVfpxBecOWb90Id36MpRtAo4dhytaIkgoj/qrOBn6UIMkKVOSEEpUD9KJYqivpeUI/XXamvD89RRh68OhfyLHPlxpStmVzTUR7W3q78Fw+TPkglL6KHdU9j4UTyYn/GsbFLKh8/PAB29BHHYjVWWHh2Gj3nBjNLsT0qUgMQCQWd2H+jgnNMEDBQYkBCU7ECZXKp89fsN0fpQdJWWOg65jMF1wfUwaL82TbkpstDLadS25JhY+qhpmmwwui56FwtZSv375zTVpZQUgeMOCqP8af4RS67XIVCkz51VwPJhJzcy05lVtwzZjrhwnGmsH2Czh+hL9YnHW89l2C0QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 1 1",
        "title": "final 1 1",
        "src": "/tech-academy-apac/static/86faf1516ff021edb8b39ad722fb6040/3cbba/final-1_1.png",
        "srcSet": ["/tech-academy-apac/static/86faf1516ff021edb8b39ad722fb6040/7fc1e/final-1_1.png 288w", "/tech-academy-apac/static/86faf1516ff021edb8b39ad722fb6040/a5df1/final-1_1.png 576w", "/tech-academy-apac/static/86faf1516ff021edb8b39ad722fb6040/3cbba/final-1_1.png 1152w", "/tech-academy-apac/static/86faf1516ff021edb8b39ad722fb6040/26482/final-1_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Now, let’s test your demo. Open the Platform Navigator page and go to the `}<strong parentName="li">{`Integration Instances`}</strong>{` view (Menu > Administration > Integration instances).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVQoz4WSz2sTQRTH919IY5pfzdqkSzQ5WERJoHj13H+gISdzFz14FUTwX/CmBwXBgyep3krx0oKJJoQkIoZCY0WT3cn+3tn5+mbSRiuKs3yY2Zn33rz3faPd3LwSlwwDlUpF6LqO7e1tNJtN7Ozs/JNGo7Gk1WoRt3D77j08ePgImmEYvFwuo1QqiWKxiH6/j/8NIQQ452rd6/Wwv/8OBweHsG17ETCTySCZTIp8Po9ut6sMpYN0/BM5PM9TznEs8Gb3NZ49fYxXL59jNptCW19f5wQoqArY6XSUk+/7CMPwr0RRRHDEPIQTAR+PgcEJYDIXWkHX+QZpmFpdFblcDu12e5lFEATnCMNfa88LyCpE+7OLO0883H/h48uxCa1EGRJIp1JCX1tDlzSRI+ICkfcVPPhO5QuVkYgDRM6YSl1kGscyJqWGH8pnPreg3ahW+PVLZVzOZ8XV4kX03+6eCk8GbArHttQ6Jm+ZoTk9oQuiZVMY2cznDCQnLIsCbhob/Fq1CiOfFxW9gMFpydLB83wqL1T/MqDccxx3eYFs0u82zGLQ0tksz5J2F6jkDM2H7feI6ZtaM7i+q3A8hwQ3YdlM/duuDUbrGZupM4ncMy3SkLqrnk06nRYF0rDzYdHlIOQI3AnxDSHpx6gs6WCappotZlG5TJUpUed0pq2srHACiURCpFKpcw/bdxkC315cQJ2VT+kM13XVWzzDsZ2FhvV6nROo1Wpia2sLe3t7OJ5MMB6PMRp9UhwdHdE8wnA4xHA0xGAwUHuO41BD5goZVM4/AYBMBOhMia5SAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 2 1",
        "title": "final 2 1",
        "src": "/tech-academy-apac/static/f9c5fcfb2be2401874a98324ee5ef813/3cbba/final-2_1.png",
        "srcSet": ["/tech-academy-apac/static/f9c5fcfb2be2401874a98324ee5ef813/7fc1e/final-2_1.png 288w", "/tech-academy-apac/static/f9c5fcfb2be2401874a98324ee5ef813/a5df1/final-2_1.png 576w", "/tech-academy-apac/static/f9c5fcfb2be2401874a98324ee5ef813/3cbba/final-2_1.png 1152w", "/tech-academy-apac/static/f9c5fcfb2be2401874a98324ee5ef813/4147f/final-2_1.png 1429w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Here you should see all the integrations as Ready (`}<inlineCode parentName="li">{`Note:`}</inlineCode>{` Ignore the Warning in Kafka cluster).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACBklEQVQoz5VTSY7UQBD0Oxu6adQSB058gpGQ+ATDE3gBGiEOPIALs/Tifen2Vq6yy46JLLuZK5SUclRlVWRmZNrbbDZYr9fY7XZYrVaQ/Xa7/Wd7s32LV6/XePf+A24+fYZ3Pp8RxzGSJEFRFLDWOhvHEf+/LDzT9+iHAaYfMJBITPbyHafJfS3J7TjjQTDPezs6gn1q8eW7xe3dhB+/O3jBfo/4eEQehogOBySnk8Px8YDj/R9kQcCzI/ynR4dT34f/+ODuVbGPn78e8PH2hJuvPr7dhfDi+3ukYY46y3GJQhR81OY5qiTGmfu2oC9NkPkBqjSjLyMmGc/kXhadgDYDdAYTPsFTlws6Zi8FSInaGKfGtNh1DSzxuu8H+xcrYm3nuw174RVRhEpTDTvBkKxtGljRkNZT34lBRmqnlJ5JpxFt22Kg5kLTdAqdYTq817Air2R3le5dZ7XWqKrKEV+7LUs6buiTrwSQe9Y1ZULVdQw059vGkRCmaDSzYBeVUi+js2QpkYVIfNeMBc/BJpStghlmgRxhxWaoRQMZi47Rp0VPu8yikLjxWjIWLH5ZDasZlpFtnYbsXlkzG21g2gYXdq6XbGiGWo18PFCn+lKiqVm20cQX5596g4w/hlbG4TrwSShzxzlsOQZlGKBm2h1Ho8sWy2dTWUp7wVff/I7jxTEr2eBnmVV7kVVlOPgAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 3 1",
        "title": "final 3 1",
        "src": "/tech-academy-apac/static/b2add4b4abfcfd8c6ba4b0fe0a7161de/3cbba/final-3_1.png",
        "srcSet": ["/tech-academy-apac/static/b2add4b4abfcfd8c6ba4b0fe0a7161de/7fc1e/final-3_1.png 288w", "/tech-academy-apac/static/b2add4b4abfcfd8c6ba4b0fe0a7161de/a5df1/final-3_1.png 576w", "/tech-academy-apac/static/b2add4b4abfcfd8c6ba4b0fe0a7161de/3cbba/final-3_1.png 1152w", "/tech-academy-apac/static/b2add4b4abfcfd8c6ba4b0fe0a7161de/26482/final-3_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Then, open the `}<strong parentName="li">{`API management`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABzElEQVQoz5VSzW7TQBD2cwYSUkXiwImnKELiJdobPfcB4IB658CtEiSK2zj+Xdu73h/vx8y4DikHRFcazc/OfvPNzCar1QrL5RKbzQaLxQLsr9fr/5Y36wu8er3E23fvcfnxE5KqqnA4HJAdjyjLEiEEkXEc8fITkFhr4ZwDa++9CPusGXiO/W070ogevzKPqy8e118Dvv3QSNL0AVmWCTtmenxiyvZut0NRFHKfpinyvCDJsd/vpSNV57j7vsfl5yM+3OS4vcuRFGWFSg0YBouu66CUErZaa/GZ7WAM6kZBGyt3TdPAUEzstqFWLYlDsC0SbQZo8scIaYUTY4wn4cPaOY8nV4rMM+4tFXSQu67TvJQGSkcEQrR2QN/3z+bFZxyDsPNhKsLsp7uIjggYG8VuW2LYUluaSlAuLAFxkFuZtz0BjrDDIJoBB7JDGAVEESAX4sOFkoqGXT0WcHWNdvsTBS0j0MPwjOEoydzqzHAqFtGQbf0ZYHF/j3L3CLPdQh8eJMgAM0MGYJ9ZTXOcGU6AHcfPAeuaZth6WYqnZKXaE9iJIdm9NrS8KNOf58yAZdcTIP4A8sxaCvJjDvD8zhn+SzjPyTsj7/mb/QavRIH0ojUJlQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 4 1",
        "title": "final 4 1",
        "src": "/tech-academy-apac/static/72580f8df84af5299cb4d6e46f6433c2/3cbba/final-4_1.png",
        "srcSet": ["/tech-academy-apac/static/72580f8df84af5299cb4d6e46f6433c2/7fc1e/final-4_1.png 288w", "/tech-academy-apac/static/72580f8df84af5299cb4d6e46f6433c2/a5df1/final-4_1.png 576w", "/tech-academy-apac/static/72580f8df84af5299cb4d6e46f6433c2/3cbba/final-4_1.png 1152w", "/tech-academy-apac/static/72580f8df84af5299cb4d6e46f6433c2/26482/final-4_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   If necessary log in API Manager with `}<em parentName="p">{`Common Services User Registry`}</em>{`.`}</p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Develop APIs and products`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACE0lEQVQoz21S2Y4SURDtz3SAhOUFYuJvGLb5BuKbMfGFJ33SH3BwDErGmRhGtoaw9b23N+jmWOc2tJhYSaXuUnXq1OIUi0XUajU0Gg1ry+UyqtVqrpVK5b9aKBRwc/MCpVIJxWIB9Zev8LrZhvP23XscDwdMJhMsFgusVisopaC1RhAEOB6PuUZRhINYP4wRhBHiOLZ6kPg4juD7PpxWq40kSTCdTjGfzy2o67pWCe55HsIwwJe7AT5+HgBJhB+jB9x/f8Lj2LXJ6aOEwH6/h3N72wWFjJghU5Of6Uxmg8EAw+EQ3yYpxrMNdts1nn79xsJdwUisvgB2uxkgL1pnpWoB0menTBX2yuDNJ4MPX0O4G4PAaJtMC0OlNIwx/wKSspGe8UOvltC08kZnBnliR89KgDz4RuV9Vurv2QK2Ox2kkm3zPIa3dLF9GGFzfyeND23JTGDO4IeIZz9Pxvdrnwyw1cLJ20PtdogDH7EARbst1HaLowwrTVOcTifLIpTJctoUbgBBk7MPlS1w2s0mwJETSFYglBU4ckDsqWRlAIWDIQtaCt95JzCFSTNAMtzvsJzNsJZVUQKUyD2VJKdzIJ25byGTCiBBuHs8s2Sy5z+t05EeRps15o8/sZtNYZZLGA7FlhjaYDpflvxSnn/ehGshYwtI8a4+E2FE55MEXsqhc7bkYd5DgvZ6PdTrdfT7fVvNHzDeZ8fIt9pAAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 5 1",
        "title": "final 5 1",
        "src": "/tech-academy-apac/static/69ee403b522fb12e63d884620c3afcc1/3cbba/final-5_1.png",
        "srcSet": ["/tech-academy-apac/static/69ee403b522fb12e63d884620c3afcc1/7fc1e/final-5_1.png 288w", "/tech-academy-apac/static/69ee403b522fb12e63d884620c3afcc1/a5df1/final-5_1.png 576w", "/tech-academy-apac/static/69ee403b522fb12e63d884620c3afcc1/3cbba/final-5_1.png 1152w", "/tech-academy-apac/static/69ee403b522fb12e63d884620c3afcc1/26482/final-5_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   And select `}<strong parentName="p">{`JGRMQAPI`}</strong>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWUlEQVQoz6VTy07CQBTtb9ISIchCFn6DCxOCRVm4YuNWVqzc+wEmJvoDEGgCobza6WPogx57RkrQGBJwkpM75972zD23U80wDFzW67hqNFCr1VCpVFCtVo+Cz+i6jlKpBKNcRtnQcVG/xs2tCe2518NmI+H7Pv6z7l6Ap9cU2kPnEVGcwRUhQikRxzGSJFFI03S//w3W9si5CLdYuZKCHWzzE1bCg7NawlmvlXAYhgiCQMVDyF2NoKtiv5EBPOFCM5tNLIZDWJ8fmL6/wRqPMZ/PYds2LMvCbDZTfDKZKDBPMD8ajVT85jYWiyW0+1YL/tTGcjBAwlNz0EaWZftI0KbcjaTIRVGkumMkZ8ea2W6roTqeh4A2D2wcs1uAYymsuy4tm6YSJPFy0XNBUcdxfgoyeSqOChaFU0T43jq/GeR/Wj61u2LxY1H47A6FEEqk2+2qX7bf7yv+BdvQazT03cIHAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 5 2",
        "title": "final 5 2",
        "src": "/tech-academy-apac/static/2f3774efc5f7a8b85d7506cbdbf3858a/3cbba/final-5_2.png",
        "srcSet": ["/tech-academy-apac/static/2f3774efc5f7a8b85d7506cbdbf3858a/7fc1e/final-5_2.png 288w", "/tech-academy-apac/static/2f3774efc5f7a8b85d7506cbdbf3858a/a5df1/final-5_2.png 576w", "/tech-academy-apac/static/2f3774efc5f7a8b85d7506cbdbf3858a/3cbba/final-5_2.png 1152w", "/tech-academy-apac/static/2f3774efc5f7a8b85d7506cbdbf3858a/26482/final-5_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">{`Put your API `}<strong parentName="li">{`online`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABhklEQVQoz5WS7U7CMBSGe5mgKNPxQ+IPL8IQE9ANifcgV0WELFEgbOyz675eew5uQUgQmzw5p236nve0FZ3OJXq9Hvr9PkzTxI1hwLw1YBjHdCl2uxwvWi202210rq5wrbm7f8DgaQjxPp0CqCBlgrIskFdAqHByVM4CweIDmefy3HEcJEnCubBf36C0ShgrRHGMNM0QyxxZljFpqjhGUaTzlHPpbxF8fSLZbqGUgud5WK/XcF0X4vnFQqldKZWjKAp9QCEMfPi+z1UJEpJSciSUFlV5zjHV61VVYT6fYzabQTwOhnxouVxis9nA1dU8TzsIgkaADhz3Xe2luzzXRcRkMuEJtUIbeZ4hDEOG3eiWauG/iPWVCdu2WZBaopHIjN0RJHYuZIjikaAf7QSp2n8Ea8R4PGYhslw7pHapwKGD2sVJQcuyWIgclWXJgvTCq9WqeWnao29DUL7/4oeI0WjUvBCNINoJ0r/yf+6SoDUi2Fs7hIo3DqlNcihVoTfkL1fnQme+ARlJdlTb3RIDAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 6 1",
        "title": "final 6 1",
        "src": "/tech-academy-apac/static/67b0e30fd32dfbf612a138d3d1589509/3cbba/final-6_1.png",
        "srcSet": ["/tech-academy-apac/static/67b0e30fd32dfbf612a138d3d1589509/7fc1e/final-6_1.png 288w", "/tech-academy-apac/static/67b0e30fd32dfbf612a138d3d1589509/a5df1/final-6_1.png 576w", "/tech-academy-apac/static/67b0e30fd32dfbf612a138d3d1589509/3cbba/final-6_1.png 1152w", "/tech-academy-apac/static/67b0e30fd32dfbf612a138d3d1589509/26482/final-6_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABlklEQVQoz5WSzU7CQBSF59E0IQGXogtFkCpseAETYyIL40a0ReI7yMq4IO7YkfAcLFgAwdrf6fTv2DvYBjAgTnIynenc7557Z1i5fIZ6vY5Go4FarYYLRUHtUoGibFb1vIpKuYLiURH5QgEHhTwOj09wdX0D9trtAojBuYsoChHEgCXw50iO4e3jHbl8DqXTEvb399Bs3oJpzy8QCcVyBGzbgSd82K4PzxMQgvbsbPY8D77vy7UXCIxGI/T7fQwGA/R6PQyHQ7DHJxVRkk6IAGEYJgEClmnAMAy4rgvHcSSIcy7nVCJJGEVR5ng2m2E8HoPd3T/IwMlkgvl8jk9dh65/wTTNLHhj2XEsoWSEBjlnnU5HLqgUOhAEPizLkpJOqLwlZ9tE1TBN0ySQSqLhcl+6IxFsV6W9/QU07AWQsv0HmIq1220JSntFDqlcSrDuIHWxFaiqqgSRI2owAemGp9Ppyk3TsyHR9/qNL4u1Wi0JDIJAzqa9ANIzMH56SaI9krm0ty5KnjmkMskhF2Hyg6+42lUU8w3ThGuH4EaIeAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 6 2",
        "title": "final 6 2",
        "src": "/tech-academy-apac/static/7e254cb7439945852bf857baf180758d/3cbba/final-6_2.png",
        "srcSet": ["/tech-academy-apac/static/7e254cb7439945852bf857baf180758d/7fc1e/final-6_2.png 288w", "/tech-academy-apac/static/7e254cb7439945852bf857baf180758d/a5df1/final-6_2.png 576w", "/tech-academy-apac/static/7e254cb7439945852bf857baf180758d/3cbba/final-6_2.png 1152w", "/tech-academy-apac/static/7e254cb7439945852bf857baf180758d/26482/final-6_2.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`Now, let’s try it! Open the `}<strong parentName="li">{`Explorer`}</strong>{` tab.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABhklEQVQoz5WS207CQBCG9zWFgpVyIfHChzDEBBSQ+A7yPgYvSbjgAmqpbbfdQw+/O8shgig6yZ/uIfPNPztljlNHu91Gp9OB53m4cl14LReue0KtltVlswmn7uCiVoPjOGg2Gri+uUX3vgf2MpkAqCBEhrIskFdAonA6lATW73bJNac0G4vFAlmW2TUbPj1DGUqSKnCeQioNnmlIqaCUOUtTKM7hv00RTF8hwzV0kSMVqb2XUiIMQ/i+jyAIwB4eByhNJaVyFEUBrRWSOEIURbZqaoBSCGQGKsxebiE7GKmqKsznc8xmM7C7bs8mLpdLW2FtqoXhB+I43iecCwJS5HkONh6P7UZrbS/yXCNJEqtjJ+dE3bDhcGiBwrRFkQlt3ZEI9leRIfp+A0Z8A6Rq/wHuxEajkQXt3oocUrtU4NjBzsWvwMFgYEHkqCxLC6QJr1arg0lzM2USranYT+/I+v3+fkIUMd8A6b+Ktm9JojNS/OXsWFR875DaJIdCFeZCHLj6qyjnE5yrdh+iiV29AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 7 1",
        "title": "final 7 1",
        "src": "/tech-academy-apac/static/129a2effd6255768585b236f48e01960/3cbba/final-7_1.png",
        "srcSet": ["/tech-academy-apac/static/129a2effd6255768585b236f48e01960/7fc1e/final-7_1.png 288w", "/tech-academy-apac/static/129a2effd6255768585b236f48e01960/a5df1/final-7_1.png 576w", "/tech-academy-apac/static/129a2effd6255768585b236f48e01960/3cbba/final-7_1.png 1152w", "/tech-academy-apac/static/129a2effd6255768585b236f48e01960/26482/final-7_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`Click on `}<strong parentName="li">{`POST /contacts`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABmklEQVQoz4VS20rDQBDNd9bURtMHiw8+6rsIEkIRwW+wXySivvShTUtoapvN/XKcs+1KCykdGGZndvbsmYtl2xcYDocYjUZwXRdXjgP32oHjnNbBYAD7wkav14Nt27js93Fze4enZw/W+2QCoEWapmiaGnULxAXOSlwqtG2rz7PZDErF2rdeXt90MMsyqDhGmhVQaYmyrFDXNZIkQZ6XCMIY4W8udxWqqkSap5JToigKrNeRJkQMy/fHEGryg5KkXB7n+kEYhlgsFuJnqAS4KHafVNVO+Zk5N/K+FY2FkPV4/4Do8wPxzxdaoU1hchRF+hOKKe1QDiPmntVYY9/XjlqtBPQbuQQzYclyTDLLOfS79B/Q8zztbLZbKOnBVmjr8gWETJlswM7JMeBmo4fCPvBCqUT3h4BsNs8cAMHNMIyy77QkcgwoAQIqPdlcN5ssp9Mplssl5vM5giDQ1pwZ59rQPw0o1pTb7KeX7NeCH9GyJWZVWJGpoBOQCVQDupKB8bEpnw+75CQgbaOnxxVt9R6SKdXsYNeUyf4PCkp4WYWAROgAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 8 1",
        "title": "final 8 1",
        "src": "/tech-academy-apac/static/81e36d0faaaf5399a86e1e56cbdeab29/3cbba/final-8_1.png",
        "srcSet": ["/tech-academy-apac/static/81e36d0faaaf5399a86e1e56cbdeab29/7fc1e/final-8_1.png 288w", "/tech-academy-apac/static/81e36d0faaaf5399a86e1e56cbdeab29/a5df1/final-8_1.png 576w", "/tech-academy-apac/static/81e36d0faaaf5399a86e1e56cbdeab29/3cbba/final-8_1.png 1152w", "/tech-academy-apac/static/81e36d0faaaf5399a86e1e56cbdeab29/26482/final-8_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 9
    }}>
      <li parentName="ol">{`Open `}<strong parentName="li">{`Try it`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABl0lEQVQoz4VS7W4aQQy854QjXAo/ivqjzxBVUSskRCv1HcIDVeoDIBQFyn2x97G7d0w8pktRA4qlkb2+83js3SiOh5hOp5jNZphMJrhPEkw+JEiStxiPgx8jHsYYDAaI4xh3oxE+fvqMx29zRE+rFWh1XaPvO3RHoLR41w7O4Hg8arzZbGAOB0gC0fcfPzXZNA2MMeItTO3gnEPXddKokdgjzQ1KyVuJnXeo21r/sdYiTVMVRI5ouVwqIcmqqtKkdxa73Q7b7Rb7/R84KWorKcgLiR289+h8p57o+17VZlmG6OHLV+mQIc9zHER2WZZKboU0zUpVZdZrmN+/4F+er44fRidHtFgs9EB1bdsqqNJ6i6ptTuqlUSZjFdKIRQTVFEWhMT3Xo4Tz+fzMToUEybkfena3f2MnqllIhHF1fDmfFQZCduGol4RcNI1rIGgs5s6u2U1CI4TszBsM6yBOt17rWqj8EqHxTYUkPI9s7VlZaBIu45KQ9dcVmn+PNigkGcFVhG//e32HtwjD2wrfAmkY95pCruMVPmB5K41tggAAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 9 1",
        "title": "final 9 1",
        "src": "/tech-academy-apac/static/67cca0299971a9fba879204160e2810a/3cbba/final-9_1.png",
        "srcSet": ["/tech-academy-apac/static/67cca0299971a9fba879204160e2810a/7fc1e/final-9_1.png 288w", "/tech-academy-apac/static/67cca0299971a9fba879204160e2810a/a5df1/final-9_1.png 576w", "/tech-academy-apac/static/67cca0299971a9fba879204160e2810a/3cbba/final-9_1.png 1152w", "/tech-academy-apac/static/67cca0299971a9fba879204160e2810a/26482/final-9_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 10
    }}>
      <li parentName="ol">{`On the Body section, click `}<strong parentName="li">{`Generate`}</strong>{` to create a request body sample.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABQklEQVQoz5WTS2+CQBSF+Zs8AoRFYxf9IVVpuifu7H9qN23cNN2IvOQlcDpnyJDRaqQ3OZmLOfNxPTMYtm0jCAIsFgu5ep4H3/f/yHVdKfb0WJYF0zThOA5s28LD4xOeVy8wtts3sMqyxOl0kuq6DnoNw4DD4YAkSVBVFW5VXdcwVuErd0hzlmWj8hx930sTV4ovUS9Uv+lica8RhqF8SNMUuQBRRXFE27ZiLaSZPUFq2kspIIcy1uv1BCRgBBbTRCoOmgk+U9NgEDBC7wL7fpiyacTGOI5lRuwnCeigZSiBy+XyBrCfjHp+Z2obdHWFrjz+D8hn/u0pQzZiuuTzC/nHO9qf7xEobsIsIPPSb4E6wCxJ0Wm+2ROyZ36XYobgvPqh3AOqE7xWm80GURRht9thv9+P93AO8JpY/HooRkI/gb9sK3fkkBkd4AAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 10 1",
        "title": "final 10 1",
        "src": "/tech-academy-apac/static/a836ca7c92ce2025d1c2ed6c430f553d/3cbba/final-10_1.png",
        "srcSet": ["/tech-academy-apac/static/a836ca7c92ce2025d1c2ed6c430f553d/7fc1e/final-10_1.png 288w", "/tech-academy-apac/static/a836ca7c92ce2025d1c2ed6c430f553d/a5df1/final-10_1.png 576w", "/tech-academy-apac/static/a836ca7c92ce2025d1c2ed6c430f553d/3cbba/final-10_1.png 1152w", "/tech-academy-apac/static/a836ca7c92ce2025d1c2ed6c430f553d/26482/final-10_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 11
    }}>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Send`}</strong>{`.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRUlEQVQoz52T20rDQBRF85u50JQ+SHwQ/A2bRgU/QIX64KP/IxS0geKlza25T7bZUybUtKWlBzYzk5yz5szORDNNE6PRCI7jyNG2bQyHwx0NBgMpzpljGAZ0XYdlWTBNAxeXV7hxb6FNpy9gpGmKqqqk6rrGdjRNg9VqhSAIkGUZDkWe59Bc754VMjmKoo3iGEIImcSR4iZqQ/VsWwzWap7nyUUYhohbEJUka5Rl2Y6JTOacINVtXwrIprTJZNIBCdgAk64jZQeTCe5LQY8ChWg6b4qiwHK5lB4RwrXSDnA8Hh8Aig4otvzr6ywg1+yuH2XVoBZnAHlM3/exWCzkl+R7Korif1csaK/WSUAWcXe+Y6dK9FBakiaoZu/yrh4FquPsi6fnR9y5D7h253h9+0S5PhG4T8qzn69vzD/av+i3rY1C/AG9EHZmmR3JVAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 11 1",
        "title": "final 11 1",
        "src": "/tech-academy-apac/static/c34447d2193f1ddfa60ebda633a5f869/3cbba/final-11_1.png",
        "srcSet": ["/tech-academy-apac/static/c34447d2193f1ddfa60ebda633a5f869/7fc1e/final-11_1.png 288w", "/tech-academy-apac/static/c34447d2193f1ddfa60ebda633a5f869/a5df1/final-11_1.png 576w", "/tech-academy-apac/static/c34447d2193f1ddfa60ebda633a5f869/3cbba/final-11_1.png 1152w", "/tech-academy-apac/static/c34447d2193f1ddfa60ebda633a5f869/26482/final-11_1.png 1428w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 12
    }}>
      <li parentName="ol">{`If you received 200 response, your request has been processed (success).
`}<em parentName="li">{`Note:`}</em>{` if you receive a CORS issue. Open the URL, accept the risks and try again.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.59722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvElEQVQoz4WS3W7TQBCF/aSJ4sAF1yAk+iRJyJ8QEpflXaiARpGgkuPG7vpnbe/aXgcfzm6bUgsVVvo0O+uZMzPr9S4u3mE2m2G1WjmWy6Wz6/X60W6320c2m407m8/nLm+xWOA9+fDxEy4vP8N7/eYt7Op7PLuUUlBVBU1rjHG0TYNT1/0V6714+Qp1rZHnElJK2px+jdOvHrZGSv/L1RW+X19jt98jPB4RxTFEmiIh1qYZc1jA5nnTqe8qlmWJil1Ya/2+qdGzUFsUkBQo7u4573WWQecZaqLSBEZrFIz1fH86EKw4VsNOs0PA4BxSRMjjI06qcr6xBYktdI9EWxY4ZSnuogjeZDIZdkjBllX7zrg7qduOIynIokZhRdsWDePPtKQ2HQxzREzB8XiMjpc7FMzRM9EuQ+E0ShH8DHAjbhCKA8IkdONVzLF5RVmh5diC1/FfwY6CeZIj+BHg2+1XHJLDn+t5wOYYjvyPDjO2du6wg8wkwn2I3e3OCWqlnxccjUYuaSDIcTqO0MkcTSJQMVDbP0sU9yqOB9jvht8E8Sa+P+jQovme7CNWPHMPmqgHnu6f+g1zhBD4DXwuKPQ+iqY4AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 12 1",
        "title": "final 12 1",
        "src": "/tech-academy-apac/static/8f7a3c1b99d9def85ebff29834ae697a/3cbba/final-12_1.png",
        "srcSet": ["/tech-academy-apac/static/8f7a3c1b99d9def85ebff29834ae697a/7fc1e/final-12_1.png 288w", "/tech-academy-apac/static/8f7a3c1b99d9def85ebff29834ae697a/a5df1/final-12_1.png 576w", "/tech-academy-apac/static/8f7a3c1b99d9def85ebff29834ae697a/3cbba/final-12_1.png 1152w", "/tech-academy-apac/static/8f7a3c1b99d9def85ebff29834ae697a/9aecc/final-12_1.png 1445w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 13
    }}>
      <li parentName="ol">{`Now, let’s check the `}<strong parentName="li">{`Integration Tracing`}</strong>{` page (Operate > Integration Tracing).`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.72222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7ElEQVQoz6WSzY7SUBiGewvIQAkWaMcQxRlj3Ll16U2MVwFsIJmZxIULjTdh3OgaEzYmXAKZkMDOaUl/LLRA/39ez3fGIuNoYuJJ33znNCfP9/Me4eWzp2i32+h0Omg2Gnh1doaL83MMBoO9hsPhHfX7fXS7XfR6Pb6/fP0Gb9+9h9CUFSjHx2gpCqqiiK+TCf5nCU8ePYQiSahXKqhXq/jy+ROQJtjudsjSFK7rYjqdYjabYT6fY7lcQtd1Hg3DgG3bXJ7nIQgCCC9OOnh+8hinzQZOpfuYfPwAJPE+YxCEUFUNmqZxiGVZHLBjCQlCcbvdIoqiG+ADVl271YRcr0OqHGE8HnOQ7/vIsgxxGiGOI+R5jpRVnCQJF+0LFWfqRqiwNo9YuxRL98oYjUYc6DEgQXa+B8fdIc1yRCEDswj6WKSEJIJR5MAaM0Jkolgu/wISjFYcJ7AtF7pmQl/rsB02M9fmbVK7RcthGGKz2UAQfwLF34CUlSpJmEFrawXtm4qFsYD6XYW5Nu8A4zj+ByBugI7t4HpxjSvtigN9z9/D/gqs1f4MjJnjNJuVsYK5MmA65t7dwulbwCozo0KmMJVKpVtAmuN+6HnGjSAdOlyI7nJTWq0WZFnmktgTKp4NZTus4rBFOh+q+EfAHw/pCM7uYG/GAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 13 1",
        "title": "final 13 1",
        "src": "/tech-academy-apac/static/e2f21c972b2cfadda85d6976f9b428c6/3cbba/final-13_1.png",
        "srcSet": ["/tech-academy-apac/static/e2f21c972b2cfadda85d6976f9b428c6/7fc1e/final-13_1.png 288w", "/tech-academy-apac/static/e2f21c972b2cfadda85d6976f9b428c6/a5df1/final-13_1.png 576w", "/tech-academy-apac/static/e2f21c972b2cfadda85d6976f9b428c6/3cbba/final-13_1.png 1152w", "/tech-academy-apac/static/e2f21c972b2cfadda85d6976f9b428c6/9aecc/final-13_1.png 1445w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 14
    }}>
      <li parentName="ol">{`Close the `}<em parentName="li">{`What’s New`}</em>{` dialog.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.375%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACGElEQVQoz3WSSYsaURSFay84gERtjXGRBn+AqOAIIZJNHHaJC1f9ZwLGsQrRRZv2RzRknZUhuFCwErJJehFR4zyPJ3UvlCjdKTjcqlf1vnfuuSX4fD54PB4EAgF4vV643W6+D4VCCIfDXIPB4IV4ze/n70m03+cP4NXrNxBcLhdITqcTqVQKpVIJjUYD3W4Xg8EA8/kcq9UKy+XypM12i1/fvqIsSRAVSVRFEcViAYLNZoPdbodGo0E0GkUul0NbbmM2mzHseDziqetvv8+HFwoFBVTkWlCqYLVaQVCDwYBIJIJkMol6vY7NZoPpdIrD4XCCEFx9Hg6H7CqdTiOTybDIjPDc/gLX1y9hsViQSCT4RbPZ5Hb7iovRaMQit+v1+gSktXK5jHw+zw5JDLRcXXHLRqMR8XicX7TbbQaqMHJDEZy7pfVKpcLfS5LIbqltwWR6BpPJBK1WyxnSYqvVYkeTyUQBTU950kDI5f9aJgkEM5vN0Ol0iMViDJRlmfPr9XoMU6dMdb/fn4A03Ww2y62qegSkUynD4XDEDrfKcKhVddpqJSBNmVqmPWctXwLp1IeH37xpt9/xtNeKs91udwEcj8ecIUEeAUkEjCrAvJLDl/vP+PPjJzrydyzGIyxXaywWC5Y67U6n83SG9A86HA7o9Xq8jcaQzorIfviI9zci3t1I+HR7i1qthru7GldV1WqV8zuHkf4BxOOucByT6EIAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 14 1",
        "title": "final 14 1",
        "src": "/tech-academy-apac/static/b147195e0c680013b88733cbeba93f9e/3cbba/final-14_1.png",
        "srcSet": ["/tech-academy-apac/static/b147195e0c680013b88733cbeba93f9e/7fc1e/final-14_1.png 288w", "/tech-academy-apac/static/b147195e0c680013b88733cbeba93f9e/a5df1/final-14_1.png 576w", "/tech-academy-apac/static/b147195e0c680013b88733cbeba93f9e/3cbba/final-14_1.png 1152w", "/tech-academy-apac/static/b147195e0c680013b88733cbeba93f9e/9aecc/final-14_1.png 1445w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`   Accept the license.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.375%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxklEQVQoz51SQYvaUBCOFxHckwcVWbsorRQ8dg/+C3+AVgUp0puXXrpkjYJnT579W7u3ttgKuiYajSYx8dt8s7wlbbcs9MHHzHtv5puZj9G63S6azSZ6vR5arRYajQY6nY6g3W7L22v4GOV/6n3Gl68DaPV6HUStVsNsNgPP+XxGGIb4n6OVSiVUKhUkEgnoug7H2WM+n2O1WsG2bZxOJ/i+L/Zf8H0PrutJnHZ19QblchnpdBr9fh/T6RSTyURIGbDf77Hb7aJCjvgvgf+0x+MR2tt373F9/QHFYhHj8Vg+SWZZlgSwgyAIXgUlcl0X2uVlUUbOZDIYjUYIwkDGXa/XYlmAgUxQoMZK5/idxbVsNotcLodkMonBYCCPy+VSCE3TFLDb7XYr5NSVVvl8p1XvGskKhQJSqRQMw5D22VmcjOS0f2qmdDscDs/4i5CtW+ZTR8QmImJ1lcjxVbLneb+NLSPHCYfDoewSicLwFHkhgihQia60it9p1V3Whhrm83khpIasun54wK+fJhYLC5vv32BHo+84aky/l0AJZLGr1SouLtLQbw3YLrD4scStcY8b/Q6b+zs40XgM5i4+7aPz7MfBmEc/EBkOn3tCCwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 14 2",
        "title": "final 14 2",
        "src": "/tech-academy-apac/static/767c79cbaccf8657dd8e8187a658cff5/3cbba/final-14_2.png",
        "srcSet": ["/tech-academy-apac/static/767c79cbaccf8657dd8e8187a658cff5/7fc1e/final-14_2.png 288w", "/tech-academy-apac/static/767c79cbaccf8657dd8e8187a658cff5/a5df1/final-14_2.png 576w", "/tech-academy-apac/static/767c79cbaccf8657dd8e8187a658cff5/3cbba/final-14_2.png 1152w", "/tech-academy-apac/static/767c79cbaccf8657dd8e8187a658cff5/9aecc/final-14_2.png 1445w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 15
    }}>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`Traces`}</strong>{` view.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.02777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACDklEQVQoz51SS4sTQRCekwkYWEHMY3YXNDfdXWEvHkTyK9bcYh7kkJsHDwqCj2T17G9wT/4SL+YfeAkoCI5JJjP9mO6e+azqTWIUBLGHoqerur/66qsKhsMhOp0ORqMRer0eut0uBoOB//8X6/f7eETvHz95imfPXyA4O2uj3X6IVquF9xcX4FUUBf53BbXGPo5OTnBtbw9vJxM457BcLv1urd2aMea3865lWba14PTWTdy7cxunN67j3ZtzMLckSaCU2poQwvt43/i01t6U0mufprhEcP/4CA/uEsPKVbx89RqSHkVRtL6stpc3AJnms/QJ4jiGUYKYacSpxiohwP3DQ4QHB7hSKmFCJfPiMv62MkdxlyMmWYRI8elzBGVyH2NZglq1irDRQLlcxng89gEphQ8as9HIeH3YF8XElFAZzDmDDx+/4ss3ASsLGMuAtRrCMLwEnJyDc8VpBqkM0jQho4d57jvPuyXQPHcEqjFfLiBT0lVmJAcn/xOQGDoq53v0w7PiTmekG2u1WCz8AwZm1vP5HIKSFfwVTKNYl7wDuNGQxWcWjsw6SxJIXzInMJTQ0s5JGJgT5MRcKxobTWNTJQ3r9TpKO01ZrVb+stK/xkNStw35JHecwHmE0vTSfCUZxXhsms0mjml0KpWKL5mBeCRyYsIXGYzPrB2fPUsC5OFn5gw8nU4xm808059TeyMvgtnjQgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 15 1",
        "title": "final 15 1",
        "src": "/tech-academy-apac/static/ac93ed0d24a79291d94ebd724ee91264/3cbba/final-15_1.png",
        "srcSet": ["/tech-academy-apac/static/ac93ed0d24a79291d94ebd724ee91264/7fc1e/final-15_1.png 288w", "/tech-academy-apac/static/ac93ed0d24a79291d94ebd724ee91264/a5df1/final-15_1.png 576w", "/tech-academy-apac/static/ac93ed0d24a79291d94ebd724ee91264/3cbba/final-15_1.png 1152w", "/tech-academy-apac/static/ac93ed0d24a79291d94ebd724ee91264/9aecc/final-15_1.png 1445w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 16
    }}>
      <li parentName="ol">{`Select the entry that has all APIC ACE and MQ components in the services column.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.375%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACFElEQVQoz6VSy44SURBlQxgCW958AZqw4Rs08h0scTa4wIAJBIgrY0wkxo+bzSTK0AJNv7tvQx9PlbTJuPUmlap7q+6px6nC/f1bjEYjjMdjTCYTLBYLrNdrlc1mo7JarZ7dc3u1+hO3pv/zl6/YfvuOwqvXbzAcDtHv97HdbvG/p9B78VLBKpUK5vM50jSF4zjwPA9xHCNJEr2LLT6RIIxgTArPDxAEgb5dLheNKXQ6HXS7XZRKJcxmM3UImO/7aou4rqufsizD9XpFQjDRMZNJQnkXMcagUK/X0Wq1UC6XMSdgxsAcUDNTvByQPgVMjOowirSqZ4CNRgPtdhuluztM2XLGOfhhiIDBF6mIEvGT2OITMaxadMwkUqXEyEn5XmgSsMkKa9UqPs3ew3guHGsP17IQnc+InTPO+z1tW30Jqw1OJxhq73CA+8vSmJS+mG9aobRcJSkf301wPR7gHY8IqCUwsm1Yj4/weTckR4D80xExk9n7J5x2OxWHwMHPH3nLLbZcxnQ6ReY6cBnoUSICJ/YJu4cHuE87GFYZs7qAnyMm8NmFz24kRiTk298ZCikf8hmSEBm4sszh26xS2aRP5mVujMckJyER2W2GSkqtVkOz2USxWNS1keOT5ZDE5GsjTIrOKMKuua2NJDH/rk2v18NgMFDQ5XKpgbKssjoSIEAWW5ME2S1BvjbCviQTWwAlwW/GxyaBJObpUwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 16 1",
        "title": "final 16 1",
        "src": "/tech-academy-apac/static/03fa29cca9ae0ac97c2263d2a70fbd95/3cbba/final-16_1.png",
        "srcSet": ["/tech-academy-apac/static/03fa29cca9ae0ac97c2263d2a70fbd95/7fc1e/final-16_1.png 288w", "/tech-academy-apac/static/03fa29cca9ae0ac97c2263d2a70fbd95/a5df1/final-16_1.png 576w", "/tech-academy-apac/static/03fa29cca9ae0ac97c2263d2a70fbd95/3cbba/final-16_1.png 1152w", "/tech-academy-apac/static/03fa29cca9ae0ac97c2263d2a70fbd95/9aecc/final-16_1.png 1445w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <ol {...{
      "start": 17
    }}>
      <li parentName="ol">{`Great, here you should have the integrated trace graph with 10 nodes, including all the demo components.`}</li>
    </ol>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.72222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAACGUlEQVQoz4WSy3ISQRSGZ8NtYWXHLRZFsVSsMk9gnoK4CFc3WFYUy4WaULyI+jjqI7AIkCqNBAaYYa7dc/093QFiNCnPzFfd1T39nz7/GaXRaKBWq6HZbOL4uI56vYFO5wXR2dFqtYnWLdrtNrrdrhyFxstXJ+i9ew+lVnuOo6MaDg+f4dPnLxDBOZd4nie5K+I4xnA4/GddefT4CQ4OniKTyWAwGMjFxWKB1WoFTdMkjDH4vo84imhXEIMzB9+/fYXvcQS0JxKLb5RSqYRyuYxEIoF+vy8FXSEQBHRscxsiJLFLVcfocoWpzjAj6KXRBROV0PecRiWbzaJQKCCZTOLs9FQKGNoav37+wFJVoRHMtsEJc21grZtwHQ6H+ZTYh2bZWBomVF2DYZlQcrkcisUikuk0Prw+AVPnmI7OMZuMcTUZyfmc5vOLCTHGbDyCOj6Hu1wgCANZ5rZkwY1gKoWz3pvrpvjBxilyjMwPCfGEcQSfSg88H9Z8Bt0wYNgMjBoohMMw/EvwbW/XwW32bXg8QhhsXI0oIZV34/B13CuoWRyWy8gnD7YdwGQu+cNguxyGWFtzRKaxSy64LSiakkrvBBmnQyRoOi7dMoRHN7Wo89wnn8gOZrsISTC+SzCfz+Ph/j4SosvbkvG/iO8vuVKpoFqt4sHeHj6KprgOzKspHDLdoY7L8U9ozaZ9ruvy3wzo/xMIMdHl3w7mHSNVIEciAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "final 17 1",
        "title": "final 17 1",
        "src": "/tech-academy-apac/static/17bd353104eb5849cd3275a647803a6d/3cbba/final-17_1.png",
        "srcSet": ["/tech-academy-apac/static/17bd353104eb5849cd3275a647803a6d/7fc1e/final-17_1.png 288w", "/tech-academy-apac/static/17bd353104eb5849cd3275a647803a6d/a5df1/final-17_1.png 576w", "/tech-academy-apac/static/17bd353104eb5849cd3275a647803a6d/3cbba/final-17_1.png 1152w", "/tech-academy-apac/static/17bd353104eb5849cd3275a647803a6d/9aecc/final-17_1.png 1445w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`Summary`}</h2>
    <p>{`You have successfully completed this lab. In this lab you learned:`}</p>
    <ul>
      <li parentName="ul">{`the IBM opinionated point of view regarding a GitOps centric method to manage RHOCP infrastructure, IBM integration software and application workload code (three tier GitOps architecture).`}</li>
      <li parentName="ul">{`how to develop, review, and extend an IBM GitOps automation repository that incapsulate key software components within the IBM Integration portfolio.`}</li>
      <li parentName="ul">{`how to position a GitOps automation framework as a key boot-strapping and operational mechanism supporting a Client PoC activity and Client adoption.`}</li>
    </ul>
    <p>{`Check `}<a href="https://youtu.be/oTrtd9eKU8E" target="blank">{`this video`}</a>{` later, if you want to learn how to deliver a demo using this demo environment.`}</p>
    <p>{`So far we have focused on the “runtime” aspect of the deployment, but to provide a full demo experience, in some cases you will need to walk a customer through the assets that make up the demo scenario. If you want to have the developer experience in your demo/POC, check `}<a href="https://github.ibm.com/joel-gomez/cp4i-demo#developer-experience" target="_blank">{`here`}</a>{` how to do it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      